<!-- HTML模板 -->
<template>
  <!--创建合同-->
  <el-container class="to-create">
    <!--第一步-->
    <template v-if="!nextstep">
      <!--左侧-->
      <el-aside
        width="2.80rem"
        class="aside-left"
        :style="{ height: boxHeight }"
      >
        <p class="page-total">
          共{{ contractInfo.items }}页
          <a
            href="javascript: void(0)"
            @click="
              apiMethods.FileOperController.download_down({
                targetId: contractInfo.contractId,
                fileType: fileType,
                sign: contractInfo.sign,
                ts: contractInfo.ts,
                fix: '.pdf',
              })
            "
            class="fr color-success cred"
            >下载</a
          >
        </p>
        <div class="page-con">
          <template v-for="i in contractInfo.items">
            <div
              @click="getContractDetailByNum(i)"
              :key="i"
              :class="currentInfo.page === i ? 'active' : ''"
              class="list"
            >
              <img v-if="contractList[i]" :src="contractList[i].url" />
              <img v-else src="/images/contr_default.jpg" alt="" />
              <span>{{ i }}</span>
            </div>
          </template>
        </div>
        <div class="go-Page">
          <div>
            <div>
              <div class="bd">
                <el-input
                  v-model="goPageNum"
                  placeholder="输入页码"
                  type="number"
                  @keyup.enter.native="handleContractPageClick"
                />
                /{{ contractInfo.items }}
              </div>
              <a @click="handleContractPageClick">GO</a>
            </div>
          </div>
        </div>
      </el-aside>
      <!--合同显示详情-->
      <el-main class="main-content" :style="{ height: boxHeight }">
        <contract-view
          ref="contractView"
          :contract-info.sync="currentInfo"
          :chapter-list.sync="chapteJson"
          :items="contractInfo.items"
          :page="currentInfo.page"
          :scaleValue.sync="scaleValue"
          :show-chapter="true"
          @del-chapte="delChapteByCindex($event)"
          @pre-page="getContractDetailByNum($event)"
          @next-page="getContractDetailByNum($event)"
          @changeSmallMap="changeSmallMap"
          @toCurrentPage="toCurrentPage"
        />
        <!--添加附件-->
        <div ref="accessory" class="text-center accessory-box">
          <!-- 去顶部去底部按钮-->
          <template
            v-if="contractInfo && contractInfo.items && contractInfo.items > 1"
          >
            <span class="jumpFirst" @click="goPageAndFixed(1)"
              ><img src="../../assets/images/btn-down.png"
            /></span>
            <span class="jumpLast" @click="goPageAndFixed(contractInfo.items)"
              ><img src="../../assets/images/btn-down.png"
            /></span>
          </template>
          <div
            @click="accessoryShow = !accessoryShow"
            class="text-center btn"
            ref="step4"
          >
            <i class="el-icon-circle-plus"></i>
            附属材料<i
              v-if="accessoryShow"
              class="el-icon-arrow-down arrow"
            ></i>
            <i v-else class="el-icon-arrow-up arrow"></i>
          </div>
          <ul class="text-left accessory-list" id="accessoryList">
            <span
              style="
                position: absolute;
                top: 10px;
                left: 15px;
                color: rgba(0, 0, 0, 0.65);
                font-size: 12px;
              "
              ><img
                style="
                  width: 8px;
                  height: 8px;
                  margin-right: 3px;
                  vertical-align: middle;
                "
                src="../../assets/images/x-icon.png"
              />仅供参与方查阅，不用于签署(限图片，视频，文档，压缩包文件)</span
            >
            <li class="accessory-group">
              <template v-if="attatchFileNamesJson.length">
                <p
                  v-for="(item, i) in attatchFileNamesJson"
                  class="list-item"
                  :key="i"
                >
                  <span>{{ item.origiName }}</span>
                  <i
                    @click="delAttatchFileNamesJson(item)"
                    class="el-icon-error del"
                  ></i>
                </p>
              </template>
              <div class="title upload-accessory">
                <!--              <a href="javascript:void (0)" class="color-success"><img class="up-icon" src="../../assets/images/up-icon.png"/>上传附属文件</a>-->
                <div class="div-upload">+</div>
                <input
                  class="input-upload"
                  @change="handleAttatchFileUpload"
                  type="file"
                  name="attatchInput"
                />
              </div>
            </li>
          </ul>
        </div>
      </el-main>
      <!--右侧-->
      <el-aside
        width="2.80rem"
        class="aside-right"
        :style="{ height: boxHeight }"
      >
        <div class="qs-wrap">
          <p class="m-title"><span class="icon-1">1</span>添加签署方</p>
          <div class="qs-box">
            <!--            <img v-if="!gifClick" @click="()=>{addSignerList();gifClick=true;}" class="xiyibu csCursor" src="../../assets/images/xiyibu.gif"-->
            <!--                 ref="step1" id="step1"/>-->
            <div style="padding: 0 25px">
              <el-button
                @click="addSignerList"
                size="small"
                type="danger"
                class="btn danger-btn mybtn"
                ref="step1"
                id="step1"
                style="z-index: 1000; position: relative"
                ><i class="el-icon-circle-plus"></i>签署方
                <span class="an-gif" v-if="!gifClick">
                  <img
                    class="mygif"
                    src="../../assets/images/cursor.png"
                  /><span class="dot"></span>
                </span>
              </el-button>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin: 0 25px;
              "
            >
              <el-checkbox v-model="checkedBatch" @change="changeCheckedBatch">
                批量签署方
              </el-checkbox>
              <el-tooltip effect="light" placement="bottom-end">
                <div slot="content">
                  将相同内容的文件<br />（如：学校放假通知书、<br />安全告知函等）<br />同时发给不同签署方，<br />各个签署方分别各自签署。
                </div>
                <i
                  class="el-icon-question"
                  style="
                    font-size: 16px;
                    margin-left: 10px;
                    color: #a1a1a1;
                    cursor: pointer;
                  "
                ></i>
              </el-tooltip>
            </div>
          </div>
        </div>

        <!--签署方列表-->
        <!-- <div class="list-signers" :style="{maxHeight: listHeight}"> -->
        <div class="list-signers">
          <p class="t2"><span class="icon-1">2</span>设置签章位置</p>
          <p class="t3">在签署页，拖动签章位置到需要盖章的地方</p>
          <div class="qy-wrap">
            <template v-if="signatoryJson">
              <template v-for="(item, index) in signatoryJson">
                <!-- 批量签署方 -->
                <template v-if="item.signOwner === '批量签署方'">
                  <div :key="item.signOwner" style="margin-top: 18px">
                    <p class="user-show">
                      <i
                        @click="delSignList(item)"
                        class="el-icon-error del-signer"
                      ></i>
                    </p>
                    <div class="row-wrap">
                      <div
                        class="dragbox"
                        draggable="true"
                        @dragend="dragQZEnd($event, item.signOwner)"
                      >
                        <el-button
                          draggable="true"
                          @click="handleAddChapter(item.signOwner)"
                          size="small"
                          title="点击或拖拽"
                          class="normal-btn"
                        >
                          <span class="rt" style="width: 90px">批量签署方</span
                          >{{ item.signOwner }}
                        </el-button>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- 普通签署方 -->
                <template v-else>
                  <el-button-group :key="item.signOwner" class="btn-group">
                    <p class="user-show">
                      <i
                        @click="delSignList(item)"
                        class="el-icon-error del-signer"
                      ></i>
                      <span
                        v-if="item.signatoryFullName"
                        :title="item.signatoryFullName"
                        class="font-ellipsis"
                        >{{ item.signatoryFullName }}</span
                      >
                    </p>
                    <div class="row-wrap">
                      <tool-tip
                        placement="left"
                        :offset="-70"
                        @hide="handleHide(item, index)"
                        @show="handleShow(item, index)"
                        :show-toggle.sync="item.openUserTab"
                        width="260"
                        trigger="click"
                      >
                        <singer-form
                          ref="referenceSignerForm"
                          :index.sync="index"
                          @amendSign="handleTargetIdChange"
                          @handleSelectCorpAccount="handleSelectCorpAccount"
                          @qsNameChange="
                            (itemInfo) => {
                              changeQSNameInQZ(
                                itemInfo.signOwner,
                                itemInfo.signatoryFullName
                              );
                            }
                          "
                          @targetBlur="getUserInfoBySelectTargetId"
                          @telsClick="handleTelsClick"
                          :signatory.sync="item"
                          @closeToolTip="handleHide"
                        />
                        <el-button
                          slot="reference"
                          size="small"
                          class="btn-left edit-Btn-wrap"
                          ref="step2"
                        >
                          <!-- <i v-if="item.openUserTab" class="el-icon-arrow-right"></i>
                          <i v-else class="el-icon-arrow-left"></i> -->
                          <template v-if="item.openUserTab">
                            <!-- 收起 -->
                            <i class="edit-active-icon"></i>
                          </template>
                          <template v-else>
                            <!-- 编辑 -->
                            <i class="edit-icon"></i>
                          </template>
                        </el-button>
                      </tool-tip>
                      <div
                        class="dragbox"
                        draggable="true"
                        @dragend="
                          dragQZEnd(
                            $event,
                            item.signOwner,
                            item.signatoryFullName
                          )
                        "
                      >
                        <el-button
                          @click="
                            handleAddChapter(
                              item.signOwner,
                              item.signatoryFullName
                            )
                          "
                          size="small"
                          draggable="true"
                          class="btn-right normal-btn"
                          ref="step3"
                          title="点击或拖拽"
                          ><span class="rt">{{ item.signOwner }}</span
                          >设置签章位置
                        </el-button>
                      </div>
                    </div>
                  </el-button-group>
                </template>
              </template>
              <!--              <p style="color: #999;font-size: 12px;padding-right: 20px;margin-top:40px;">1、点击“添加签署方”，可增加签署方。</p>-->
              <!--              <p style="color: #999;font-size: 12px;padding-right: 20px">2、翻动到需要签章的文件页，点击对应签署方，可拖动限定该方的签署位置。</p>-->
            </template>
          </div>
        </div>

        <div class="right-bottom">
          <el-button
            @click="goNextStep"
            type="danger"
            size="small"
            class="danger-btn"
            style="z-index: 1000; position: relative"
            >下一步
          </el-button>
        </div>
      </el-aside>
    </template>
    <!--第二步-->
    <template v-else>
      <el-main v-loading="batchLoading" class="cont-info-form">
        <el-form
          size="small"
          ref="contForm"
          :model="contractInfo"
          class="cont-form"
          :rules="contractNameRules"
          label-width="160px"
        >
          <div class="f-top">
            <h4><i></i>基础设置</h4>
            <el-form-item style="margin: 10px 0" prop="contractName" label="文件名称">
              <el-input
                style="width: 260px"
                v-model="contractInfo.contractName"
                placeholder="请输入文件名称"
                @blur="validContractName"
              />
            </el-form-item>

            <el-form-item style="margin: 10px 0" prop="contractName" label="签署链接有效期">
              <div slot="label">
                <span>签署链接有效期 &nbsp;</span>
                <el-tooltip effect="light" placement="bottom-end">
                  <div slot="content">
                    在指定日期之后，签署方若未完成文件签署，
                    <br />签署方接收到的签署 “ 短信/邮件 ” 链接
                    <br />将失效
                  </div>
                  <i
                    class="el-icon-question"
                    style="
                              font-size: 16px;
                              cursor: pointer;
                              color: #a1a1a1;
                            "
                  ></i>
                </el-tooltip>
              </div>
              <!--864需求新增-->
              <el-date-picker
                style="width: 260px"
                class="datep"
                v-model="signlinktime"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                @change="pickTime"
                :clearable="clearable"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>

            <div class="card-box">
              <div class="enclosure_files">
                附属材料&nbsp;&nbsp;
                <span>
                        <el-tooltip effect="light" placement="bottom-end">
                          <div slot="content">附属材料仅供参与方查阅，不用于签署</div>
                          <i
                            class="el-icon-question"
                            style="
                              display: inline-block;
                              font-size: 16px;
                              cursor: pointer;
                              color: #a1a1a1;
                            "
                          ></i>
                        </el-tooltip>
                      </span>
                <span
                  style="font-size: 12px; margin: 0 12px"
                >{{ attatchFileNamesJson.length }}/30</span>
                <el-upload
                  action="#"
                  multiple
                  :show-file-list="false"
                  :file-list="attatchFileNamesJson"
                  :before-upload="handleAttatchFileUploadNew"
                  :limit="30"
                  :on-exceed="enclosureFilesHandleExceed"
                  :on-error="enclosureFilesError"
                >
                  <el-button icon="el-icon-plus" size="small"></el-button>
                </el-upload>
                <div
                  class="enclosureFiles-item"
                  v-for="(item, index) in attatchFileNamesJson"
                  :key="index"
                >
                  <div class="desc">{{ item.origiName }}</div>
                  <span class="el-icon-error del-btn" @click="delAttatchFileNamesJson(item)"></span>
                </div>
              </div>
            </div>
          </div>

          <div class="f-center">
            <div class="h4">
              <i></i>签署设置
              <div class="wp">
                <div class="radio">
                  <div
                    @click="showMoreSet = !showMoreSet"
                    class="more-set"
                    style="margin-left: 30px"
                  >
                    {{ !showMoreSet ? "我的偏好>>" : "收起<<" }}
                  </div>
                  <div v-show="showMoreSet">
                    <el-tooltip effect="light" placement="bottom-end">
                      <div slot="content">
                        测试签约流程时，可关闭数字证书，正式签<br />
                        署时带数字证书可进一步保障签约有效性。
                      </div>
                      <el-checkbox
                        v-model="contractInfo.serverCa"
                        @change="handleChangeCa('serverCa')"
                        :disabled="contractInfo.consumMode == 1"
                        :true-label="1"
                        :false-label="0"
                      >
                        数字证书<i
                        class="el-icon-question"
                        style="
                              font-size: 16px;
                              margin-left: 10px;
                              color: #a1a1a1;
                            "
                      ></i>
                      </el-checkbox>
                    </el-tooltip>
                    <el-checkbox
                      v-model="contractInfo.needPresSign"
                      :true-label="1"
                      :false-label="0"
                    >
                      保全章
                    </el-checkbox>
                    <el-checkbox
                      v-model="qiFengSign.enterpriseSign"
                      :true-label="1"
                      :false-label="0"
                      @change="qifengChange"
                    >
                      企业骑缝章
                    </el-checkbox>
                    <el-checkbox
                      v-model="qiFengSign.personSign"
                      :true-label="1"
                      :false-label="0"
                      @change="qifengChange"
                    >
                      个人骑缝章
                    </el-checkbox>


                    <!-- 个人图形章 -->
                    <el-checkbox
                      v-model="personImgSign"
                      :true-label="1"
                      :false-label="0"
                    >个人仅可使用图形章</el-checkbox>
                    <!-- 签章时间 -->
                    <el-checkbox
                      v-model="contractInfo.hideSignDate"
                      :true-label="1"
                      :false-label="0"
                    >签章时间</el-checkbox>
                    <el-checkbox v-model="waterConfig.switch">文件水印&nbsp;</el-checkbox>
                    <i
                      class="el-icon-setting"
                      style="cursor: pointer;"
                      @click="setWatermarkVisible = true"
                    ></i>
                    <div style="display: inline-block; line-height: 20px; border: 1px solid #888888; border-radius: 4px; padding: 4px 10px;" v-if="!isInDingTalk" class="prtf-sty" @click="turnPref">偏好设置</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 导入批量签署人文件 -->
            <input
              style="display: none; width: 0; height: 0; visibility: hidden"
              ref="importBatchFile"
              type="file"
              @change="batchFileChange()"
            />
            <div style="padding: 10px 0 0 20px;">
              <div ref="step5">
                <el-checkbox v-model="contractInfo.ifOrder"
                ><b>按顺序签名</b>
                  <small>/各方按顺序完成签署</small>
                </el-checkbox>
              </div>
            </div>
            <div class="tab">
              <div
                v-if="signatoryJson && signatoryJson.length"
                class="list-box"
              >
                <draggable
                  :list="signatoryJson"
                  @start="dragging = true"
                  @end="dragging = false"
                  :options="{
                      handle: '.icon-move_box',
                      animation: 200,
                      ghostClass: 'ghost',
                    }"
                  :move="
                      () => {
                        return this.contractInfo.ifOrder;
                      }
                    "
                >
                  <transition-group type="transition">
                    <template v-for="(item, i) in signatoryJson">
                      <!-- 批量签署方 -->
                      <li v-if="item.signOwner === '批量签署方'" :key="i">
                        <!-- 1px solid #fce7e7; -->
                        <div
                          style="
                              height: 40px;
                              line-height: 40px;
                              background: #f2f2f2;
                              padding-right: 10px;
                            "
                          class="sign-item"
                        >
                          <div
                            v-show="contractInfo.ifOrder"
                            class="icon-move_box"
                          >
                            <i></i>
                          </div>
                          <div
                            v-show="contractInfo.ifOrder"
                            style="width: 26px; text-align: right"
                          >
                            {{ i + 1 }}
                          </div>
                          <span class="user-type"
                          >批量签署方
                              <span
                                style="
                                  color: rgba(0, 0, 0, 0.45);
                                  font-size: 12px;
                                  margin-left: 5px;
                                "
                              >/上限100人</span
                              >
                            </span>
                          <span
                            style="rgba(0,0,0,0.85);font-size:14px;margin:0 50px 0 30px;"
                          >当前：{{ batchArray.length }}人</span
                          >
                          <el-button
                            @click="downloadTemplate()"
                            size="small"
                            class="c-btn"
                          >下载批量模板</el-button
                          >
                          <el-button
                            @click="batchImport()"
                            size="small"
                            class="c-btn"
                          >导入签署方</el-button
                          >
                          <div style="float: right">
                            <el-button
                              @click="batchAdd()"
                              size="small"
                              class="y-btn"
                            >添加</el-button
                            >
                            <el-button
                              @click="batchClearAll()"
                              size="small"
                              class="y-btn"
                            >全部清空</el-button
                            >
                          </div>
                        </div>
                        <!-- 批量签署方列表 -->
                        <!-- ref="contractListTab" 这是填充批量的 不然数组下标对不上就会报错 -->
                        <el-row
                          ref="contractListTab"
                          style="
                              max-height: 850px;
                              overflow: auto;
                              padding-bottom: 10px;
                            "
                        >
                          <template v-for="(t, m) in batchArray">
                            <el-form
                              :key="m"
                              :model="t"
                              size="small"
                              ref="contractBatchListTab"
                            >
                              <div
                                :class="{
                                    item: true,
                                    'sign-item': true,
                                    'i-drag': contractInfo.ifOrder,
                                  }"
                                style="padding-left: 10px"
                              >
                                <div class="col" style="width: 70px">
                                  <el-form-item>
                                    <el-select
                                      @change="handleSignBatchUserType(t, m)"
                                      v-model="t.signatoryUserType"
                                      size="small"
                                      class="select"
                                      style="width: 70px"
                                    >
                                      <el-option :value="0" label="个人" />
                                      <el-option :value="1" label="企业" />
                                    </el-select>
                                  </el-form-item>
                                </div>
                                <div class="col" style="width: 230px">
                                  <el-form-item
                                    prop="emailOrPhone"
                                    :rules="
                                        t.signatoryUserType == 1
                                          ? rulesTab.emailOrPhone
                                          : rulesTab.mobile
                                      "
                                  >
                                    <el-input
                                      ref="batchInputEmailOrPhone"
                                      style="width: 230px"
                                      @blur="
                                          getBatchUserInfoBySelectTargetId(
                                            t.emailOrPhone,
                                            m
                                          )
                                        "
                                      v-model="t.emailOrPhone"
                                      :placeholder="
                                          item.signatoryUserType == 1
                                            ? '签署方接收手机号或邮箱'
                                            : '签署方接收手机号'
                                        "
                                    />
                                  </el-form-item>
                                </div>

                                <div class="col" style="width: 230px">
                                  <!-- 下拉选择框 -->
                                  <template
                                    v-if="
                                        t.canSelectArray &&
                                        t.canSelectArray.length > 1
                                      "
                                  >
                                    <el-form-item>
                                      <el-select
                                        @change="
                                            handleSelectCorpAccount($event, t)
                                          "
                                        v-model="t.canSelectArrayIndex"
                                        style="width: 230px"
                                        size="small"
                                        class="select"
                                      >
                                        <el-option
                                          :value="vi2"
                                          :label="v2.name"
                                          v-for="(
                                              v2, vi2
                                            ) in t.canSelectArray"
                                          :key="vi2"
                                        />
                                      </el-select>
                                    </el-form-item>
                                  </template>
                                  <template v-else>
                                    <el-form-item
                                      prop="signatoryFullName"
                                      :rules="rulesTab.signatoryFullName"
                                      :show-message="
                                          t.disabled !== 'disabled'
                                        "
                                    >
                                      <el-input
                                        v-model="t.signatoryFullName"
                                        :disabled="t.disabled === 'disabled'"
                                        style="width: 230px"
                                        placeholder="请输入签署方名称"
                                      />
                                    </el-form-item>
                                  </template>
                                </div>

                                <!-- 身份证 和 营业执照号 -->
                                <div
                                  v-if="t.signatoryUserType === 0"
                                  class="col"
                                >
                                  <!-- 身份证 -->
                                  <el-form-item
                                    v-if="t.signatoryUserType === 0"
                                    prop="IDCard"
                                    :rules="
                                        t.disabled !== 'disabled'
                                          ? rulesTab.IDCard
                                          : {}
                                      "
                                    :show-message="t.disabled !== 'disabled'"
                                    style="position: relative"
                                  >
                                    <el-input
                                      v-model="t.IDCard"
                                      :disabled="t.disabled === 'disabled'"
                                      :class="{
                                          'no-padding': t.disabled
                                            ? true
                                            : false,
                                        }"
                                      placeholder="请输入中国大陆18位身份证号码"
                                    />
                                    <!-- <a @click="handleTargetIdChange(t)" v-if="t.ischange === 1" href="javascript:void (0)"
                                      class="color-success amend-signator amend-tab__form">修改</a> -->
                                  </el-form-item>
                                </div>

                                <div
                                  class="col notice-warp"
                                  style="width: 150px"
                                >
                                  <el-button
                                    icon="el-icon-plus"
                                    v-if="
                                        t.isNoticePhone && !t.showNoticePhone
                                      "
                                    @click="changBatchUserShowNoticePhone(m)"
                                  ></el-button>
                                  <el-form-item
                                    prop="alertMobile"
                                    :rules="rulesTab.mobile"
                                    v-if="t.showNoticePhone"
                                  >
                                    <el-input
                                      v-model="t.alertMobile"
                                      placeholder="请输入通知手机号"
                                    />
                                    <span class="g-icon-close">
                                        <img
                                          class="icon icon1"
                                          src="/images/icon/icon_close.png"
                                          @click="
                                            changBatchUserShowNoticePhone(m)
                                          "
                                        />
                                        <img
                                          class="icon icon2"
                                          src="/images/icon/icon_colse_hover.png"
                                          @click="
                                            changBatchUserShowNoticePhone(m)
                                          "
                                        />
                                      </span>
                                  </el-form-item>
                                </div>
                                <!--<el-col :span="3" class="col">-->
                                <!--<el-form-item>-->
                                <!--<el-select v-if="t.signatoryUserType === 1 && t.corpUser" v-model="t.handSign" size="small" class="select">-->
                                <!--<el-option :value="0" label="图形章"/>-->
                                <!--<el-option style="display:none;" :value="0" label="图形章"/>-->
                                <!--</el-select>-->
                                <!--<el-select v-if="t.signatoryUserType === 1 && !t.corpUser" v-model="t.handSign" size="small" class="select">-->
                                <!--<el-option :value="1" label="图形章"/>-->
                                <!--<el-option :value="2" label="图形章+手写"/>-->
                                <!--</el-select>-->
                                <!--<el-select v-if="t.signatoryUserType === 0" v-model="t.handSign" size="small" class="select">-->
                                <!--<el-option :value="0" label="标准图形章"/>-->
                                <!--<el-option :value="1" label="手写"/>-->
                                <!--</el-select>-->
                                <!--</el-form-item>-->
                                <!--</el-col>-->
                                <div
                                  class="col"
                                  style="
                                      width: 190px;
                                      margin-right: 0;
                                      padding-right: 26px;
                                      flex: auto;
                                      text-align: right;
                                    "
                                >
                                  <!--<el-form-item>-->
                                  <!--<el-select v-model="t.authLevel" size="small" class="select">-->
                                  <!--<el-option :value="null" label="无验证方式"/>-->
                                  <!--<el-option :value="2" label="银行卡四要素认证"/>-->
                                  <!--<el-option :value="10" label="银行卡三要素认证"/>-->
                                  <!--<el-option :value="11" label="公安部人脸识别"/>-->
                                  <!--</el-select>-->
                                  <!--</el-form-item>-->
                                  <el-checkbox
                                    v-model="t.authLevel"
                                    :true-label="11"
                                    style="margin: 0"
                                    :false-label="null"
                                    @change="authLevelChange(m)"
                                  >
                                    需要人脸识别
                                  </el-checkbox>
                                  <el-tooltip
                                    effect="light"
                                    content=""
                                    placement="bottom-end"
                                  >
                                    <div slot="content">
                                      选择人脸识别，可把签署方的<br />人脸视频文件作为签署证据
                                    </div>
                                    <i
                                      class="el-icon-question"
                                      style="
                                          font-size: 16px;
                                          margin-left: 10px;
                                          color: #a1a1a1;
                                          cursor: pointer;
                                        "
                                    ></i>
                                  </el-tooltip>
                                </div>

                                <div
                                  :span="t.signatoryUserType === 0 ? 3 : 7"
                                  class="col"
                                  style="flex: none"
                                >
                                  <el-form-item
                                    style="
                                        text-align: right;
                                        line-height: 50px;
                                        margin: 10px 0 10px 0;
                                      "
                                  >
                                    <el-button @click="batchClear(m)"
                                    >删除</el-button
                                    >
                                  </el-form-item>
                                </div>
                              </div>
                            </el-form>
                          </template>
                        </el-row>
                      </li>

                      <!-- 正常签署方 -->
                      <li v-else :key="i">
                        <el-form
                          :model="item"
                          size="small"
                          ref="contractListTab"
                          :key="i"
                          :data-signOwner="item.signOwner"
                          class="contract-lit__tab"
                        >
                          <div
                            :class="{
                                item: true,
                                'sign-item': true,
                                'i-drag': contractInfo.ifOrder,
                              }"
                          >
                            <div
                              v-show="contractInfo.ifOrder"
                              class="icon-move_box"
                            >
                              <i></i>
                            </div>
                            <div
                              v-show="contractInfo.ifOrder"
                              style="width: 26px; text-align: right"
                            >
                              {{ i + 1 }}
                            </div>
                            <div class="user-type">
                              <p>{{ item.signOwner }}</p>
                            </div>
                            <div class="col" style="width: 70px">
                              <el-form-item>
                                <el-select
                                  @change="handleSignUserType(item, i)"
                                  v-model="item.signatoryUserType"
                                  size="small"
                                  class="select"
                                  style="width: 70px"
                                >
                                  <el-option :value="0" label="个人" />
                                  <el-option :value="1" label="企业" />
                                </el-select>
                              </el-form-item>
                            </div>

                            <div class="col" style="width: 230px">
                              <el-form-item
                                prop="emailOrPhone"
                                :rules="
                                    item.signatoryUserType == 1
                                      ? rulesTab.emailOrPhone
                                      : rulesTab.mobile
                                  "
                              >
                                <el-input
                                  @blur="
                                      () => {
                                        (item.emailOrPhone = $utils.trim(
                                          item.emailOrPhone
                                        )),
                                          getUserInfoBySelectTargetId(
                                            item.emailOrPhone,
                                            i
                                          );
                                      }
                                    "
                                  style="width: 230px"
                                  v-model="item.emailOrPhone"
                                  :placeholder="
                                      item.signatoryUserType == 1
                                        ? '签署方接收手机号或邮箱'
                                        : '签署方接收手机号'
                                    "
                                >
                                  <i
                                    class="icon icon-btn_tels"
                                    style="
                                        background-size: contain;
                                        cursor: pointer;
                                      "
                                    slot="suffix"
                                    @click="handleTelsClickOther(item, i)"
                                  ></i>
                                </el-input>
                              </el-form-item>
                            </div>

                            <div class="col" style="width: 230px">
                              <!-- 下拉选择框 -->
                              <!--企业的时候才有手动输入，个人的时候是个人的修改方式-->
                              <template
                                v-if="
                                    item.canSelectArray &&
                                    ((+item.signatoryUserType === 1 &&
                                      item.canSelectArray.length > 0 &&
                                      !item.ManualInput) ||
                                      (+item.signatoryUserType === 0 &&
                                        item.canSelectArray.length > 1))
                                  "
                              >
                                <el-form-item>
                                  <el-select
                                    @change="
                                        handleSelectCorpAccount($event, item)
                                      "
                                    v-model="item.canSelectArrayIndex"
                                    size="small"
                                    class="select"
                                    style="width: 230px"
                                  >
                                    <el-option
                                      :value="vi"
                                      :label="v.name"
                                      v-for="(v, vi) in item.canSelectArray"
                                      :key="vi"
                                    />

                                    <!--手动输入，选择此项显示输入框，手动输入-->
                                    <el-option
                                      v-if="item.signatoryUserType === 1"
                                      value="ManualInput"
                                      label="手动输入"
                                    />
                                  </el-select>
                                </el-form-item>
                              </template>
                              <template v-else>
                                <el-form-item
                                  prop="signatoryFullName"
                                  :rules="rulesTab.signatoryFullName"
                                  :show-message="item.disabled !== 'disabled'"
                                >
                                  <el-input
                                    :value="item.signatoryFullName"
                                    @input="
                                        (val) => {
                                          item.signatoryFullName = val;
                                          changeQSNameInQZ(item.signOwner, val);
                                        }
                                      "
                                    :disabled="item.disabled === 'disabled'"
                                    style="width: 230px"
                                    :placeholder="
                                        item.signatoryUserType === 0
                                          ? '请输入签署方姓名'
                                          : '请输入签署方公司名称'
                                      "
                                  />
                                </el-form-item>
                              </template>
                            </div>

                            <!-- 身份证 和 营业执照号 -->
                            <div
                              v-if="item.signatoryUserType === 0"
                              class="col"
                              style="width: 190px"
                            >
                              <!-- 身份证 -->
                              <el-form-item
                                v-if="
                                    item.signatoryUserType === 0 && !contractInfo.serverCa
                                  "
                                prop="IDCard"
                                :rules="
                                    item.disabled !== 'disabled'
                                      ? rulesTab.IDCard
                                      : {}
                                  "
                                :show-message="item.disabled !== 'disabled'"
                                style="position: relative"
                              >
                                <el-input
                                  v-model="item.IDCard"
                                  :disabled="item.disabled === 'disabled'"
                                  :class="{
                                      'no-padding': item.disabled
                                        ? true
                                        : false,
                                    }"
                                  placeholder="请输入中国大陆18位身份证号码"
                                />
                                <a
                                  @click="handleTargetIdChange(item)"
                                  v-if="item.ischange === 1"
                                  href="javascript:void (0)"
                                  class="color-success amend-signator amend-tab__form"
                                >修改</a
                                >
                              </el-form-item>
                              <!-- 营业执照号 -->
                              <!--<el-form-item v-else-if="item.signatoryUserType !== 1" :prop="(item.disabled === 'disabled') || item.signatoryUserType === 1 ? '' : 'BusinessLicenseNo'"-->
                              <!--:rules="rulesTab.BusinessLicenseNo"-->
                              <!--:show-message="item.disabled !== 'disabled'" style="position: relative;">-->
                              <!--<el-input v-model="item.BusinessLicenseNo" :disabled="(item.disabled === 'disabled') || item.signatoryUserType === 1"-->
                              <!--placeholder="请输入营业执照号"/>-->
                              <!--<a @click="handleTargetIdChange(item)" v-if="item.ischange === 1" href="javascript:void (0)"-->
                              <!--class="color-success amend-signator amend-tab__form">修改</a>-->
                              <!--</el-form-item>-->
                            </div>

                            <div class="col notice-warp" style="width: 150px">
                              <el-button
                                icon="el-icon-plus"
                                v-if="
                                    item.isNoticePhone && !item.showNoticePhone
                                  "
                                @click="changShowNoticePhone(i)"
                              ></el-button>
                              <el-form-item
                                prop="alertMobile"
                                :rules="rulesTab.mobile"
                                v-if="item.showNoticePhone"
                              >
                                <el-input
                                  v-model="item.alertMobile"
                                  placeholder="请输入通知手机号"
                                />
                                <span class="g-icon-close">
                                    <img
                                      class="icon icon1"
                                      src="/images/icon/icon_close.png"
                                      @click="changShowNoticePhone(i)"
                                    />
                                    <img
                                      class="icon icon2"
                                      src="/images/icon/icon_colse_hover.png"
                                      @click="changShowNoticePhone(i)"
                                    />
                                  </span>
                              </el-form-item>
                            </div>

                            <!--<el-col :span="3" class="col">-->
                            <!--<el-form-item>-->
                            <!--<el-select v-if="item.signatoryUserType === 1 && item.corpUser" v-model="item.handSign" size="small" class="select">-->
                            <!--<el-option :value="0" label="图形章"/>-->
                            <!--<el-option style="display:none;" :value="0" label="图形章"/>-->
                            <!--</el-select>-->
                            <!--<el-select v-if="item.signatoryUserType === 1 && !item.corpUser" v-model="item.handSign" size="small" class="select">-->
                            <!--<el-option :value="1" label="图形章"/>-->
                            <!--<el-option :value="2" label="图形章+手写"/>-->
                            <!--</el-select>-->
                            <!--<el-select v-if="item.signatoryUserType === 0" v-model="item.handSign" size="small" class="select">-->
                            <!--<el-option :value="0" label="标准图形章"/>-->
                            <!--<el-option :value="1" label="手写"/>-->
                            <!--</el-select>-->
                            <!--</el-form-item>-->
                            <!--</el-col>-->
                            <div class="col">
                              <el-form-item>
                                <!--<el-select v-model="item.authLevel" size="small" class="select">-->
                                <!--<el-option :value="null" label="无验证方式"/>-->
                                <!--<el-option :value="2" label="银行卡四要素认证"/>-->
                                <!--<el-option :value="10" label="银行卡三要素认证"/>-->
                                <!--<el-option :value="11" label="公安部人脸识别"/>-->
                                <!--</el-select>-->
                                <el-checkbox
                                  v-model="item.authLevel"
                                  :true-label="11"
                                  style="margin: 0"
                                  :false-label="null"
                                  @change="authLevelChange(i)"
                                >
                                  需要人脸识别
                                </el-checkbox>
                                <el-tooltip
                                  effect="light"
                                  content=""
                                  placement="bottom-end"
                                >
                                  <div slot="content">
                                    选择人脸识别，可把签署方的<br />人脸视频文件作为签署证据
                                  </div>
                                  <i
                                    class="el-icon-question"
                                    style="
                                        font-size: 16px;
                                        margin-left: 10px;
                                        color: #a1a1a1;
                                        cursor: pointer;
                                      "
                                  ></i>
                                </el-tooltip>
                              </el-form-item>
                            </div>
                          </div>
                        </el-form>
                      </li>
                    </template>
                  </transition-group>
                </draggable>
              </div>
              <el-dialog
                title="提示"
                :visible.sync="authLevelShow"
                width="20%"
              >
                  <span style="display: inline-block; text-align: center"
                  >是否取消该签署方的人脸识别？取消人脸识别，将不能把该签署方的人脸视频文件作为签署证据。</span
                  >
                <span slot="footer" class="dialog-footer">
                    <el-button @click="authLevelShow = false">取 消</el-button>
                    <el-button type="primary" @click="dialogVisible = false"
                    >确 定</el-button
                    >
                  </span>
              </el-dialog>
              <div style="text-align: right; padding: 0 29px 10px 0">
                <el-button @click="nextstep = false" type="danger"
                >修改签署方</el-button
                >
              </div>
            </div>
          </div>
          <!-- 集团账户设置了审批流 -->
          <div
            class="f-center2"
            v-if="
              isGroup && checkedBatch === false && hasApplyApproval === true
            "
          >
            <el-form-item
              v-if="
                isGroup && checkedBatch === false && hasApplyApproval === true
              "
            >
              <h4 style="display: inline-block; margin-right: 15px">
                <i></i>选择审批流程
              </h4>
              <div class="bow">
                <el-select
                  v-model="approvalFlowSelect"
                  size="mini"
                  placeholder="请选择审批流程"
                  @change="handleChangeApprovalFlow"
                >
                  <el-option
                    v-for="(v, index) in approvalFlowList"
                    :key="index"
                    :value="v.flowId"
                    :label="v.flowName"
                  ></el-option>
                </el-select>
                <div
                  v-if="flows.length > 0"
                  style="
                    border: 1px solid rgba(229, 229, 229, 1);
                    border-radius: 4px;
                    margin-top: 12px;
                  "
                >
                  <div style="display: inline-block; position: relative">
                    <flow
                      v-for="(v, index) in flows"
                      :model="v"
                      :hiddenArrow="v.hiddenArrow"
                      :hiddenRemove="false"
                      :key="index"
                    >
                      <div slot="username">
                        <span style="color: #aaaaaa">{{ v.partyName }}</span>
                      </div>
                    </flow>
                  </div>
                </div>
              </div>
            </el-form-item>
          </div>

          <div class="f-center2" v-if="isGroup && checkedBatch === false">
            <!-- 抄送设置 -->
            <el-form-item v-if="isGroup && checkedBatch === false">
              <h4><i></i>设置抄送人</h4>
            </el-form-item>
            <el-form-item v-if="isGroup && checkedBatch === false" class="bow">
              <div
                style="
                  border: 1px solid rgba(229, 229, 229, 1);
                  border-radius: 4px;
                  overflow: hidden;
                  padding: 8px 0;
                "
              >
                <div class="audit-flex">
                  <div
                    v-for="(item, index) in arrayCopior"
                    :key="index"
                    class="audit-box"
                  >
                    <i class="icon icon-audit-touxiang66"></i>
                    <!-- <i class="icon icon-audit-touxiang66dark"></i> -->
                    <div class="auditor">
                      {{ item.userName || item.partyName }}
                    </div>
                    <i
                      v-show="!item.hideRemove"
                      @click="handleClickRemoveArrayCopior(index)"
                      class="icon icon-audit-cuowu17 size17"
                    ></i>
                  </div>
                  <!-- 添加按钮 -->
                  <div
                    class="audit-add"
                    @click="clickHandleAddAuditorOrCopyer(false)"
                  >
                    <i class="icon icon-audit-add-2x"></i>
                  </div>
                </div>
              </div>
            </el-form-item>
          </div>
          <!-- 签署方和发起方是同一人，展示选择签章 -->
        <div class="f-center2" v-if="isMine()">
          <el-form-item>
            <p class="cc_title">选择签章</p>
            <template>
              <div class="temone-box" v-if="chapterList.length">
                <template v-for="(item, index) in chapterList">
                  <div
                    class="temone-chap"
                    :class="{'select-border': chapterCheck.includes(item.corpSealId) ? true : false}"
                    :key="index"
                    @click="selectChap(item)"
                  >
                    <img class="select_img" src="/images/selected.png" alt="">
                    <div class="info_box" >
                      <el-popover placement="top-start" trigger="hover">
                        <div style="padding: 10px;font-weight: bold;" v-if="(!isInDingTalk && item.flowDetail) || (isInDingTalk && item.dingTalkFlow)">
                          <p>
                            {{ !isInDingTalk ? item.flowDetail && item.flowDetail.flowName :
                            (isInDingTalk && item.dingTalkFlow ? item.dingTalkFlow.flowName : "") }}
                          </p>
                          <div style="height:125px;overflow:auto">
                            <approval-process
                              :flowInfo="computeInfo(isInDingTalk ? item.dingTalkFlow : item.flowDetail)"
                              :orderFlag="isInDingTalk ? item.dingTalkFlow.flowType : item.flowDetail.orderFlag"
                            ></approval-process>
                          </div>
                        </div>
                        <div v-else>
                          <p style="padding: 20px; color: #606266; font-weight: bold">无审批流程</p>
                        </div>
                        <div slot="reference">
                          <div class="t-box">
                            <img class="y-img" :src="item.signUrl" :title="item.sealName" />
                          </div>
                          <p :title="`${item.sealName}`">
                            {{ `${item.sealName}` }}
                          </p>
                        </div>
                      </el-popover>
                    </div>
                  </div>
                </template>
              </div>
              <p v-else style="color: #ec1c1e">
                您还没有获得企业印章的使用授权，可继续发起合同，请在签署前联系管理员给您进行印章授权！
              </p>
            </template>
          </el-form-item>
        </div>

          <!--<el-form-item>-->
          <!--<h4>签署设置</h4>-->
          <!--</el-form-item>-->

          <!--<el-form-item>-->
          <!--<el-row style="margin-bottom: 20px;margin-left: 0px;margin-right: 0px;" :gutter="20">-->
          <!--<el-col :span="8" style="padding-left: 0;">-->
          <!--<el-checkbox @change="handleChangeCa('serverCa')" v-model="contractInfo.serverCa" :disabled="contractInfo.consumMode == 1"-->
          <!--:true-label="1" :false-label="0" border class="checkbox">-->
          <!--<p class="title">-->
          <!--数字证书-->
          <!--<el-tooltip effect="dark" placement="top">-->
          <!--<div slot="content">数字证书：选择使用数字证书，<br/>所有C端（个人）签署方均须登录并<br/>完成实名认证后才能完成签署。</div>-->
          <!--<i class="el-icon-question"></i>-->
          <!--</el-tooltip>-->
          <!--</p>-->
          <!--<br/>-->
          <!--<p class="small">所有签署方须实名认证后签署</p>-->
          <!--</el-checkbox>-->
          <!--</el-col>-->
          <!--<el-col :span="8">-->
          <!--<el-checkbox v-model="contractInfo.needQifengSign" :true-label="1" :false-label="0" border class="checkbox">-->
          <!--<p class="title"> 骑缝章 </p><br/>-->
          <!--<p class="small">所有签署方均使用图形章自动完成骑缝章</p>-->
          <!--</el-checkbox>-->
          <!--</el-col>-->
          <!--<el-col :span="8" style="padding-right: 0;">-->
          <!--<div class="checkbox end-time">-->
          <!--<el-date-picker v-model="contractInfo.overDate" type="date" :picker-options="pickerOptionsBetween0to30"-->
          <!--format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="请选择签署截止日期"/>-->
          <!--<p class="small">签署方未在截止日期内完成签署，合同将会失效</p>-->
          <!--</div>-->
          <!--</el-col>-->

          <!--</el-row>-->
          <!--<el-row :gutter="20" style="margin-left: 0px;margin-right: 0px;" v-if="hasVideoPackage">-->
          <!--<el-col :span="8" style="padding-left: 0;">-->
          <!--<el-checkbox v-model="contractInfo.needVideoSign" :true-label="1" :false-label="0" border class="checkbox">-->
          <!--<p class="title"> 视频签署 </p><br/>-->
          <!--<p class="small">需要签署方进行在线视频沟通后，再完成签署</p>-->
          <!--</el-checkbox>-->
          <!--</el-col>-->
          <!--</el-row>-->
          <!--</el-form-item>-->

          <div class="f-bottom" v-if="false">
            <!-- 签署消费方式改版 2019-2-14 15:51:25 -->
            <el-form-item v-if="!isGroup">
              <h4><i></i>支付方式</h4>
            </el-form-item>
            <!-- 自定义select 重构 -->
            <el-form-item v-if="!isGroup" class="bow">
              <el-select v-model="contractInfo.consumMode" placeholder="请选择">
                <el-option label="发起方支付全部费用" :value="0"></el-option>
                <el-option
                  label="各方各自支付自己的费用"
                  :value="1"
                ></el-option>
              </el-select>
              <!--              <el-popover-->
              <!--                placement="bottom-start"-->
              <!--                :offset="15"-->
              <!--                v-model="visibleChangeSelectStatus"-->
              <!--                trigger="click">-->
              <!--                <ul>-->
              <!--                  <li style="padding: 10px 15px">-->
              <!--                    <el-radio @change="visibleChangeSelect" v-model="contractInfo.consumMode"-->
              <!--                              :label="0" border class="radio">发起方支付全部费用-->
              <!--                    </el-radio>-->
              <!--                  </li>-->
              <!--                  <li style="padding: 0px 15px 10px 15px">-->
              <!--                    <el-radio @change="visibleChangeSelect" v-model="contractInfo.consumMode" :label="1"-->
              <!--                              border class="radio">各方各自支付自己的费用-->
              <!--                    </el-radio>-->
              <!--                  </li>-->
              <!--                </ul>-->
              <!--                <el-button slot="reference" style="width: 450px;background: rgb(248,248,248);padding: 0;" class="pay-type">-->
              <!--                  <div style="width: 450px;z-index: 10;">-->
              <!--                    <template v-if="contractInfo.consumMode === 0">-->
              <!--                      <label class="el-radio radio el-radio&#45;&#45;small is-checked">-->
              <!--											<span class="el-radio__input is-checked">-->
              <!--												<span class="el-radio__inner"></span>-->
              <!--											</span>-->
              <!--                        <span class="el-radio__label">发起方支付全部费用</span>-->
              <!--                        <i :class="{'el-icon-arrow-down': true, 'custom-transform-rotateZ-180': visibleChangeSelectStatus, 'custom-transform-rotateZ-0': !visibleChangeSelectStatus}"-->
              <!--                           style="vertical-align: text-top;font-size: 20px;color: #cccccc;margin-left: 10px;"></i>-->
              <!--                      </label>-->
              <!--                    </template>-->
              <!--                    <template v-else>-->
              <!--                      <label role="radio" aria-checked="true" tabindex="0" class="el-radio radio el-radio&#45;&#45;small is-checked">-->
              <!--											<span class="el-radio__input is-checked">-->
              <!--												<span class="el-radio__inner"></span>-->
              <!--											</span>-->
              <!--                        <span class="el-radio__label">各方各自支付自己的费用</span>-->
              <!--                        <i :class="{'el-icon-arrow-down': true, 'custom-transform-rotateZ-180': visibleChangeSelectStatus, 'custom-transform-rotateZ-0': !visibleChangeSelectStatus}"-->
              <!--                           style="vertical-align: text-top;font-size: 20px;color: #cccccc;margin-left: 10px;"></i>-->
              <!--                      </label>-->
              <!--                    </template>-->

              <!--                  </div>-->
              <!--                </el-button>-->
              <!--              </el-popover>-->
            </el-form-item>
          </div>

          <el-form-item class="text-center">
            <el-button @click="nextstep = false">上一步</el-button>
            <el-button
              v-if="!checkedBatch"
              @click="sendContractToCreate(true)"
              :disabled="isSaveDisable"
              :class="{ 'g-save-disable': isSaveDisable }"
              >存为草稿</el-button
            >
            <el-button
              @click="sendContractToCreate(false)"
              type="danger"
              :disabled="isSaveDisable"
              :class="{ 'g-save-disable': isSaveDisable }"
              >立即发起</el-button
            >
          </el-form-item>
        </el-form>
      </el-main>
    </template>

    <!--审批人/抄送人-->
    <el-dialog
      :title="auditAndCopyTitle"
      :visible.sync="visibleAuditAndCopy"
      width="50%"
    >
      <el-row class="tel-search">
        <el-col :span="18">
          <!--          <el-input clearable v-model="auditAndCopyModel.keyword" @keyup.enter.native="clickHandleAuditorOrCopyerSearch()" size="small"-->
          <!--                    placeholder="姓名/邮箱/手机号"/>-->
          <el-row>
            <el-col :span="8" style="padding: 0 10px">
              <el-input
                clearable
                v-model="myCorpModel.keyword"
                @keyup.enter.native="clickHandleMyCorpSearch()"
                size="small"
                placeholder="邮箱/手机号"
              />
            </el-col>
            <el-col :span="8" style="padding: 0 10px">
              <el-input
                clearable
                v-model="myCorpModel.corpUserName"
                size="small"
                placeholder="签署方名称"
              ></el-input>
            </el-col>
            <el-col :span="8" style="padding: 0 10px">
              <el-select
                v-model="myCorpModel.corpGroupId"
                placeholder="请选择部门"
                size="small"
              >
                <el-option label="全部" value=""></el-option>
                <el-option
                  v-for="(item, i) in department"
                  :key="i"
                  :label="item.groupName"
                  :value="item.corpGroupId"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="5" :offset="1">
          <el-button @click="clickHandleMyCorpSearch()" size="small" class="btn"
            >查询</el-button
          >
        </el-col>
      </el-row>

      <div class="tel-box" style="height: 415px; overflow: auto">
        <el-table
          v-loading="myCorpModel.loading"
          :empty-text="myCorpModel.emptyText"
          @row-click="handleRowClickAuditAndCopy"
          :data="tableListMyCorp"
          style="width: 100%"
          highlight-current-row
          tooltip-effect="dark"
          stripe
          :cell-style="{ cursor: 'pointer' }"
          :header-cell-style="{
            background: '#f9f9f9',
            color: '#333333',
            fontWeight: '500',
          }"
        >
          <el-table-column label="邮箱/手机号" prop="targetId" />
          <el-table-column label="签署方名称" prop="userName" />
          <el-table-column label="部门" prop="groupNames" />
        </el-table>
      </div>
      <br />
      <el-pagination
        @size-change="handleSizeChangeQueryToolMyCorp"
        @current-change="handleCurrentChangeQueryToolMyCorp"
        :current-page="myCorpModel.itemPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="myCorpModel.pageSize"
        layout="sizes, prev, pager, next, jumper, total"
        :total="myCorpModel.total"
        style="text-align: right"
      />

      <p slot="footer" class="dialog-footer">
        <el-button @click="visibleAuditAndCopy = false" size="small" class="btn"
          >取消</el-button
        >
        <el-button
          @click="clickHandleAddAuditorOrCopyerSubmit()"
          type="danger"
          size="small"
          class="btn"
          >添加</el-button
        >
      </p>
    </el-dialog>

    <!--消费弹窗-->
    <el-dialog
      :visible.sync="priseVisibleDialog"
      @closed="handleDelSendContract"
      title="温馨提示"
      :show-close="false"
      width="400px"
      class="prise-dialog"
    >
      <div
        class="box-dashed text-center"
        style="margin-top: 10px; padding-bottom: 5px"
      >
        <img src="/images/icon_signed.png" style="height: 80px" />
        <template v-if="priseInfo.mealInfo">
          <h4>
            本次共花费：
            <span class="color-danger">{{ priseInfo.mealInfo }}</span>
          </h4>
          <h4 v-if="priseInfo.point">
            另需要支付<span class="color-danger"
              >{{ priseInfo.point }}积分</span
            >
          </h4>
        </template>
        <h4 v-else style="font-weight: bold">
          本次共花费：<span class="color-danger"
            >{{ priseInfo.point }}积分</span
          >
        </h4>
        <p style="text-align: start; margin-left: 8px">
          <i class="el-icon-info"></i>
          发起后，签署方将收到签署短信通知，该通知24小时有效，请尽快完成签署！
        </p>
      </div>
      <div slot="footer" class="text-center">
        <el-button
          @click="toPay(priseInfo.cashierUrl)"
          type="danger"
          size="small"
          class="footer-btn"
          :disabled="payDisabled"
          >确定
        </el-button>
      </div>
    </el-dialog>
    <!--通讯簿列表-->
    <el-dialog
      title="选择签署方"
      :visible.sync="showTel"
      lock-scroll
      width="749px"
    >
      <!-- tabs -->
      <el-tabs v-model="activeTabSigner">
        <!-- 我的通讯录 -->
        <el-tab-pane label="常用签署方" name="default">
          <el-row class="tel-search">
            <el-col :span="6">
              <el-input
                v-model="telPageInfo.accountNo"
                @keyup.enter.native="getTelList()"
                size="small"
                placeholder="邮箱/手机号"
              />
            </el-col>
            <el-col :span="6" :offset="1">
              <el-input
                v-model="telPageInfo.name"
                @keyup.enter.native="getTelList()"
                size="small"
                placeholder="签署方名称"
              />
            </el-col>
            <el-col :span="6" :offset="1">
              <el-input
                v-model="telPageInfo.idNo"
                @keyup.enter.native="getTelList()"
                size="small"
                placeholder="证件号"
              />
            </el-col>
            <el-col :span="3" :offset="1">
              <el-button @click="getTelList" size="small" class="btn"
                >查询</el-button
              >
            </el-col>
          </el-row>
          <div
            class="tel-box"
            style="max-height: 340px; overflow: auto; min-width: 749px"
          >
            <el-table
              @row-click="handleTelRowClickSelectRow"
              :data="telList"
              style="width: 100%"
              highlight-current-row
              tooltip-effect="dark"
              stripe
              :cell-style="{ cursor: 'pointer' }"
              :header-cell-style="{
                background: '#f9f9f9',
                color: '#333333',
                fontWeight: '500',
              }"
            >
              <el-table-column label="签署方名称" prop="enterpriseName" />
              <el-table-column label="证件号" prop="businessLicense" />
              <el-table-column label="邮箱/手机号" prop="mobileOrChild" />
            </el-table>
          </div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="telPageInfo.itemPage"
            :page-sizes="[6, 12, 30, 60]"
            :page-size="telPageInfo.pageSize"
            layout="sizes, prev, pager, next, jumper, total"
            :total="telPageInfo.total"
            style="text-align: right; margin-top: 10px"
          />
        </el-tab-pane>
        <!-- 我的组织 -->
        <el-tab-pane
          v-if="isGroup"
          :label="activeTabOrganizationName"
          name="organization"
        >
          <el-row class="tel-search">
            <el-col :span="18">
              <el-row>
                <el-col :span="8" style="padding: 0 10px">
                  <el-input
                    clearable
                    v-model="myCorpModel.keyword"
                    @keyup.enter.native="clickHandleMyCorpSearch()"
                    size="small"
                    placeholder="邮箱/手机号"
                  />
                </el-col>
                <el-col :span="8" style="padding: 0 10px">
                  <el-input
                    clearable
                    v-model="myCorpModel.corpUserName"
                    size="small"
                    placeholder="签署方名称"
                  ></el-input>
                </el-col>
                <el-col :span="8" style="padding: 0 10px">
                  <el-select
                    v-model="myCorpModel.corpGroupId"
                    placeholder="请选择部门"
                    size="small"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="(item, i) in department"
                      :key="i"
                      :label="item.groupName"
                      :value="item.corpGroupId"
                    >
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="5" :offset="1">
              <el-button
                @click="clickHandleMyCorpSearch()"
                size="small"
                class="btn"
                >查询</el-button
              >
            </el-col>
          </el-row>
          <div class="tel-box" style="height: 415px; overflow: auto">
            <el-table
              v-loading="myCorpModel.loading"
              :empty-text="myCorpModel.emptyText"
              @row-click="handleRowClickMyCorp"
              :data="tableListMyCorp"
              style="width: 100%"
              highlight-current-row
              tooltip-effect="dark"
              stripe
              :cell-style="{ cursor: 'pointer' }"
              :header-cell-style="{
                background: '#f9f9f9',
                color: '#333333',
                fontWeight: '500',
              }"
            >
              <el-table-column label="邮箱/手机号" prop="targetId" />
              <el-table-column label="签署方名称" prop="userName" />
              <el-table-column label="部门" prop="groupNames" />
            </el-table>
          </div>
          <br />
          <el-pagination
            @size-change="handleSizeChangeQueryToolMyCorp"
            @current-change="handleCurrentChangeQueryToolMyCorp"
            :current-page="myCorpModel.itemPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="myCorpModel.pageSize"
            layout="sizes, prev, pager, next, jumper, total"
            :total="myCorpModel.total"
            style="text-align: right"
          />
        </el-tab-pane>
      </el-tabs>
      <p slot="footer" class="dialog-footer">
        <el-button
          @click="handleClickSelectSignorOk()"
          type="danger"
          size="small"
          class="btn"
          >确定</el-button
        >
      </p>
    </el-dialog>
    <!--签署指引-->
    <div v-if="guideStep" class="apply-guide">
      <div class="box" ref="guideBox">
        <div
          v-if="guideStep !== 'step5'"
          class="tooltip"
          :class="guideStep === 'step4' ? 'tooltip-top' : 'tooltip-bottom'"
          ref="tooltip"
        >
          <template v-if="guideStep === 'step1'">
            <div class="tooltip-text"><span>1</span>点击添加签署方</div>
            <div class="tooltiop-btns">
              <a @click="guideApplyCancel" href="javascript:void (0)"
                >关闭引导</a
              >
              <a @click="guideApply('step2')" href="javascript:void (0)"
                >下一步</a
              >
            </div>
            <div class="tooltip-arrow" style="left: 65%"></div>
          </template>
          <template v-if="guideStep === 'step2'">
            <div class="tooltip-text"><span>2</span>点击填写签署方信息</div>
            <div class="tooltiop-btns">
              <a @click="guideApplyCancel" href="javascript:void (0)"
                >关闭引导</a
              >
              <a @click="guideApply('step3')" href="javascript:void (0)"
                >下一步</a
              >
            </div>
            <div class="tooltip-arrow" style="left: 92%"></div>
          </template>
          <template v-if="guideStep === 'step3'">
            <div class="tooltip-text">
              <span>3</span>点击签署方设置固定签章位置
            </div>
            <div class="tooltiop-btns">
              <a @click="guideApplyCancel" href="javascript:void (0)"
                >关闭引导</a
              >
              <a @click="guideApply('step4')" href="javascript:void (0)"
                >下一步</a
              >
            </div>
            <div class="tooltip-arrow" style="left: 75%">+</div>
          </template>
          <template v-if="guideStep === 'step4'">
            <div class="tooltip-text"><span>4</span>点击添加附件</div>
            <div class="tooltiop-btns">
              <a @click="guideApplyCancel" href="javascript:void (0)">完成</a>
            </div>
            <div class="tooltip-arrow" style="left: 25%"></div>
          </template>
        </div>
        <template v-if="guideStep === 'step5'">
          <div
            class="tooltip tooltip-bottom"
            style="left: 10px; top: 60px"
            ref="tooltip"
          >
            <div class="tooltip-text">
              <span>1</span>顺序签名选择，可以拖动签署方进行签名排序
            </div>
            <div class="tooltiop-btns">
              <a @click="guideApplyCancel" href="javascript:void (0)">完成</a>
            </div>
            <div class="tooltip-arrow" style="left: 25%"></div>
          </div>
        </template>
      </div>
    </div>
    <!--1.填写企业证件号，2.对填写的姓名身份证号进行二要素验证错误-->
    <sign-info-tips-dialog
      :show.sync="visibleCredit"
      :entCreditArr="entCreditArr"
      :entCreditJson="entCreditJson"
      :userIdentityInfoArr="userIdentityInfoArr"
      @continue="addContractById"
      @cancel="handleDelSendContract"
    />
    <el-dialog
      title="温馨提示"
      :visible.sync="signDialog"
      width="500px"
      style="margin-top: 30vh"
    >
      <div style="padding: 50px 35px 35px 40px; color: rgba(41, 2, 2, 0.64)">
        <div style="display: flex; align-items: center; margin-bottom: 5px">
          <img
            src="../../static/images/warning.png"
            style="width: 15px; height: 15px; margin-right: 5px"
          />
          <p style="font-size: 16px; font-weight: bold">
            是否放弃设置签章位置，继续发起签署？
          </p>
        </div>
        <p style="font-weight: bold; display: inline-block; margin-left: 20px">
          {{ chap.join("、")
          }}<span style="font-weight: 500"> 还未设置签章位置！</span>
        </p>
      </div>
      <div
        style="display: flex; align-items: center; justify-content: flex-end"
      >
        <el-button
          @click="nextStep"
          style="
            width: 65px;
            height: 30px;
            border: 1px solid rgba(220, 220, 220, 1);
            padding: 0;
            text-align: center;
            color: rgba(41, 2, 2, 0.44);
          "
          >继续发起</el-button
        >
        <el-button
          @click="signDialog = false"
          style="
            width: 65px;
            height: 30px;
            padding: 0;
            text-align: center;
            color: #ffffff;
            background: #ec1c1c;
            border: 0;
          "
          >返回设置</el-button
        >
      </div>
    </el-dialog>
    <!--  设置水印 setWatermarkVisible -->
    <el-dialog title="添加水印" width="60%" :visible.sync="setWatermarkVisible">
      <waterMark v-if="setWatermarkVisible" :visible.sync="setWatermarkVisible" :waterConfig.sync="waterConfig" />
    </el-dialog>
  </el-container>
</template>

<script>
import Flow from "../../components/flow";
import draggable from "vuedraggable";
import SingerForm from "../../components/singer-form";
import ToolTip from "../../components/tool-tip";
import ContractView from "../../components/contract-view/indexOld";
import SignInfoTipsDialog from "../../components/contract/signInfoTipsDialog";
import approvalProcess from "@/components/approval-process/index";
import waterMark from "@/components/waterMark/index";
import {
  postCreateApply,
  postFindByEmailOrMphon,
  convertDetailToShow,
  postTelFindByPagedEnterpriseList,
  postFileTempUpload,
  getDraftInfoByApplyId,
  tempConvertToContract,
  ApiMethods,
  fileOperShow,
  configUrl,
  queryCreditCodeByEntName,
  queryUserValidateByNameIDnum,
  getCorpDraftInfoByApplyId
} from "../../assets/js/http-serve/http-methods";
import {
  mobileOrEmail,
  identityNo,
  businessVal,
  personalName,
  mobile,
  happy
} from "../../assets/js/lib/valid-methods";
import VideoSign from "../../assets/js/http-serve/video-sign";
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
// import TemplateManage from '../console/template';
import moment from "moment";
import {
  setCurrentUser,
} from "@/assets/js/http-serve/corp/common";
import { isInDingTalk } from '@/assets/js/utils/ding-env';

export default {
  data () {
    return {
      personImgSign: 0, // 是否使用个人图形章

      DINGSDK: null,
      chapterList:[], // 授权给我的签章列表
      chapterCheck:[], // 选择的签章
      isInDingTalk,
      /** 用来确定骑缝章的值 needQifengSign */
      qiFengSign: {
        personSign: 1,
        enterpriseSign: 1
      },
      isError: true, // 解决 el-form-item :error 数据显示 bug
      isSaveDisable: true, //禁用保存按钮
      goPageNum: null, // 前往多少页
      payInfoData: {},
      showMoreSet: false,
      // 雷云风新的需求，发起审批新流程
      flows: [],
      hasApplyApproval: false,
      approvalFlowList: [],
      approvalFlowSelect: undefined,

      batchLoading: false,
      // 批量签署方 array
      batchArray: [],
      // 批量签署方 checkbox
      checkedBatch: false,
      // 支付方式select 展开关闭状态
      visibleChangeSelectStatus: false,
      // 是否是集团账户
      isGroup: false,
      // 添加审批人/抄送人Dialog
      visibleAuditAndCopy: false,
      auditAndCopyTitle: "",
      auditAndCopyActive: false,
      auditAndCopyModel: {
        loading: false,
        emptyText: "请输入组织内部签署方名称或账号",
        keyword: "",
        itemPage: 0,
        pageSize: 10,
        total: 0
      },
      tableListAuditAndCopy: [], // 审批人 抄送人列表

      arrayCopior: [], // 抄送人数组
      tableAuditAndCopySelectRow: undefined,
      // 我的组织 选择签署人
      myCorpModel: {
        loading: false,
        emptyText: "请输入组织内部签署方名称或账号",
        keyword: "",
        itemPage: 0,
        pageSize: 10,
        total: 0,
        corpUserName: "", // 名称
        corpGroupId: "" // 部门ID
      },
      tableListMyCorp: [],
      tableSignorSelectRow: undefined,
      tableSignorSelectRowTargetID: undefined,

      // 签署方 tabs
      activeTabSigner: "default", // 我的通讯录 default , 我的组织 organization
      activeTabOrganizationName: "我的组织",
      // select index
      selectIndex: 0,
      pickerOptionsBetween0to30: {
        disabledDate (time) {
          return (
            time.getTime() < Date.now() ||
            time.getTime() > Date.now() + 3600 * 24 * 30 * 1000
          );
        }
      },
      apiMethods: ApiMethods,
      contractNameRules: {
        contractName: [
          // {validator: this.$validator.specialValContractName, trigger: 'change', message: '文件名称不能包含特殊字符'},
        ]
      },
      // 合同信息
      contractInfo: {
        contractName: "",
        serverCa: 1,
        needCa: 0,
        signatoryJson: "[]",
        attatchFileNamesJson: "[]",
        overDate: "",
        needVideoSign: 0,
        ifOrder: false,
        needPresSign: 1,
        /**
         * 是否使用骑缝章
         * @value 0 不要企业和个人骑缝章（两个都不打钩）
         * @value 1 企业和个人都有骑缝章（两个都打钩）
         * @value 2 企业打钩个人不打钩
         * @value 3 企业不打钩个人打钩
         * */
        needQifengSign: 1,
        approveJson: "",
        returnURL:
          configUrl().junziqianWebOp + "/signInfo/signList?signStatus=2",
        consumMode: 0,
        saveToDraftBox: 0,
        applyId: null,
        contractId: null,

        // 视频签署
        newNeedVideoSign: "", // 是否使用视频签署
        videoSignStartTime: "", // 开始时间
        hideSignDate: 0, // 签章不显示时间
      },
      setWatermarkVisible: false,
      waterConfig: {}, //水印内容
      // 合同列表
      contractList: {},
      rulesTab: {
        emailOrPhone: [{ validator: mobileOrEmail, trigger: "change" }],
        signatoryMobile: [{ validator: mobileOrEmail, trigger: "change" }],
        childUserName: [{ validator: mobileOrEmail, trigger: "change" }],
        mobile: [{ validator: mobile, trigger: "change" }],
        signatoryFullName: [{ validator: personalName, trigger: "blur" }],
        // signatoryIdentityCard: [{validator: identityNo, trigger: 'blur'}]
        IDCard: [{ validator: identityNo, trigger: "blur" }],
        BusinessLicenseNo: [{ validator: businessVal, trigger: "blur" }]
      },
      // 附件参数信息 参数为json 现场上传{targetId: '', targetFix: '', origiName: ''}或者修改草稿箱已有的{codeName: '', origiName: ''}
      attatchFileNamesJson: [],
      /**
       * 重构
       * 签字人列表参数
       * // 后端必须要的
       * signOwner: 甲乙方,
       * childUserName: 企业联系, 如果是集团账户 存 corpUser
       * signatoryMobile: 个人联系,
       * signatoryFullName: 签署方名称,
       * signatoryIdentityCard: 证件号,
       * signatoryUserType: 用户类型,
       * authLevel: 认证类型身份、三四要素,
       * handSign: 签章类型,
       * chapteJson: [{page: 0, chaptes[固定签章,章位置]}],
       *
       * // 前端辅助变量
       * emailOrPhone: '', 邮箱和电话
       * canSelectArray: [], 新增集团账户 数组
       * canSelectArrayIndex： 0, // 选择下标
       * ischange: 0/1是否修改,
       * notRegister: false/true签署方是否注册,
       * disabled: "disabled是否禁止填写",
       * openUserTab: false/true打开弹窗,
       * order: 排序,
       * isEncrypt: false/true是否加密(通过查询的加密)}
       */
      signatoryJson: [
        {
          signOwner: "签署方一",

          emailOrPhone: "",
          childUserName: "",
          signatoryMobile: "",

          signatoryFullName: "",
          signatoryIdentityCard: "",
          signatoryUserType: 0,

          corpUser: false,

          //authLevel: 11,    873 需求修改，此前默认人脸认证 ，此后取消这个逻辑
          authLevel: "",
          handSign: 0,

          chapteJson: null,
          // 新增集团账户 数组
          canSelectArray: [],
          canSelectArrayIndex: 0,

          IDCard: "",
          BusinessLicenseNo: "",
          ischange: 0,
          notRegister: true,
          disabled: "",
          openUserTab: false,
          isEncrypt: false,

          isNoticePhone: false,
          showNoticePhone: false,
          alertMobile: ""
        }
      ],
      isSaveToDraftBox: false, // 合同是否保存到草稿箱
      // 企业名称和企业证件号，key(signatoryJson中的signatoryFullName签署方名称)=>value(signatoryJson中的signatoryIdentityCard证件号) 只能是企业类型的用户

      // 签署方身份信息验证相关 start
      //..... 验证用户输入的企业是否存在 start.....
      entCreditJson: null,
      entCreditArr: [],
      entNameArr: [],
      visibleCredit: false,
      //..... 验证用户输入的企业是否存在 end.....
      userIdentityInfoArr: [], // 存放需要进行姓名身份证二要素的数组
      // 签署方身份信息验证相关 end

      // 签章参数 {page: 0合同第几页, chaptes:[签章位置{offsetX: '0.5', offsetY: '0.5', cindex: 0章顺序不分甲乙方和页数, signOwner: 甲乙方, url: 章地址， page: 0合同页数}]}
      chapteJson: [],
      // 联系人相关通讯录
      telList: [],
      telPageInfo: {
        itemPage: 1,
        pageSize: 6,
        total: 0,
        name: null,
        idNo: null,
        accountNo: null
      },
      showTel: false,
      boxHeight: "1170px",
      listHeight: "",
      // 当前页信息
      currentInfo: { page: 1, url: "" },
      accessoryShow: false,
      timer: null,
      // 第一步：false，第二步：true
      nextstep: false,
      // nextstep: false,
      // 显示价格的弹窗
      priseInfo: { mealInfo: null, money: 0, point: 0, cashierUrl: "" },
      priseVisibleDialog: false,
      // 合同类型 1临时文件 3存储文件
      fileType: 1,
      // 是否有视频签署套餐
      hasVideoPackage: false,
      loading: null,
      dragging: false,
      guideStep: null,
      lastGuide: false,
      // 小地图 拖动相对位移
      deviationSmallMap: {
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        clientWidth: 0,
        clientHeight: 0
      },
      // 签署方相对坐标, 甲,乙,丙....
      relativeCoordinate: {
        签署方一: { x: 0.2, y: 0.2 },
        签署方二: { x: 0.2, y: 0.22 },
        签署方三: { x: 0.2, y: 0.24 },
        签署方四: { x: 0.2, y: 0.26 },
        签署方五: { x: 0.2, y: 0.28 },
        签署方六: { x: 0.2, y: 0.3 },
        签署方七: { x: 0.2, y: 0.31 },
        签署方八: { x: 0.2, y: 0.32 },
        签署方九: { x: 0.2, y: 0.34 },
        签署方十: { x: 0.2, y: 0.36 },
        批量签署方: { x: 0.2, y: 0.38 }
      },
      authLevelShow: false,
      payDisabled: false,
      gifClick: false,
      // 合同缩放比例
      scaleValue: 100,
      chap: [], //未设签章数组
      signDialog: false, //未设签章弹窗
      department: [], // 部门列表
      signlinktime: "", //签署链接时效
      clearable: false,
      pickerOptions: {
        disabledDate (time) {
          const one = 30 * 24 * 3600 * 1000;
          const minTime = new Date().getTime();
          const maxTime = new Date().getTime() + one;
          return time.getTime() < minTime || time.getTime() > maxTime;
        }
      }
    };
  },
  async created () {
    let v = this.$store.getters.currentAuthUser;
    if (v && v.corpUserId) {
      this.isGroup = true;
      this.activeTabOrganizationName = v.corpName;
      // 集团账户情况下，需判断当前账户所在部门是否设置了审批流
      this.hasApprovalFlow();
      this.getChapterList()
      if (this.isGroup) {
        this.getDepartmentList();
      }
    }
    this.getAndSetTime();
    this.DINGSDK = await this.$DingSDKPromise();
  },
  computed: {
    currentUser () {
      return this.$store.getters.currentAuthUser;
    },
  },
  mounted () {
    let { query } = this.$route;
    this.boxHeight = document.body.clientHeight - 60 + "px";
    this.listHeight = document.body.clientHeight - 194 + "px";
    // 草稿箱合同信息
    if (query.applyId) {
      this.contractInfo.applyId = query.applyId;
      this.fileType = 3;
      this.getDraftContractInfoByApplyId(query.applyId);
      this.guideApplyCancel();
    } else {
      this.contractInfo.docHash = query.docHash;
      this.contractInfo.ts = query.ts;
      this.contractInfo.sign = query.sign;
      this.contractInfo.items = parseInt(query.items);
      this.contractInfo.contractId = query.contractId;
      this.contractInfo.contractName = query.contractName;
      this.currentInfo = { page: 1, url: "" };
      this.fileType = query.fileType || 1;
      this.getContractDetailByNum(1);
      if (localStorage.getItem("APPLY_GUIDE") !== "guide") {
        this.guideApply("step1");
        this.lastGuide = true;
      }
    }
    // this.contractInfo.needPresSign = Number(query.needPresSign)
    // this.contractInfo.needQifengSign = Number(query.needQifengSign)
    this.getTelList();

    this.queryUserHasVideoPackage();
    this.signatoryJson[0].emailOrPhone =
      this.$store.getters.authUser.mobileMash ||
      this.$store.getters.authUser.emailMask;
    // 第一次加载
    this.getUserInfoBySelectTargetId(
      this.signatoryJson[0].emailOrPhone,
      0,
      true
    );
    // 查询偏好设置
    this.getSettings()
  },
  watch: {
    "contractInfo.consumMode" (val) {
      if (val === 1) {
        this.contractInfo.serverCa = 1;
      }
    },
    accessoryShow (val) {
      clearInterval(this.timer);
      let fileHeight = document.getElementById("accessoryList").clientHeight;
      if (val) {
        let top = -fileHeight;
        this.timer = setInterval(() => {
          if (top === 0) {
            return clearInterval(this.timer);
          }
          top += 1;
          this.$refs.accessory.style.bottom = top + "px";
        }, 5);
      } else {
        let top = 0;
        this.timer = setInterval(() => {
          if (top === -fileHeight) {
            return clearInterval(this.timer);
          }
          top -= 1;
          this.$refs.accessory.style.bottom = top + "px";
        }, 5);
      }
    }
  },
  methods: {
    /** 查询偏好设置(如果有，将对应设置设值为偏好值) */
    getSettings () {
      this.loadingStart()
      ApiMethods.PreferenceSettingsAPI.getPreferences().then(res => {
        if (!res.success) return this.$message.error(res.description);
        if (res.data) {
          const { presFlag, qifengFlag, perQifengFlag, perSealFlag, timeFlag, waterFlag, waterSetting, certFlag } = res.data;
          this.contractInfo.needPresSign = presFlag
          this.qiFengSign.enterpriseSign = qifengFlag || 0
          this.qiFengSign.personSign = perQifengFlag || 0
          this.personImgSign = perSealFlag
          this.contractInfo.hideSignDate = timeFlag
          this.contractInfo.serverCa = certFlag
          if (!!waterFlag) {
            const water = JSON.parse(waterSetting);
            water.switch = true
            if (water.floatAlpha <= 1) water.floatAlpha = water.floatAlpha * 100
            this.waterConfig = { ...water }
          }
          this.qifengChange()
        }
      }).finally(() => { this.loadingClose() })
    },
    /**
     * 跳转偏好设置页面
     */
    turnPref () {
      let current = this.currentUser, MAIN = this.$store.getters.allAuthUser.accountInfoVO,
        entP = {
          path: "/console/account",
          query: { type: '6', account: '111' }
          // 为了兼容控制台layouts中的判断，这里无其他作用
        }, person = { path: "/tpl/Preferences" };
      if (current.corpUserId) {
        setCurrentUser(MAIN).finally(() => {
          this.$store.dispatch("setIgnoreChangePage", false);
          const _current = this.currentUser;
          const route = _current.userType === 0 ? person : entP
          let routeUrl = this.$router.resolve(route);
          this.$nextTick(() => {
            window.open(routeUrl.href, "_blank");
          })
        });
      } else {
        const route = current.userType === 0 ? person : entP
        let routeUrl = this.$router.resolve(route);
        console.log('current', current);
        window.open(routeUrl.href, "_blank");
      }
    },
    enclosureFilesHandleExceed (files, fileList) {
      return this.$message.error(
        `当前限制选择 30 个文件，本次选择了 ${files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    enclosureFilesError (err) {
      console.log(err);
      this.loadingClose();
    },
    /** 签署方是否含有发起方 */
    isMine(){
      const mine = this.signatoryJson.filter((sign)=>sign.sameCorpUser)
      return mine.length ? true : false
    },
    /** 选择签章 */
    selectChap(chap){
      // 没有值就选中，反之取消选中
      const have = this.chapterCheck.some((id)=> id === chap.corpSealId)
      if(!have) {
        this.chapterCheck.push(chap.corpSealId)
        return
      }
      this.chapterCheck.forEach((id,i)=>{
        if(chap.corpSealId === id){
          this.chapterCheck.splice(i,1)
        }
      })
    },
    /** 获取章列表 */
    getChapterList() {
      ApiCorpMethods.SealController.listSeals().then(res=>{
        if (res.success) {
          if (res.data) {
            let list = res.data || null;
            list.forEach(t => {
              t.signUrl = fileOperShow(t.sealFile);
            });
            console.log('list',list);
            this.chapterList = list;
            if (list.length) {
              this.chapterCheck.push(list[0].corpSealId)
            }
          } else {
            this.chapterList = [];
          }
        }
      });
    },
    /**
     * 骑缝章勾选change 判断是骑缝章的值
     * @value 0 不要企业和个人骑缝章（两个都不打钩） personSign==0 && enterpriseSign==0
     * @value 1 企业和个人都有骑缝章（两个都打钩）personSign==1 && enterpriseSign==1
     * @value 2 企业打钩个人不打钩 personSign==0 && enterpriseSign==1
     * @value 3 企业不打钩个人打钩 personSign==1 && enterpriseSign==0
     * */
    qifengChange (val) {
      let { personSign, enterpriseSign } = this.qiFengSign;
      if (personSign == 0 && enterpriseSign == 0)
        this.contractInfo.needQifengSign = 0;
      if (personSign == 1 && enterpriseSign == 1)
        this.contractInfo.needQifengSign = 1;
      if (personSign == 0 && enterpriseSign == 1)
        this.contractInfo.needQifengSign = 2;
      if (personSign == 1 && enterpriseSign == 0)
        this.contractInfo.needQifengSign = 3;
    },
    //获取系统时间，并默认签署链接失效时间为三天后
    getAndSetTime () {
      ApiMethods.SysController.getDate().then(res => {
        if (res.success) {
          let a = res.data;
          a = a.substr(0, a.lastIndexOf(":"));
          a = a.replace(/\-/g, "/");
          let three = new Date(a).getTime() + 3 * 24 * 60 * 60 * 1000;
          let ft = moment(new Date(three)).format("YYYY-MM-DD");
          this.signlinktime = ft;
        }
      });
    },

    pickTime (val) {
      let a = moment(val).format("YYYY-MM-DD");
      this.signlinktime = a;
    },

    // 判断集团账户是否有审批流
    hasApprovalFlow () {
      // 查询发起审批流
      let params = {};
      params.itemPage = 1;
      params.pageSize = 100;
      params.flowType = 0; // 流程类型0审批流程1用章流程
      ApiCorpMethods.CorpAuditContractController.pageFlow(params)
        .then(res => {
          if (res.code === "0") {
            this.approvalFlowList = res.data;
            if (this.approvalFlowList.length > 0) {
              this.hasApplyApproval = true;
            } else {
              this.hasApplyApproval = false;
            }
          } else {
            this.hasApplyApproval = false;
            this.$message.error(res.description || "查询审批流程数据失败");
          }
        })
        .catch(error => {
          this.hasApplyApproval = false;
          this.$message.error(error.description || "查询审批流程数据失败");
        });
    },

    handleChangeApprovalFlow (val) {
      let params = {};
      params.flowId = val;
      ApiCorpMethods.CorpAuditContractController.preFlowInst(params)
        .then(res => {
          if (res.code === "0") {
            // convert form data
            if (res.data) {
              let data = res.data;
              // flow
              if (data.partyList) {
                this.flows = data.partyList;
              }
              this.arrayCopior = [];
              if (data.copyToList) {
                (data.copyToList || []).forEach(i => {
                  i.hideRemove = true;
                  this.arrayCopior.push(i);
                });
              }
              if (data.orderFlag === 1) {
                this.flows.forEach((element, index) => {
                  if (this.flows.length - 1 !== index) {
                    element.hiddenArrow = true;
                  } else {
                    element.hiddenArrow = false;
                  }
                });
              } else {
                this.flows.forEach((element, index) => {
                  element.hiddenArrow = false;
                });
              }
            }
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.$message.error(error.description);
        });
    },
    // 批量签署方 修改签署人类型
    handleSignBatchUserType (signator, index) {
      this.getBatchUserInfoBySelectTargetId(signator.emailOrPhone, index);
    },
    changBatchUserShowNoticePhone (selectIndex) {
      let _showNoticePhone = !this.batchArray[selectIndex].showNoticePhone;
      let text = _showNoticePhone ? "添加" : "删除";
      this.$message(`${text}通知手机号`);
      this.$set(
        this.batchArray[selectIndex],
        `showNoticePhone`,
        _showNoticePhone
      );
      this.$set(this.batchArray[selectIndex], `alertMobile`, null);
    },
    // 批量签署方根据用户从table选择的签署人查询信息
    getBatchUserInfoBySelectTargetId (emailOrPhone, selectIndex) {
      if (selectIndex !== undefined) {
        this.selectIndex = selectIndex;
      }
      // 清空验证信息
      if (
        this.$refs["contractBatchListTab"] &&
        this.$refs["contractBatchListTab"][this.selectIndex]
      ) {
        this.$refs["contractBatchListTab"][this.selectIndex].clearValidate();
      } else {
        if (
          this.$refs["referenceSignerForm"] &&
          this.$refs["referenceSignerForm"].length > 0
        ) {
          this.$refs["referenceSignerForm"][this.selectIndex].clearValidate();
        }
      }

      if (emailOrPhone) {
        this.tableSignorSelectRowTargetID = emailOrPhone;
      }
      if (!emailOrPhone || !this.tableSignorSelectRowTargetID) {
        return;
      }
      let targetId = this.tableSignorSelectRowTargetID;
      if (happy.mobile.test(targetId) || happy.email.test(targetId)) {
        postFindByEmailOrMphon({targetId}).then(data => {
          if (data.data) {
            this.fillBatchSignorData(data.data);
          } else {
            this.fillBatchSignorData([]);
          }
        });
      } else {
        this.fillBatchSignorData([]);
      }
    },
    // 查询到结果后重新赋值
    fillBatchSignorData (canSelectArray) {
      let signor = undefined;
      this.batchArray.forEach((element, index) => {
        if (index === this.selectIndex) {
          signor = element;
        }
      });
      signor.errorMsg = "";
      this.$set(this.batchArray[this.selectIndex], `errorMsg`, "");
      if (
        this.$refs["contractBatchListTab"] &&
        this.$refs["contractBatchListTab"][this.selectIndex]
      ) {
        setTimeout(() => {
          this.$refs["contractBatchListTab"][this.selectIndex].validateField(
            "emailOrPhone"
          );
        });
      }
      if (canSelectArray.length === 0) {
        signor.signatoryFullName = "";
        signor.signatoryIdentityCard = "";
        signor.IDCard = "";
        signor.BusinessLicenseNo = "";
        signor.childUserName = "";
        signor.signatoryMobile = "";
        // signor.signatoryUserType = 0;

        signor.ischange = 0;
        signor.disabled = "";
        signor.handSign = signor.signatoryUserType === 0 ? 1 : 2;

        if (happy.email.test(signor.emailOrPhone)) {
          signor.isNoticePhone = true;
          if (signor.alertMobile) {
            signor.showNoticePhone = true;
          } else {
            signor.showNoticePhone = false;
          }
        } else {
          signor.isNoticePhone = false;
          signor.showNoticePhone = false;
          signor.alertMobile = "";
        }
      } else {
        let isEmptySignor = false;
        if (signor.signatoryUserType === 1) {
          canSelectArray = canSelectArray.filter(item => item.userType === 1);
          if (
            mobile.mobile.test(signor.emailOrPhone) &&
            canSelectArray.length === 0
          ) {
            isEmptySignor = true;
            signor.showNoticePhone = false;
            signor.alertMobile = "";

            //清空清空额外短信通知手机号
            // signor.isNoticePhone = false
            // signor.showNoticePhone = false
            // signor.alertMobile = ''
            //
            // signor.errorMsg = `该手机号已注册，但还未加入公司，请核实`;
            // if (this.$refs['contractBatchListTab'] && this.$refs['contractBatchListTab'][this.selectIndex]) {
            //   setTimeout(() => {
            //     this.$refs['contractBatchListTab'][this.selectIndex].fields[0].validateMessage = '该手机号已注册，但还未加入公司，请核实'
            //     this.$refs['contractBatchListTab'][this.selectIndex].fields[0].validateState = 'error'
            //   })
            // }
          }
          if (happy.email.test(signor.emailOrPhone)) {
            signor.isNoticePhone = true;
            if (signor.alertMobile) {
              signor.showNoticePhone = true;
            } else {
              signor.showNoticePhone = false;
            }
          }
        } else {
          // if(email.test(signor.emailOrPhone)){
          //   isEmptySignor = true;
          //   let canSelectArray0 = canSelectArray.filter(item => item.userType === 0)
          //   let canSelectArray1 = canSelectArray.filter(item => item.userType === 1)
          //   // findByEmailOrMphone数据请求有数据的时候，emailOrPhone是邮箱，类型是个人的时候，清空额外短信通知手机号
          //   if(canSelectArray0.length === 0 && canSelectArray1.length > 0){
          //     signor.isNoticePhone = false
          //     signor.showNoticePhone = false
          //     signor.alertMobile = ''

          //     // signor.errorMsg = `该邮箱已注册为企业用户，请核实`;
          //     // if (this.$refs['contractBatchListTab'] && this.$refs['contractBatchListTab'][this.selectIndex]) {
          //     //   this.$refs['contractBatchListTab'][this.selectIndex].fields[0].validateMessage = '该邮箱已注册为企业用户，请核实'
          //     //   this.$refs['contractBatchListTab'][this.selectIndex].fields[0].validateState = 'error'
          //     // }
          //   }else{
          //     signor.isNoticePhone = true
          //     if(signor.alertMobile){
          //       signor.showNoticePhone = true
          //     }else{
          //       signor.showNoticePhone = false
          //     }
          //   }
          // }
          // if(mobile.test(signor.emailOrPhone)){
          //   signor.isNoticePhone = false
          //   signor.showNoticePhone = false
          //   signor.alertMobile = ''
          // }
          signor.isNoticePhone = false;
          signor.showNoticePhone = false;
          signor.alertMobile = "";
          canSelectArray = canSelectArray.filter(item => item.userType === 0);
          if (canSelectArray.length === 0) {
            isEmptySignor = true;
          }
        }
        if (isEmptySignor) {
          signor.signatoryFullName = "";
          signor.signatoryIdentityCard = "";
          signor.IDCard = "";
          signor.BusinessLicenseNo = "";
          signor.childUserName = "";
          signor.signatoryMobile = "";
          // signor.signatoryUserType = 0;

          signor.ischange = 0;
          signor.disabled = "";
          signor.handSign = signor.signatoryUserType === 0 ? 1 : 2;
        } else {
          let current = this.$store.getters.currentAuthUser;
          let corpId = "";
          if (current) {
            corpId = current.corpId;
          }
          // 默认选择第一个
          signor.canSelectArrayIndex = 0;
          canSelectArray.forEach((element, index) => {
            if (element.corpId && element.corpId === corpId) {
              signor.canSelectArrayIndex = index;
              signor.corpUser = true;
            }
          });

          let v = canSelectArray[signor.canSelectArrayIndex];
          signor.signatoryFullName = v.name;
          signor.signatoryIdentityCard = v.businessLicense || v.identityCard;
          signor.IDCard = v.userType === 0 ? v.identityCard : "";
          signor.BusinessLicenseNo = v.userType === 0 ? "" : v.businessLicense;

          signor.childUserName = "";
          signor.signatoryMobile = "";

          // signor.signatoryUserType = v.userType;
          if (signor.signatoryUserType === 1) {
            signor.childUserName = v.corpUser; // corpUser集团账户的值
          } else {
            signor.signatoryMobile = signor.emailOrPhone;
          }
          signor.ischange = 1;
          signor.disabled = "disabled";
          if (signor.corpUser) {
            signor.handSign = 0;
          } else {
            signor.handSign = v.userType === 0 ? 1 : 2;
          }
        }
      }
      this.batchArray.forEach((element, index) => {
        if (index === this.selectIndex) {
          signor.canSelectArray = canSelectArray;
          element = signor;
        }
      });
      this.getIsSaveDisable();
    },
    getIsSaveDisable () {
      let _isSaveDisable1 = false,
        _isSaveDisable2 = false,
        _isSaveDisable = false;
      this.signatoryJson.forEach((element, index) => {
        if (element.errorMsg) {
          _isSaveDisable1 = true;
        }
      });
      this.batchArray.forEach((element, index) => {
        if (element.errorMsg) {
          _isSaveDisable2 = true;
        }
      });
      if (_isSaveDisable1 || _isSaveDisable2) {
        _isSaveDisable = true;
      }
      this.isSaveDisable = _isSaveDisable;
    },
    // 批量签署方添加
    batchAdd () {
      if (this.batchArray.length === 100) {
        this.$message.info("单独签署方上限为100个");
        return;
      }
      this.batchArray.push({
        emailOrPhone: "",
        childUserName: "",
        signatoryMobile: "",

        signatoryFullName: "",
        signatoryIdentityCard: "",
        signatoryUserType: 0,

        authLevel: 11,
        handSign: 0,

        chapteJson: null,
        // 新增集团账户 数组
        canSelectArray: [],
        canSelectArrayIndex: 0,

        IDCard: "",
        BusinessLicenseNo: "",
        ischange: 0,
        notRegister: true,
        disabled: "",
        openUserTab: false,
        isEncrypt: false
      });
    },
    // 批量导入
    batchImport () {
      let importBatchFile = this.$refs["importBatchFile"];
      if (importBatchFile) {
        importBatchFile.value = "";
      }
      if (this.batchArray.length > 0) {
        this.$confirm("导入前将清空当前批量签署方, 是否继续导入", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.batchArray = [];
            if (this.$refs["importBatchFile"]) {
              this.$refs["importBatchFile"].click();
            }
          })
          .catch(() => { });
      } else {
        if (this.$refs["importBatchFile"]) {
          this.$refs["importBatchFile"].click();
        }
      }
    },
    batchFileChange () {
      this.batchLoading = true;
      let importBatchFile = this.$refs["importBatchFile"];
      let files = importBatchFile.files;
      if (files.length > 0) {
        let file = files[0];
        let name = file.name;
        let suffix = name.substring(name.lastIndexOf("."));
        if (suffix === ".xlsx" || suffix === ".xls") {
          let params = new FormData();
          params.append("excel ", file);
          ApiCorpMethods.BatchContractController.uploadBatch(params)
            .then(res => {
              if (res.success) {
                let data = res.data;
                this.batchArray = [];
                if (data) {
                  for (let index = 0; index < data.length; index++) {
                    const element = data[index];
                    if (this.batchArray.length === 100) {
                      break;
                    }
                    let signor = {
                      emailOrPhone: "",
                      childUserName: "",
                      signatoryMobile: "",

                      signatoryFullName: "",
                      signatoryIdentityCard: "",
                      signatoryUserType: 0,

                      authLevel: 11,
                      handSign: 0,

                      chapteJson: null,
                      // 新增集团账户 数组
                      canSelectArray: [],
                      canSelectArrayIndex: 0,

                      IDCard: "",
                      BusinessLicenseNo: "",
                      ischange: 0,
                      notRegister: true,
                      disabled: "",
                      openUserTab: false,
                      isEncrypt: false
                    };

                    let targetId = element.targetId;
                    signor.emailOrPhone = targetId;
                    let isPhone = false;
                    if (/^\d{11}$/.test(targetId)) {
                      isPhone = true;
                    }

                    // 初始化额外发送手机号
                    signor.isNoticePhone = false;
                    signor.showNoticePhone = false;
                    signor.alertMobile = "";

                    signor.signatoryFullName = element.name;
                    signor.signatoryIdentityCard = element.idNo;
                    let userType = isPhone ? 0 : 1;

                    signor.IDCard = userType === 0 ? element.idNo : "";
                    signor.BusinessLicenseNo =
                      userType === 0 ? "" : element.idNo;

                    signor.childUserName = "";
                    signor.signatoryMobile = "";

                    signor.signatoryUserType = userType;
                    if (signor.signatoryUserType === 1) {
                      signor.childUserName = targetId;
                    } else {
                      signor.signatoryMobile = targetId;
                    }
                    // 选择签章类型 handSign
                    // if (element.handSign !== undefined || element.handSign !== null) {
                    //   if (userType === 0) {
                    //     if (element.handSign === 0 || element.handSign === 1) {
                    //       signor.handSign = element.handSign;
                    //     } else {
                    //       signor.handSign = 0;
                    //     }
                    //   } else {
                    //     if (element.handSign === 1 || element.handSign === 2) {
                    //       signor.handSign = element.handSign;
                    //     } else {
                    //       signor.handSign = 1;
                    //     }
                    //   }
                    //
                    // } else {
                    //   signor.handSign = userType === 0 ? 1 : 2;
                    // }
                    // 固定签章类型
                    signor.handSign = userType === 0 ? 1 : 2;
                    // 选择验证方式
                    // if (element.authLevel === null || element.authLevel === 2 || element.authLevel === 10 || element.authLevel === 11) {
                    //   signor.authLevel = element.authLevel;
                    // } else {
                    //   signor.authLevel = null;
                    // }

                    //只有人脸
                    signor.authLevel = element.authLevel ? 11 : null;

                    this.batchArray.push(signor);
                  }

                  if (data.length > 100) {
                    this.$confirm(
                      `成功导入${this.batchArray.length}条，剩余${data.length -
                      this.batchArray.length}条未被导入(批量签署方上限100)`,
                      "系统提示",
                      {
                        confirmButtonText: "确定",
                        type: "warning",
                        showCancelButton: false
                      }
                    )
                      .then(() => { })
                      .catch(() => { });
                  } else {
                    this.$confirm(
                      `共导入${this.batchArray.length}条数据`,
                      "系统提示",
                      {
                        confirmButtonText: "确定",
                        type: "warning",
                        showCancelButton: false
                      }
                    )
                      .then(() => { })
                      .catch(() => { });
                  }

                  // 手动数据库验证
                  // this.$nextTick(()=> {
                  // 	if (this.$refs['batchInputEmailOrPhone']) {
                  // 		this.$refs['batchInputEmailOrPhone'].forEach((element, k) => {
                  // 			setTimeout(() => {
                  // 				element.focus()
                  // 				element.blur()
                  // 			}, 200*(k+1))
                  // 		})
                  // 	}
                  // })

                  this.batchLoading = false;
                }
              } else {
                this.batchLoading = false;
                this.$message.error(res.description || "导入文件失败.");
              }
            })
            .catch(error => {
              this.$message.error(error.description || "导入文件失败.");
              this.batchLoading = false;
            });
        } else {
          this.$message.warning("文件格式不正确.");
          this.batchLoading = false;
        }
      } else {
        this.batchLoading = false;
      }
    },
    // 批量删除全部
    batchClearAll () {
      this.$confirm("是否删除所有已添加的批量签署方？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.batchArray = [];
          let importBatchFile = this.$refs["importBatchFile"];
          if (importBatchFile) {
            importBatchFile.value = "";
          }
          this.$message.success('操作成功！')
        })
        .catch(() => { });
    },
    // 批量删除
    batchClear (index) {
      if (this.batchArray[index]) {
        this.batchArray.splice(index, 1);
      }
    },
    // 下载模板
    downloadTemplate () {
      let www =
        this.globalConfig.domain.junziqianWebOp + "/batch-template.xlsx";
      if (isInDingTalk) {
        this.DINGSDK && this.DINGSDK.downloadFile({
          url: www,
          success: (res) => {
            const { filePath } = res;
          },
          fail: () => { },
          complete: () => { },
        });
      } else { window.open(www); }
    },
    // changeCheckedBatch
    // 批量签署方 checkbox
    changeCheckedBatch (val) {
      let index = this.findSignatoryJsonBatchIndex();
      if (val) {
        // 添加
        if (index === undefined) {
          this.signatoryJson.push({
            signOwner: "批量签署方",
            chapteJson: null
          });
        }
      } else {
        // 删除
        if (index !== undefined) {
          this.signatoryJson.splice(index, 1);
        }
      }
    },
    // 查找批量签署方的index
    findSignatoryJsonBatchIndex () {
      let index = undefined;
      if (this.signatoryJson) {
        this.signatoryJson.forEach((element, i) => {
          if (element.signOwner === "批量签署方") {
            index = i;
          }
        });
      }
      return index;
    },

    // visibleChangeSelect
    visibleChangeSelect (val) {
      this.visibleChangeSelectStatus = false;
    },

    /**
     * 20200521新增功能
     * 签署方名称改变时，更新页面中签章对应的签署方名称
     * @signOwner 签署方一二三，根据signOwner找到对应的签章更新
     * @signatoryFullName 需要更改的签署方名称
     * */
    changeQSNameInQZ (signOwner, signatoryFullName) {
      this.chapteJson.map(item => {
        if (item.signOwner === signOwner) {
          item.qsInfo = signatoryFullName; // 更改显示的签署方姓名
        }
      });
    },

    // 集团账户选择触发事件
    handleSelectCorpAccount (value, item) {
      const mine = this.signatoryJson.filter((sign)=>sign.sameCorpUser)
      if(!mine.length){
        this.chapterCheck = []
      }
      if (value === "ManualInput") {
        // 新需求，新增手动输入
        item.signatoryFullName = "";
        item.signatoryIdentityCard = "";
        item.IDCard = "";
        item.childUserName = "";
        item.signatoryMobile = "";
        item.ischange = 0;
        item.disabled = "";
        item.handSign = 0;
        item.corpUser = false;
        item.signatoryUserType = 1;
        item.BusinessLicenseNo = "";
        item.ManualInput = true; // 标志启用手动输入
      } else {
        let v = item.canSelectArray[value];
        if (v.corpUser) {
          item.corpUser = true;
          item.handSign = 0;
          item.sameCorpUser = v.sameCorpUser ? v.sameCorpUser : null
        } else {
          item.corpUser = false;
          item.handSign = v.userType === 0 ? 1 : 2;
        }

        item.signatoryMobile = "";
        item.childUserName = "";
        item.signatoryUserType = v.userType;
        item.ischange = 1;
        item.disabled = "disabled";
        item.signatoryFullName = v.name;
        item.signatoryIdentityCard = v.businessLicense || v.identityCard;
        if (item.signatoryUserType === 1) {
          item.BusinessLicenseNo = v.businessLicense;
          item.IDCard = "";
          item.childUserName = v.corpUser;
        } else {
          item.IDCard = v.identityCard;
          item.BusinessLicenseNo = "";
          item.signatoryMobile = item.emailOrPhone;
        }
        if(item.sameCorpUser && this.chapterCheck.length === 0){
          const len = this.chapterList.length;
          if(len) this.chapterCheck.push(this.chapterList[0].corpSealId)
        }
      }

      this.changeQSNameInQZ(item.signOwner, item.signatoryFullName); // 签署方名称改变时，更新页面中签章对应的签署方名称
    },
    // 选择通讯录和我的组织里面的人 确认按钮事件
    handleClickSelectSignorOk () {
      if (this.activeTabSigner === "organization") {
        this.tableSignorSelectRow = undefined;
      }

      if (
        this.$refs["contractListTab"] &&
        this.$refs["contractListTab"][this.selectIndex]
      ) {
        this.$refs["contractListTab"][this.selectIndex].clearValidate();
      } else {
        if (
          this.$refs["referenceSignerForm"] &&
          this.$refs["referenceSignerForm"].length > 0
        ) {
          this.$refs["referenceSignerForm"][this.selectIndex].clearValidate();
        }
      }

      // 复制以前的代码 怕报错
      /*********************************** */
      this.showTel = false;
      this.telPageInfo.accountNo = null;
      this.telPageInfo.name = null;
      this.telPageInfo.idNo = null;
      this.telPageInfo.itemPage = 1;
      // return openUserTab to false
      if (this.signatoryJson[this.selectIndex]) {
        this.signatoryJson[
          this.selectIndex
        ].emailOrPhone = this.tableSignorSelectRowTargetID;
        // this.signatoryJson[this.selectIndex].openUserTab = false
      }

      /*********************************** */
      this.getUserInfoBySelectTargetId(
        this.tableSignorSelectRowTargetID,
        this.selectIndex,
        true
      );
    },
    // 根据用户从table选择的签署人查询信息 type 是否改变签署人类型
    getUserInfoBySelectTargetId (emailOrPhone, selectIndex, type = false) {
      if (selectIndex !== undefined) {
        this.selectIndex = selectIndex;
      }

      // 清空验证信息
      if (
        this.$refs["contractListTab"] &&
        this.$refs["contractListTab"][this.selectIndex]
      ) {
        this.$refs["contractListTab"][this.selectIndex].clearValidate();
      }

      if (emailOrPhone) {
        this.tableSignorSelectRowTargetID = emailOrPhone;
      }
      if (!emailOrPhone || !this.tableSignorSelectRowTargetID) {
        return;
      }
      let targetId = this.tableSignorSelectRowTargetID;
      const {corpUserId} = this.$store.getters.currentAuthUser,params = {targetId}
          // 是成员账号就传corpUserId
        if(corpUserId) params.corpUserId = corpUserId
      if (happy.mobile.test(targetId) || happy.email.test(targetId)) {
        postFindByEmailOrMphon(params)
          .then(data => {
            if (data.data) {
              this.fillSignorData(data.data, type);
            } else {
              this.fillSignorData([], type);
            }
          })
          .catch(err => {
            this.$message.error(err.description);
          });
      } else {
        this.fillSignorData([], type);
      }
    },
    changShowNoticePhone (selectIndex) {
      let _showNoticePhone = !this.signatoryJson[selectIndex].showNoticePhone;
      this.$set(
        this.signatoryJson[selectIndex],
        `showNoticePhone`,
        _showNoticePhone
      );
      this.$set(this.signatoryJson[selectIndex], `alertMobile`, null);
    },
    // 查询到结果后重新赋值
    fillSignorData (canSelectArray, type) {
      let signor = undefined;
      this.signatoryJson.forEach((element, index) => {
        if (index === this.selectIndex) {
          signor = element;
        }
      });

      if (
        this.$refs["contractListTab"] &&
        this.$refs["contractListTab"][this.selectIndex]
      ) {
        setTimeout(() => {
          this.$refs["contractListTab"][this.selectIndex].validateField(
            "emailOrPhone"
          );
        });
      }
      signor.errorMsg = "";
      this.$set(this.signatoryJson[this.selectIndex], `errorMsg`, "");

      if (canSelectArray.length === 0) {
        // 按照以前老版本改
        if (this.tableSignorSelectRow) {
          // 有值
          // businessLicense: "155454526254523"	证件号
          // enterpriseName: "15545"	签署方名称
          // mobileOrChild: "13896918730"	联系方式
          let targetId = this.tableSignorSelectRow.mobileOrChild;
          let isPhone = false;
          if (happy.mobile.test(targetId)) {
            isPhone = true;
          }

          signor.signatoryFullName = this.tableSignorSelectRow.enterpriseName;
          signor.signatoryIdentityCard = this.tableSignorSelectRow.businessLicense;
          let userType = isPhone ? 0 : 1;

          signor.IDCard =
            userType === 0 ? this.tableSignorSelectRow.businessLicense : "";
          signor.BusinessLicenseNo =
            userType === 0 ? "" : this.tableSignorSelectRow.businessLicense;

          signor.childUserName = "";
          signor.signatoryMobile = "";
          signor.signatoryUserType = userType;
          if (signor.signatoryUserType === 1) {
            signor.childUserName = targetId;
          } else {
            signor.signatoryMobile = targetId;
          }
          signor.ischange = 1;
          signor.disabled = "disabled";
          signor.handSign = userType === 0 ? 1 : 2;

          // 通讯录选择的时候隐藏清空额外短信通知手机号
          signor.isNoticePhone = false;
          signor.showNoticePhone = false;
          signor.alertMobile = "";
        } else {
          // 没有值
          // 下面这是清空的

          // signatoryFullName: 签署方名称, signatoryIdentityCard: 证件号, childUserName: 企业联系, signatoryMobile: 个人联系

          signor.signatoryFullName = "";
          signor.signatoryIdentityCard = "";
          signor.IDCard = "";
          signor.BusinessLicenseNo = "";
          signor.childUserName = "";
          signor.signatoryMobile = "";
          // signor.signatoryUserType = 0;

          signor.ischange = 0;
          signor.disabled = "";
          signor.handSign = signor.signatoryUserType === 0 ? 1 : 2;
          // findByEmailOrMphone数据请求没有数据的时候，emailOrPhone是邮箱就显示额外短信通知手机号
          if (happy.email.test(signor.emailOrPhone)) {
            signor.isNoticePhone = true;
            if (signor.alertMobile) {
              signor.showNoticePhone = true;
            } else {
              signor.showNoticePhone = false;
            }
          } else {
            signor.isNoticePhone = false;
            signor.showNoticePhone = false;
            signor.alertMobile = "";
          }
        }
      } else {
        // 是否允许改变签署人类型
        if (type) {
          let current = this.$store.getters.currentAuthUser;
          let corpId = "";
          if (current) {
            corpId = current.corpId;
          }
          // 默认选择第一个
          signor.canSelectArrayIndex = 0;
          canSelectArray.forEach((element, index) => {
            if (element.corpId && element.corpId === corpId) {
              signor.canSelectArrayIndex = index;
              signor.corpUser = true;
            }
          });

          let v = canSelectArray[signor.canSelectArrayIndex];
          signor.signatoryFullName = v.name;
          signor.signatoryIdentityCard = v.businessLicense || v.identityCard;
          signor.IDCard = v.userType === 0 ? v.identityCard : "";
          signor.BusinessLicenseNo = v.userType === 0 ? "" : v.businessLicense;
          signor.sameCorpUser = v.sameCorpUser ? v.sameCorpUser : null
          signor.childUserName = "";
          signor.signatoryMobile = "";

          signor.signatoryUserType = v.userType;

          if (signor.signatoryUserType === 1) {
            signor.childUserName = v.corpUser;
            canSelectArray = canSelectArray.filter(item => item.userType === 1);
            // emailOrPhone是邮箱就显示额外短信通知手机号
            if (happy.email.test(signor.emailOrPhone)) {
              signor.isNoticePhone = true;
              if (signor.alertMobile) {
                signor.showNoticePhone = true;
              } else {
                signor.showNoticePhone = false;
              }
            } else {
              signor.isNoticePhone = false;
              signor.showNoticePhone = false;
              signor.alertMobile = "";
            }
          } else {
            signor.signatoryMobile = signor.emailOrPhone;
            canSelectArray = canSelectArray.filter(item => item.userType === 0);
            signor.isNoticePhone = false;
            signor.showNoticePhone = false;
            signor.alertMobile = "";
          }
          // canSelectArray改变需要更新canSelectArrayIndex
          let rindex = canSelectArray.findIndex(
            element => element.corpId && element.corpId === corpId
          );
          signor.canSelectArrayIndex = rindex >= 0 ? rindex : 0; // 没有默认选中第一个

          signor.ischange = 1;
          signor.disabled = "disabled";
          if (signor.corpUser) {
            signor.handSign = 0;
          } else {
            signor.handSign = v.userType === 0 ? 1 : 2;
          }
        } else {
          let isEmptySignor = false;
          if (signor.signatoryUserType === 1) {
            canSelectArray = canSelectArray.filter(item => item.userType === 1);
            if (
              happy.mobile.test(signor.emailOrPhone) &&
              canSelectArray.length === 0
            ) {
              isEmptySignor = true;
              signor.showNoticePhone = false;
              signor.alertMobile = "";
              // //清空清空额外短信通知手机号
              // signor.isNoticePhone = false
              // signor.showNoticePhone = false
              // signor.alertMobile = ''
              //
              // signor.errorMsg = `该手机号已注册，但还未加入公司，请核实`;
              // if (this.$refs['contractListTab'] && this.$refs['contractListTab'][this.selectIndex]) {
              //   setTimeout(() => {
              //     this.$refs['contractListTab'][this.selectIndex].fields[0].validateMessage = '该手机号已注册，但还未加入公司，请核实'
              //     this.$refs['contractListTab'][this.selectIndex].fields[0].validateState = 'error'
              //   })
              // }
            }
            if (happy.email.test(signor.emailOrPhone)) {
              signor.isNoticePhone = true;
              if (signor.alertMobile) {
                signor.showNoticePhone = true;
              } else {
                signor.showNoticePhone = false;
              }
            }
          } else {
            signor.isNoticePhone = false;
            signor.showNoticePhone = false;
            signor.alertMobile = "";
            canSelectArray = canSelectArray.filter(item => item.userType === 0);
            if (canSelectArray.length === 0) {
              isEmptySignor = true;
            }
          }
          if (isEmptySignor) {
            signor.signatoryFullName = "";
            signor.signatoryIdentityCard = "";
            signor.IDCard = "";
            signor.BusinessLicenseNo = "";
            signor.childUserName = "";
            signor.signatoryMobile = "";

            signor.ischange = 0;
            signor.disabled = "";
            signor.handSign = signor.userType === 0 ? 1 : 2;
          } else {
            let current = this.$store.getters.currentAuthUser;
            let corpId = "";
            if (current) {
              corpId = current.corpId;
            }
            // 默认选择第一个
            signor.canSelectArrayIndex = 0;
            canSelectArray.forEach((element, index) => {
              if (element.corpId && element.corpId === corpId) {
                signor.canSelectArrayIndex = index;
                signor.corpUser = true;
              }
            });

            let v = canSelectArray[signor.canSelectArrayIndex];
            signor.signatoryFullName = v.name;
            signor.signatoryIdentityCard = v.businessLicense || v.identityCard;
            signor.IDCard = v.userType === 0 ? v.identityCard : "";
            signor.BusinessLicenseNo =
              v.userType === 0 ? "" : v.businessLicense;

            signor.childUserName = "";
            signor.signatoryMobile = "";
            if (happy.email.test(signor.emailOrPhone)) {
              signor.isNoticePhone = true;
            } else {
              signor.isNoticePhone = false;
              signor.showNoticePhone = false;
              signor.alertMobile = "";
            }
            if (signor.signatoryUserType === 1) {
              signor.childUserName = v.corpUser;
            } else {
              signor.signatoryMobile = signor.emailOrPhone;
            }

            signor.ischange = 1;
            signor.disabled = "disabled";
            if (signor.corpUser) {
              signor.handSign = 0;
            } else {
              signor.handSign = v.userType === 0 ? 1 : 2;
            }
          }
        }
      }

      signor.ManualInput = false; // 重置手动输入
      this.signatoryJson.forEach((element, index) => {
        if (index === this.selectIndex) {
          signor.canSelectArray = canSelectArray;
          element = signor;
        }
      });
      this.getIsSaveDisable();
      this.tableSignorSelectRow = undefined;
      this.changeQSNameInQZ(signor.signOwner, signor.signatoryFullName);
    },
    // 我的组织 选择签署人 点击事件
    handleRowClickMyCorp (row, event, column) {
      if (row) {
        this.tableSignorSelectRowTargetID = row.targetId;
      } else {
        this.tableSignorSelectRowTargetID = "";
      }
    },
    // 我的组织 查询签署人
    clickHandleMyCorpSearch () {
      this.queryToolMyCorp();
    },
    // 查询我的组织 签署人列表
    queryToolMyCorp () {
      this.myCorpModel.loading = true;
      this.tableAuditAndCopySelectRow = undefined;
      // if (!this.myCorpModel.keyword) {
      this.myCorpModel.targetId = this.myCorpModel.keyword;
      ApiCorpMethods.CorpCommonController.listCorpUser(this.myCorpModel)
        .then(res => {
          this.myCorpModel.loading = false;
          if (res.code === "0") {
            this.tableListMyCorp = res.data;
            this.myCorpModel.total = res.total;
            if (res.total === 0) {
              this.myCorpModel.emptyText = "暂无数据";
            }
          } else {
            this.tableListMyCorp = [];
            this.myCorpModel.total = 0;
            this.myCorpModel.emptyText = res.description;
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.myCorpModel.loading = false;
          this.tableListMyCorp = [];
          this.myCorpModel.total = 0;
          this.myCorpModel.emptyText = res.description;
          this.$message.error(err.description);
        });
      // } else {
      // this.myCorpModel.loading = false;
      // this.tableListMyCorp = [];
      // this.myCorpModel.total = 0;
      // this.myCorpModel.emptyText = '请输入组织内部签署方名称或账号';
      // }
    },
    handleSizeChangeQueryToolMyCorp (val) {
      this.myCorpModel.itemPage = 1;
      this.myCorpModel.pageSize = val;
      this.queryToolMyCorp();
    },
    handleCurrentChangeQueryToolMyCorp (val) {
      this.myCorpModel.itemPage = val;
      this.queryToolMyCorp();
    },

    // 移除抄送人
    handleClickRemoveArrayCopior (index) {
      this.arrayCopior.splice(index, 1);
    },
    // 添加审批人或者抄送人
    clickHandleAddAuditorOrCopyer (type) {
      this.auditAndCopyActive = type;
      if (type) {
        // 审批人
        this.auditAndCopyTitle = "添加审批人";
      } else {
        // 抄送人
        this.auditAndCopyTitle = "添加抄送人";
      }
      // 清空
      this.auditAndCopyModel.keyword = "";
      this.clickHandleAuditorOrCopyerSearch();
      this.queryToolMyCorp();
      this.visibleAuditAndCopy = true;
    },
    // 查询按钮
    clickHandleAuditorOrCopyerSearch () {
      if (this.auditAndCopyActive) {
        // 审批人
        this.auditAndCopyTitle = "添加审批人";
      } else {
        // 抄送人
        this.auditAndCopyTitle = "添加抄送人";
      }
      this.queryToolAuditAndCopy();
    },
    // 查询审批人 抄送人列表
    queryToolAuditAndCopy () {
      this.auditAndCopyModel.loading = true;
      this.tableAuditAndCopySelectRow = undefined;
      if (this.auditAndCopyModel.keyword) {
        this.auditAndCopyModel.targetId = this.auditAndCopyModel.keyword;
        ApiCorpMethods.CorpCommonController.listCorpUser(this.auditAndCopyModel)
          .then(res => {
            this.auditAndCopyModel.loading = false;
            if (res.code === "0") {
              this.tableListAuditAndCopy = res.data;
              this.auditAndCopyModel.total = res.total;
              if (res.total === 0) {
                this.auditAndCopyModel.emptyText = "暂无数据";
              }
            } else {
              this.tableListAuditAndCopy = [];
              this.auditAndCopyModel.total = 0;
              this.auditAndCopyModel.emptyText = res.description;
              this.$message.error(res.description);
            }
          })
          .catch(error => {
            this.auditAndCopyModel.loading = false;
            this.tableListAuditAndCopy = [];
            this.auditAndCopyModel.total = 0;
            this.auditAndCopyModel.emptyText = res.description;
            this.$message.error(err.description);
          });
      } else {
        this.auditAndCopyModel.loading = false;
        this.tableListAuditAndCopy = [];
        this.auditAndCopyModel.total = 0;
        this.auditAndCopyModel.emptyText = "请输入组织内部签署方名称或账号";
      }
    },
    handleSizeChangeQueryToolAuditAndCopy (val) {
      this.auditAndCopyModel.itemPage = 1;
      this.auditAndCopyModel.pageSize = val;
      this.queryToolAuditAndCopy();
    },
    handleCurrentChangeQueryToolAuditAndCopy (val) {
      this.auditAndCopyModel.itemPage = val;
      this.queryToolAuditAndCopy();
    },
    // 添加审批人抄送人table row click event
    handleRowClickAuditAndCopy (row, event, column) {
      this.tableAuditAndCopySelectRow = row;
    },
    // 添加审批人或者抄送人
    clickHandleAddAuditorOrCopyerSubmit () {
      if (this.auditAndCopyActive) {
        // 审批人
      } else {
        // 抄送人
        this.auditAndCopyTitle = "添加抄送人";
        if (!this.tableAuditAndCopySelectRow) {
          this.$message.error("请选择抄送人");
          return;
        } else {
          let isExist = false;
          for (let index = 0; index < this.arrayCopior.length; index++) {
            const element = this.arrayCopior[index];
            if (
              element.corpUserIdSec ===
              this.tableAuditAndCopySelectRow.corpUserIdSec
            ) {
              isExist = true;
            }
          }
          if (!isExist) {
            this.arrayCopior.push(
              JSON.parse(JSON.stringify(this.tableAuditAndCopySelectRow))
            );
            this.$message.success("抄送人添加成功");
          } else {
            this.$message.info("审批人已经存在,无需重复添加");
          }
        }
      }
    },

    validContractName: function () {
      if (this.contractInfo.contractName.length > 100) {
        return this.$message.warning("合同名称不能超过一百个字符");
      }
    },

    // 查询用户是否有视频签署套餐
    queryUserHasVideoPackage () {
      VideoSign.hasVideoPackage()
        .then(({ data }) => {
          this.hasVideoPackage = data;
        })
        .catch(err => {
          this.hasVideoPackage = false;
        });
    },
    // 取消合同发起或保存
    handleDelSendContract () {
      this.signatoryJson.forEach(t => {
        var entName = t.signatoryFullName;
        if (this.entNameArr.indexOf(entName) !== -1) {
          t.signatoryIdentityCard = "";
        }
      });
      this.entCreditArr = [];
      this.entCreditJson = {};
      this.entNameArr = [];
      this.userIdentityInfoArr = [];
      this.visibleCredit = false;
    },
    // 合同提交发送 发起或保存到草稿箱saveToDraftBox 0发起 1保存
    sendContractToCreate (saveToDraftBox) {
      // 集团账户 如果有审批流程 需要添加审批流程
      if (
        this.isGroup &&
        this.checkedBatch === false &&
        this.hasApplyApproval === true
      ) {
        if (
          this.approvalFlowList.length > 0 &&
          this.approvalFlowSelect === undefined
        ) {
          this.$message.error("请选择审批流程");
          return;
        }
      }
      if (this.checkedBatch === true) {
        if (this.batchArray.length === 0) {
          this.$message.warning("请添加批量签署方");
          return false;
        }
      }

      if (
        this.$refs["contractBatchListTab"] &&
        this.$refs["contractBatchListTab"][this.selectIndex]
      ) {
        this.$refs["contractBatchListTab"][this.selectIndex].clearValidate();
      } else {
        if (
          this.$refs["referenceSignerForm"] &&
          this.$refs["referenceSignerForm"].length > 0
        ) {
          this.$refs["referenceSignerForm"][this.selectIndex].clearValidate();
        }
      }

      // 验证填写信息
      this.$refs.contForm.validate(valid => {
        if (valid) {
          if (
            !this.contractInfo.contractName ||
            this.contractInfo.contractName === ""
          )
            return this.$message.warning("请输入合同名称");
          if (this.contractInfo.contractName.length > 100)
            return this.$message.warning("合同名称不能超过一百个字符");
          if (
            parseInt(this.contractInfo.needCa) === 1 &&
            [1, 2, 3].includes(parseInt(this.contractInfo.needQifengSign))
          )
            return this.$message.error("君子盾暂不支持骑缝章");
          if (
            parseInt(this.contractInfo.needVideoSign) === 1 &&
            this.signatoryJson.length !== 2
          )
            return this.$message.error("视频签只允许有两个手动签署方");

          this.signatoryJson.forEach(item => {
            if (item.faceOrVideo == 1 && item.videoSignUserType != 2) {
              item.videoSignUserType = item.faceOrVideo;
            }
            // 将签署设置中的 个人图形章 推入每一个 个人签署方 signLevel 字段中
            if (item.signatoryUserType === 0 && !item.forge) {
              // 【signLevel】 个人图形章，签署方个人  0 ->图形章 1->手写章
              // 【personImgSign】 是否使用图形章 1 使用 0不使用
              item.signLevel = this.personImgSign ? 0 : 1;
            }
          });

          let validChild = true;
          let rulesTab = this.$refs.contractListTab;

          if (rulesTab) {
            rulesTab.forEach(t => {
              if (t.validate) {
                t.validate(() => { });
              }
            });
            try {
              rulesTab.forEach(t => {
                if (t.fields) {
                  const fields = t.fields;
                  if (fields) {
                    fields.forEach(element => {
                      if (
                        element.prop !== "" &&
                        element.validateState === "error"
                      ) {
                        throw new Error("validFails");
                      }
                    });
                  }
                }
              });
            } catch (error) {
              validChild = false;
            }
          }

          // 验证批量签署方form表单列表
          let validChildBatch = true;
          let contractBatchListTab = this.$refs.contractBatchListTab;
          if (contractBatchListTab) {
            contractBatchListTab.forEach(t => {
              t.validate(() => { });
            });
            try {
              contractBatchListTab.forEach(t => {
                const fields = t.fields;
                if (fields) {
                  fields.forEach(element => {
                    if (
                      element.prop !== "" &&
                      element.validateState === "error"
                    ) {
                      throw new Error("validFails");
                    }
                  });
                }
              });
            } catch (error) {
              validChildBatch = false;
            }
          }

          // 证件号合二为一 针对新用户
          this.signatoryJson.forEach(t => {
            if (!t.signatoryIdentityCard) {
              if (parseInt(t.signatoryUserType) === 1) {
                t.signatoryIdentityCard = t.BusinessLicenseNo;
              } else {
                t.signatoryIdentityCard = t.IDCard;
              }
            }
            // if (!t.childUserName && !t.signatoryMobile) {
            //   if (parseInt(t.signatoryUserType) === 1) {
            //     t.childUserName = t.emailOrPhone;
            //   } else {
            //     t.signatoryMobile = t.emailOrPhone;
            //   }
            // }
            if (!t.childUserName && parseInt(t.signatoryUserType) === 1) {
              t.childUserName = t.emailOrPhone;
            }

            if (parseInt(t.signatoryUserType) === 0) {
              if (happy.email.test(t.emailOrPhone)) {
                if (t.alertMobile) {
                  t.signatoryMobile = t.alertMobile;
                } else {
                  t.signatoryMobile = t.emailOrPhone;
                }
              } else {
                t.signatoryMobile = t.emailOrPhone;
              }
            }
            // if(!t.signatoryMobile &&  && t.alertMobile){
            //   t.signatoryMobile = t.alertMobile;
            // }
          });
          if (!validChild || !validChildBatch) return;
          this.isSaveToDraftBox = saveToDraftBox;
          // 证件号合二为一
          this.signatoryJson.forEach(t => {
            if (parseInt(t.signatoryUserType) === 1) {
              t.signatoryIdentityCard = t.BusinessLicenseNo;
            } else {
              t.signatoryIdentityCard = t.IDCard;
            }
          });

          // 》》》》验证输入的企业是否存在,个人信息是否有误 相关操作 start《《《《
          // 签署方式企业用户且没有证件号
          this.entCreditJson = {};
          this.entCreditArr = [];
          this.entNameArr = [];
          let queryCreditcodeParam = [];
          // 二要素验证变量
          this.userIdentityInfoArr = [];
          let userIdentityInfoParam = []; // 存放需要进行二要素的数组
          this.signatoryJson.forEach(t => {
            // 企业用户且没有证件号
            if (
              parseInt(t.signatoryUserType) === 1 &&
              t.signatoryFullName &&
              !t.signatoryIdentityCard
            ) {
              queryCreditcodeParam.push(t.signatoryFullName);
            }

            // 个人信息-姓名身份证二要素验证
            if (
              parseInt(t.signatoryUserType) === 0 &&
              t.signatoryFullName &&
              t.signatoryIdentityCard &&
              t.signatoryIdentityCard.indexOf("***") === -1
            ) {
              // 是个人且有姓名身份证号码，且身份证号码未加密（手动输入的）
              userIdentityInfoParam.push({
                name: t.signatoryFullName,
                identityNo: t.signatoryIdentityCard
              });
            }
          });

          if (
            (queryCreditcodeParam && queryCreditcodeParam.length) ||
            (userIdentityInfoParam && userIdentityInfoParam.length)
          ) {
            // 查询企业执照号，验证个人信息
            let arr = [];
            if (queryCreditcodeParam && queryCreditcodeParam.length) {
              // 查询企业执照号并将查询到的企业赋值
              arr.push(this.queryEntIDByEntName(queryCreditcodeParam));
            }
            if (userIdentityInfoParam && userIdentityInfoParam.length) {
              // 二要素验证，身份信息不正确的予以提示
              arr.push(this.twoElementsVerify(userIdentityInfoParam));
            }
            Promise.all(arr).then(res => {
              if (res && res.length) {
                for (let i = 0; i < res.length; i++) {
                  let smt = res[i];
                  if (smt && !smt.sus) {
                    this.visibleCredit = true; // 显示签署方信息提示弹窗
                    return false; // 中止后面的操作
                  }
                }
                this.contractIsSaveToDraf(); // 信息无误
              }
            });
          } else {
            // 》》》》验证输入的企业是否存在,个人信息是否有误 相关操作 end《《《《
            this.contractIsSaveToDraf();
          }
        } else {
          console.error("验证不通过.");
        }
      });
    },

    // 通过企业名称去查询企业的证件号
    queryEntIDByEntName (entNameArr) {
      this.entNameArr = entNameArr;
      this.loadingStart("正在认证签署人信息");
      return new Promise(async (resolve, reject) => {
        queryCreditCodeByEntName(entNameArr)
          .then(res => {
            this.loadingClose();
            if (res) {
              this.entCreditArr = [];
              this.entCreditJson = res;
              this.signatoryJson.forEach(t => {
                var entName = t.signatoryFullName;
                if (entNameArr.indexOf(entName) !== -1) {
                  if (res[entName]) {
                    t.signatoryIdentityCard = res[entName];
                  } else {
                    this.entCreditArr.push(entName);
                  }
                }
              });

              if (this.entCreditArr.length) {
                resolve({ sus: false }); // 显示签署方信息提示弹窗
              } else {
                resolve({ sus: true }); // 继续发起
              }
            } else {
              resolve({ sus: true }); // 继续发起
            }
          })
          .catch(err => {
            this.loadingClose();
            this.$message.error("合同发起失败请刷新后再试");
            console.log(
              "通过企业名称去查询企业的证件号： " + JSON.stringify(err)
            );
            reject(err);
          });
      }).catch(error => {
        return error;
      });
    },

    // 通过姓名身份证进行二要素验证
    twoElementsVerify (userInfoArr) {
      this.loadingStart("正在认证签署人信息");
      return new Promise(async (resolve, reject) => {
        queryUserValidateByNameIDnum(userInfoArr)
          .then(res => {
            this.loadingClose();
            if (res && res.length) {
              this.userIdentityInfoArr = res;
              resolve({ sus: false }); // 显示签署方信息提示弹窗
            } else {
              resolve({ sus: true }); // 继续发起
            }
          })
          .catch(err => {
            this.loadingClose();
            this.$message.error("合同发起失败请刷新后再试");
            console.log("身份证二要素验证： " + JSON.stringify(err));
            reject(err);
          });
      }).catch(error => {
        return error;
      });
    },

    // 手动输入证件号后提交合同
    addContractById () {
      this.visibleCredit = false;
      this.signatoryJson.forEach(t => {
        if (this.entCreditJson[t.signatoryFullName]) {
          t.signatoryIdentityCard = this.entCreditJson[t.signatoryFullName];
        }
      });
      this.contractIsSaveToDraf();
    },
    // 合同是否保存到草稿箱
    contractIsSaveToDraf () {
      if (this.isSaveToDraftBox) {
        this.$confirm("你确定需要保存至草稿箱吗？", "系统提示", {
          showCancelButton: true,
          showConfirmButton: true,
          type: "warning"
        })
          .then(() => {
            this.postSendOrSave(true);
          })
          .catch(() => {
            this.handleDelSendContract();
          });
      } else {
        this.postSendOrSave(false);
      }
    },
    /** 查看章审批详情 */
    computeInfo(obj) {
      let nameList = [],list=[];
      if(isInDingTalk){
        // 钉钉流程 flowType 1:顺序审（多层，每层一个），2：会审（单层，一层多个
        const {nodes} = obj.flowParam;
          nodes && nodes.forEach((node) => {
            nameList.push(...(node.userApproveUsers.map(user => user.name)))
          })
        list = nameList.map(name => {
          return {partyName: name};
        });
      }else{
        const keyStr = obj.orderFlag ? "->" : "、"
        nameList =obj.allPartName.split(keyStr);
        list = nameList.map(name => {
          return {partyName: name};
        });
      }
      return list;
    },
    // 提交合同 发起或保存到草稿箱saveToDraftBox 0发起 1保存 contractInfo
    postSendOrSave (saveToDraftBox) {
      let param = this.contractInfo;
      let hh = new Date().getHours();
      let mm = new Date().getMinutes();
      let water = JSON.parse(JSON.stringify(this.waterConfig));
      if (water && water.floatAlpha && water.floatAlpha > 1) water.floatAlpha = water.floatAlpha / 100;
      if (water.switch) param.waterConfig = JSON.stringify(water); //水印
      param.signExpire = this.signlinktime + " " + hh + ":" + mm;
      if (!this.isGroup) {
        param.returnURL =
          configUrl().junziqianWebOp + "/signInfo/applyList?match=-1";
      }
      this.chapteJsonFilter();
      let _signatoryJson = JSON.parse(JSON.stringify(this.signatoryJson));
      _signatoryJson.forEach(i => {
        i.authLevel = i.authLevel ? 11 : null;
        i.handSign = i.corpUser ? 0 : i.signatoryUserType === 0 ? 1 : 2;
        delete i.isNoticePhone;
        delete i.showNoticePhone;
        if (!i.alertMobile) {
          delete i.alertMobile;
        }
        delete i.errorMsg;
      });
      let _batchArray = [...this.batchArray];
      _batchArray.forEach(i => {
        i.authLevel = i.authLevel ? 11 : null;
        i.handSign = i.corpUser ? 0 : i.signatoryUserType === 0 ? 1 : 2;
        delete i.isNoticePhone;
        delete i.showNoticePhone;
        if (!i.alertMobile) {
          delete i.alertMobile;
        }
        delete i.errorMsg;
      });
      param.signatoryJson = _signatoryJson.length
        ? JSON.stringify(_signatoryJson)
        : null;
      param.saveToDraftBox = saveToDraftBox;
      param.attatchFileNamesJson = JSON.stringify(this.attatchFileNamesJson);
      this.loadingStart("正在上传数据");
      // 集团账户 添加审批流程
      if (this.isGroup) {
        // 集团账户批量发起没有审批和抄送人
        // 添加集团账户发起签署审批流程

        // if (this.checkedBatch === false && this.hasApplyApproval === true) {
        // 20200721去掉批量审批流程判断
        if (this.checkedBatch === false) {
          param.flowId = this.approvalFlowSelect;
          // 添加审批人
          // 抄送人
          let carbonCopyJson = [];

          this.arrayCopior.forEach(element => {
            !element.hideRemove && carbonCopyJson.push(element.corpUserIdSec);
          });

          param.carbonCopyJson = JSON.stringify(carbonCopyJson);
        }
        // 无需审批 不传flowId
        if (+param.flowId === 0) {
            delete param.flowId;
          }
        // 批量操作
        if (this.checkedBatch) {
          // 过滤 批量签署方
          let index = undefined;
          let batchChapteJson = null;
          if (this.signatoryJson) {
            let signatoryJsonCopy = JSON.parse(
              JSON.stringify(this.signatoryJson)
            );
            signatoryJsonCopy.forEach((element, i) => {
              if (element.signOwner === "批量签署方") {
                index = i;
                batchChapteJson = element.chapteJson;
              }
            });
            if (index !== undefined) {
              signatoryJsonCopy.splice(index, 1);
            }
            // 重新封装参数
            param.signatoryJson = signatoryJsonCopy.length
              ? JSON.stringify(signatoryJsonCopy)
              : null;
          }

          // 重新封装批量签署方，填充信息
          _batchArray.forEach(element => {
            element.chapteJson = batchChapteJson;
            if (!element.signatoryIdentityCard) {
              if (parseInt(element.signatoryUserType) === 1) {
                element.signatoryIdentityCard = element.BusinessLicenseNo;
              } else {
                element.signatoryIdentityCard = element.IDCard;
              }
            }
            if (!element.childUserName && !element.signatoryMobile) {
              if (parseInt(element.signatoryUserType) === 1) {
                element.childUserName = element.emailOrPhone;
              } else {
                element.signatoryMobile = element.emailOrPhone;
              }
            }
          });

          // 判断未注册企业是否有证件号
          let noIdentityCardCompanyName = [];
          this.batchArray.forEach(element => {
            if (!element.signatoryIdentityCard) {
              noIdentityCardCompanyName.push(element.signatoryFullName);
            }
          });

          if (noIdentityCardCompanyName.length > 0) {
            let html = '<div style="max-height: 350px;overflow: auto">';
            noIdentityCardCompanyName.forEach(element => {
              html += "<strong>" + element + "</strong><br/>";
            });
            html +=
              "<p>以上企业没有对应营业执照号，请手动补全后重新导入.</p></div>";
            this.$alert(html, "系统提示", {
              dangerouslyUseHTMLString: true
            });
            this.loadingClose();
            return;
          }

          param.batchSignatoryJson = _batchArray.length
            ? JSON.stringify(_batchArray)
            : null;
          if (index === undefined) {
            index = 0;
          }
          if (param.ifOrder) {
            param.batchSignOrder = index + 1;
          }
          // 集团账户不支持审批和抄送
          param.approveJson = null;
          param.carbonCopyJson = null;
          ApiCorpMethods.BatchContractController.batchCreateCorp(
            Object.assign(param, { pay: 1 })
          )
            .then(res => {
              if (res.code === "0") {
                this.createdFinish(res.data, saveToDraftBox);
              } else {
                this.loadingClose();
                if (+res.code === 10806) {
                  this.$message.error("积分/套餐不足，请联系公司管理员");
                } else {
                  this.$message.error(
                    res.description || "签署失败，请刷新后再试"
                  );
                }
              }
            })
            .catch(err => {
              this.loadingClose();
              console.log("签署：" + JSON.stringify(err));
              this.$message.error(err.description || "签署失败，请刷新后再试");
            });
        } else {
          const chapsLen = this.chapterCheck.length
          if(this.isMine() && chapsLen) param.createSignerSealIds = this.chapterCheck.toString()
          ApiCorpMethods.CorpApplyContractController.create(
            Object.assign(param, { pay: 1 })
          )
            .then(res => {
              if (res.code === "0") {
                this.createdFinish(res.data, saveToDraftBox);
              } else {
                this.loadingClose();
                if (+res.code === 10806) {
                  this.$message.error("积分/套餐不足，请联系公司管理员");
                } else {
                  this.$message.error(
                    res.description || "签署失败，请刷新后再试"
                  );
                }
              }
            })
            .catch(err => {
              this.loadingClose();
              console.log("签署：" + JSON.stringify(err));
              this.$message.error(err.description || "签署失败，请刷新后再试");
            });
        }
      } else {
        // 正常流程

        // 批量操作
        if (this.checkedBatch) {
          // 过滤 批量签署方
          let index = undefined;
          let batchChapteJson = null;
          if (this.signatoryJson) {
            let batchChapt = null;
            let signatoryJsonCopy = JSON.parse(
              JSON.stringify(this.signatoryJson)
            );
            signatoryJsonCopy.forEach((element, i) => {
              if (element.signOwner === "批量签署方") {
                index = i;
                batchChapteJson = element.chapteJson;
              }
            });
            if (index !== undefined) {
              signatoryJsonCopy.splice(index, 1);
            }
            // 重新封装参数
            param.signatoryJson = signatoryJsonCopy.length
              ? JSON.stringify(signatoryJsonCopy)
              : null;
          }
          // 重新封装批量签署方，填充信息
          this.batchArray.forEach(element => {
            element.chapteJson = batchChapteJson;
            if (!element.signatoryIdentityCard) {
              if (parseInt(element.signatoryUserType) === 1) {
                element.signatoryIdentityCard = element.BusinessLicenseNo;
              } else {
                element.signatoryIdentityCard = element.IDCard;
              }
            }
            if (!element.childUserName && !element.signatoryMobile) {
              if (parseInt(element.signatoryUserType) === 1) {
                element.childUserName = element.emailOrPhone;
              } else {
                element.signatoryMobile = element.emailOrPhone;
              }
            }
          });

          // 判断未注册企业是否有证件号
          let noIdentityCardCompanyName = [];
          this.batchArray.forEach(element => {
            if (!element.signatoryIdentityCard) {
              noIdentityCardCompanyName.push(element.signatoryFullName);
            }
          });

          if (noIdentityCardCompanyName.length > 0) {
            let html = '<div style="max-height: 350px;overflow: auto">';
            noIdentityCardCompanyName.forEach(element => {
              html += "<strong>" + element + "</strong><br/>";
            });
            html +=
              "<p>以上企业没有对应营业执照号，请手动补全后重新导入.</p></div>";
            this.$alert(html, "系统提示", {
              dangerouslyUseHTMLString: true
            });
            this.loadingClose();
            return;
          }

          param.batchSignatoryJson = this.batchArray.length
            ? JSON.stringify(this.batchArray)
            : null;
          if (index === undefined) {
            index = 0;
          }
          if (param.ifOrder) {
            param.batchSignOrder = index + 1;
          }
          ApiCorpMethods.BatchContractController.batchCreate(param)
            .then(res => {
              if (res.code === "0") {
                this.createdFinish(res.data, saveToDraftBox, true, param);
              } else {
                this.loadingClose();
                this.$message.error(
                  res.description || "签署失败，请刷新后再试"
                );
              }
            })
            .catch(err => {
              this.loadingClose();
              this.$message.error(err.description || "签署失败，请刷新后再试");
            });
        } else {
          postCreateApply(param)
            .then(({ data }) => {
              this.createdFinish(data, saveToDraftBox, false, param);
            })
            .catch(err => {
              this.loadingClose();
              this.$message.error(err.description || "签署失败，请刷新后再试");
            });
        }
      }
    },
    // 发起完成之后回掉函数
    createdFinish (data, saveToDraftBox, batch, param) {
      const snapshotId = data.snapshotId || "";
      this.payInfoData = {
        batch: batch,
        param: param,
        recharge: data.recharge,
        snapshotId: snapshotId
      };
      this.loadingClose();

      if (!data.needPay || data.needPay === "false") {
        if (this.isGroup) {
          if (saveToDraftBox) {
            this.$router.push({
              path:
                "/corp/signInfo/applyList?signStatus=4&snapshotId=" + snapshotId
            });
          } else {
            // this.$router.push({
            //   path: "/corp/signInfo/applyList?match=-1&snapshotId=" + snapshotId
            // });
            let paths = "";
            if (this.isInDingTalk) {
              paths = "/corp/signInfo/signList?signStatus=5";
            } else if (data.selfSign === 1) {
              paths = "/corp/signInfo/signList?signStatus=4";
            } else if (data.selfSign === 2) {
              paths = "/corp/signInfo/signList?signStatus=5";
            } else {
              // paths = "/corp/signInfo/applyList?notMeSign=1";
              paths = `/corp/signInfo/signList?signStatus=4&mySendTo=1`;
            }
            this.$router.push({
              path: paths
            });
          }
        } else {
          if (saveToDraftBox) {
            this.$router.push({
              // path: "/signInfo/applyList?signStatus=4&snapshotId=" + snapshotId
              path: "/signInfo/applyList?signStatus=4&snapshotId=" + snapshotId
            });
          } else {
            let paths = "";
            if (param.dingTalkWorkFlowId) {
              paths = "/corp/signInfo/signList?signStatus=5";
            } else if (data.selfSign === 1) {
              paths = "/signInfo/signList?signStatus=2";
            } else if (data.selfSign === 2) {
              paths = "/corp/signInfo/signList?signStatus=5";
            } else {
              // paths = "/signInfo/applyList?notMeSign=1";
              paths = `/signInfo/signList?signStatus=2&mySendTo=1`;
            }
            this.$router.push({
              path: paths
            });
            // this.$router.push({
            //   path: "/signInfo/applyList?match=-1&snapshotId=" + snapshotId
            // });
          }
        }
      } else {
        // 改版了 去掉支付弹窗
        // const cashierUrl = decodeURIComponent(data.cashierUrl);
        // const _href = cashierUrl.split('returnURL=')[0] + 'returnURL=';
        // const returnUrl = cashierUrl.split('returnURL=')[1];
        // window.location.href = _href + encodeURIComponent(returnUrl + (returnUrl.indexOf('?') === -1 ? '?' : '&') + `snapshotId=${snapshotId}`);
        // return false;
        if (this.payInfoData.recharge) {
          this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
        } else {
          this.priseInfo.cashierUrl = data.cashierUrl || "";
          // this.priseInfo.money = data.money;
          this.priseInfo.point = data.point;
          this.priseVisibleDialog = true;
          var moneyData = data.moneyData || false;
          if (moneyData) {
            var moneryArr = [];
            // 签署次数
            if (moneyData.applySign && moneyData.applySign.timesPackage) {
              moneryArr.push(`签署${moneyData.applySign.timesPackage}次`);
            }
            // 银行卡4要数次数
            if (moneyData.bankFour && moneyData.bankFour.timesPackage) {
              moneryArr.push(`四要素${moneyData.bankFour.timesPackage}次`);
            }
            // 3要数次数
            if (moneyData.bankThree && moneyData.bankThree.timesPackage) {
              moneryArr.push(`三要素${moneyData.bankThree.timesPackage}次`);
            }
            // 人脸次数
            if (moneyData.face && moneyData.face.timesPackage) {
              moneryArr.push(`人脸${moneyData.face.timesPackage}次`);
            }
            if (moneryArr && moneryArr.length > 0) {
              this.priseInfo.mealInfo = moneryArr.join("；");
            }
          }
        }
      }
    },

    // 签章列表整理
    chapteJsonFilter () {
      if (!this.chapteJson || !this.chapteJson.length) {
        // 将签章数据置为null
        this.signatoryJson.forEach(sign => {
          sign.chapteJson = null;
        });

        return (this.chapteJson = []);
      }
      let chaptes = {};
      let chaptePage = {};
      let param = [];
      // 按现在存在的联系人列表对签章列表分类
      this.signatoryJson.forEach(sign => {
        chaptes[sign.signOwner] = this.chapteJson.filter(
          chapte => chapte.signOwner === sign.signOwner
        );
      });
      // 根据上面的分类再按照page分类
      for (let key in chaptes) {
        chaptePage[key] = {};

        chaptes[key].forEach(chapt => {
          let page = "page_" + chapt.page;
          if (!chaptePage[key][page]) {
            chaptePage[key][page] = { page: chapt.page, chaptes: [chapt] };
          } else {
            chaptePage[key][page].chaptes.push(chapt);
          }
        });
      }
      for (let key in chaptePage) {
        param[key] = [];
        for (let key1 in chaptePage[key]) {
          param[key].push(chaptePage[key][key1]);
        }
      }
      // 将签章数据放入联系人列表
      this.signatoryJson.forEach(sign => {
        sign.chapteJson = param[sign.signOwner].length
          ? param[sign.signOwner]
          : null;
      });
    },

    guideApplyCancel () {
      localStorage.setItem("APPLY_GUIDE", "guide");
      let refs = this.$refs;
      switch (this.guideStep) {
        case "step1":
          refs.step1.$el.setAttribute("style", "");
          break;
        case "step2":
          refs.step2[0].$el.setAttribute("style", "");
          break;
        case "step3":
          refs.step3[0].$el.setAttribute("style", "");
          break;
        case "step4":
          refs.step4.setAttribute("style", "");
          break;
        case "step5":
          refs.step5.setAttribute("style", "");
          break;
        default:
      }
      this.guideStep = null;
    },
    guideApply (step) {
      if (!step) return;
      this.guideStep = step;
      this.$nextTick(() => {
        let refs = this.$refs;
        let objSetp, stepRect;
        let guidBox = refs.guideBox;

        switch (step) {
          case "step1":
            objSetp = refs[step].$el;
            if (!objSetp) {
              objSetp = refs[step].$el = document.getElementById(step);
            }
            break;
          case "step2":
            refs.step1.$el.setAttribute("style", "");
            objSetp = refs[step][0].$el;
            break;
          case "step3":
            refs.step2[0].$el.setAttribute("style", "");
            objSetp = refs[step][0].$el;
            break;
          case "step4":
            refs.step3[0].$el.setAttribute("style", "");
            objSetp = refs[step];
            localStorage.setItem("APPLY_GUIDE", "guide");
            break;
          case "step5":
            objSetp = refs[step];
            break;
          default:
            this.guideApplyCancel();
            objSetp = null;
            step = null;
            break;
        }
        stepRect = objSetp.getBoundingClientRect();
        // 解决 getBoundingClientRect x,y兼容性
        let { x, y } = stepRect;
        if (x === undefined || y === undefined) return (this.guideStep = null);
        objSetp.setAttribute("style", "position:relative; z-index: 10000;");
        guidBox.setAttribute(
          "style",
          `width:${stepRect.width + 16}px;height:${stepRect.height +
          6}px;left:${x - 8}px;top:${y - 3}px;`
        );
        if (step === "step4") {
          guidBox.setAttribute(
            "style",
            `width:${stepRect.width + 16}px;height:${stepRect.height +
            6}px;left:${x - 8}px;bottom:0px;`
          );
        }
      });
    },
    // 判断是否设签章
    goNextStep () {
      if (this.signatoryJson.length === 0) {
        this.$message.warning("请至少添加一个签署方");
        return;
      }
      let chapArr = this.signatoryJson.map(sign => {
        return sign.signatoryFullName || sign.signOwner;
      });
      this.chapteJson.forEach(chap => {
        chapArr.splice(chapArr.indexOf(chap.qsInfo || chap.signOwner), 1);
      });
      this.chap = chapArr;
      if (this.chap.length === 0) {
        this.nextStep();
      } else {
        this.signDialog = true;
      }
    },
    // 下一步
    nextStep () {
      this.signDialog = false;
      // 证件号二合一
      this.signatoryJson.forEach(element => {
        // 关闭 tool-tip
        element.openUserTab = false;
        if (element.signatoryUserType === 0 && element.signatoryIdentityCard) {
          element.IDCard = element.signatoryIdentityCard;
        } else {
          element.BusinessLicenseNo = element.signatoryIdentityCard;
        }
      });
      this.nextstep = true;
      if (this.lastGuide) {
        this.guideApply("step5");
        this.lastGuide = false;
      }
    },
    // 通过applyId获取草稿箱合同信息
    async getDraftContractInfoByApplyId (applyId) {
      this.loadingStart();
      let isCorpDraft = !!this.$route.query.isCorp || false;
      let draftRes = {};
      try {
        if (isCorpDraft) {
          draftRes = await getCorpDraftInfoByApplyId(applyId);
        } else {
          draftRes = await getDraftInfoByApplyId(applyId);
        }
        this.loadingClose();
        let data = draftRes.data;
        this.nextstep = true;
        this.contractInfo.contractName = data.applySignVO.contractName;
        this.contractInfo.serverCa = data.serverCa;
        // this.contractInfo.needCa = data.needCa || 0;
        // 君哥后端保存出错，这个没用了，这个改方便
        this.contractInfo.needCa = 0;
        this.contractInfo.overDate = data.overDate || "";
        this.contractInfo.ifOrder =
          data.applySignVO.orderFlag == 1 ? true : false;
        this.contractInfo.consumMode = data.consumMode || 0;
        this.contractInfo.needQifengSign = data.needQifengSign || 1;
        this.contractInfo.needVideoSign = data.needVideoSign || 0;

        this.convertContractToInfo(data.applySignVO.fileInfo);
        this.handleConverDraftSignOS(data.signInfoVOS);
        if (data.applySignAttatchVOS) {
          this.handleConverDraftAttach(data.applySignAttatchVOS);
        }
      } catch (err) {
        console.log(err);
        this.loadingClose();
        console.error("查找合同信息  " + JSON.stringify(err));
        this.$message.warning(err.description || "没有找到合同信息");
      }
    },
    // 草稿箱合同用户信息和签章信息转换
    handleConverDraftSignOS (signOS) {
      console.log('signOS+++++++++++++++',signOS);
      this.signatoryJson = [];
      signOS.forEach((t, i) => {
        // 甲乙丙状态
        let signOwner = signerDataList[i].signOwner;
        let chapteUrl = signerDataList[i].url;
        signerDataList[i].ischecked = true;
        // 签署人
        let signatory = {
          emailOrPhone: t.signatoryEmai || t.signatoryMobile,
          // 新增集团账户 数组
          canSelectArray: [],
          canSelectArrayIndex: 0,

          signatoryFullName: t.signatoryFullName,
          signatoryIdentityCard: t.signatoryIdentityCard,
          IDCard: "",
          BusinessLicenseNo: "",
          childUserName: t.signatoryEmai,
          signatoryMobile: t.signatoryMobile || "",
          signOwner: signOwner,
          ischange: 0,
          notRegister: true,
          disabled: "",
          signatoryUserType: t.signatoryUserType || 0,
          openUserTab: false,
          // authLevel: t.authLevel ? parseInt(t.authLevel) : null,//选择验证方式
          authLevel: t.authLevel ? 11 : null, //只有人脸
          handSign: t.handSign,
          corpUser: false,
          chapteJson: [],
          isEncrypt: false,
          isNoticePhone: t.alertMobile ? true : false,
          showNoticePhone: t.alertMobile ? true : false,
          alertMobile: t.alertMobile,
          sameCorpUser:t.sameCorpUser || null // 是否和发起方是同一个人
        };
        // 转换身份证和营业执照
        if (t.signatoryUserType === 0) {
          signatory.IDCard = signatory.signatoryIdentityCard;
        } else {
          signatory.BusinessLicenseNo = signatory.signatoryIdentityCard;
          if (t.corpUser) {
            signatory.corpUser = true;
            signatory.childUserName = t.corpUser;
            signatory.signatoryMobile = "";
          } else {
            signatory.corpUser = false;
          }
        }
        // 签章
        let chapteJson = t.chapteJson ? JSON.parse(t.chapteJson) : null;

        // 签章处理
        if (chapteJson && chapteJson.length) {
          chapteJson.forEach(chaptes => {
            let chapt = chaptes.chaptes || null;
            if (chapt && chaptes.chaptes) {
              chapt.forEach(item => {
                let param = {
                  offsetX: item.offsetX,
                  offsetY: item.offsetY,
                  cindex: t.cindex,
                  signOwner: signOwner,
                  url: chapteUrl,
                  page: chaptes.page
                };
                this.chapteJson.push(param);
              });
            }
          });
        }
        signatory.chapteJson = this.chapteJson;
        // 签署人状态判断
        if (t.signatoryIdentityCard) {
          // signatory.childUserName = t.signatoryEmai;
          signatory.notRegister = false;
          signatory.disabled = "disabled";
          signatory.isEncrypt = true;
          signatory.ischange = 1;
        }
        // 判断是否打码
        if (
          signatory.signatoryIdentityCard.indexOf("*") > -1 ||
          signatory.signatoryFullName.indexOf("*") > -1
        ) {
          signatory.ischange = 1;
        }
        this.signatoryJson.push(signatory);
      });
      this.listChapteJsonCindex();
    },
    // 草稿箱合同附件转换
    handleConverDraftAttach (attach) {
      if (attach && !attach.length) return;

      attach.forEach(t => {
        if (t.file) {
          let param = {
            codeName: t.file.targetId,
            origiName: t.fileName,
            file: t.file
          };

          this.attatchFileNamesJson.push(param);
        }
      });
    },
    // 存储文件的合同文件转换，非上传的临时文件转换
    convertContractToInfo (param) {
      this.loadingStart("正在加载合同信息");

      tempConvertToContract(param)
        .then(({ data }) => {
          this.loadingClose();

          this.contractInfo.docHash = data.docHash;
          this.contractInfo.items = parseInt(data.items);
          this.currentInfo = { page: 1, url: "" };
          this.contractInfo.ts = param.ts;
          this.contractInfo.sign = param.sign;
          this.contractInfo.contractId = param.targetId;
          this.getContractDetailByNum(1);
        })
        .catch(err => {
          this.loadingClose();
          console.error("合同文件转换 " + JSON.stringify(err));
        });
    },
    // 前往支付
    toPay () {
      this.payDisabled = true;
      const param = Object.assign(this.payInfoData.param, { pay: 1 });
      let hh = new Date().getHours();
      let mm = new Date().getMinutes();
      let water = JSON.parse(JSON.stringify(this.waterConfig));
      if (water && water.floatAlpha && water.floatAlpha > 1) water.floatAlpha = water.floatAlpha / 100;
      if (water.switch) param.waterConfig = JSON.stringify(water); //水印
      param.signExpire = this.signlinktime + " " + hh + ":" + mm;
      if (this.payInfoData.batch) {
        ApiCorpMethods.BatchContractController.batchCreate(param).then(res => {
          if (+res.code === 10806) {
            this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
            this.payDisabled = false;
            return;
          }
          if (+res.code === 0) {
            this.$message.success("发起签署成功");
            if (this.isGroup) {
              // this.$router.push({
              //   path:
              //     "/corp/signInfo/applyList?match=-1&snapshotId=" +
              //     this.payInfoData.snapshotId
              // });
              let paths = "";
              if (res.data.selfSign === 1) {
                paths = "/corp/signInfo/signList?signStatus=4";
              } else if (res.data.selfSign === 2) {
                paths = "/corp/signInfo/signList?signStatus=5";
              } else {
                paths = `/corp/signInfo/signList?signStatus=4&mySendTo=1`;
              }
              this.$router.push({ path: paths });
            } else {
              // this.$router.push({
              //   path:
              //     "/signInfo/applyList?match=-1&snapshotId=" +
              //     this.payInfoData.snapshotId
              // });
              let paths = "";
              if (res.data.selfSign === 1) {
                paths = "/signInfo/signList?signStatus=2";
              } else if (res.data.selfSign === 2) {
                paths = "/corp/signInfo/signList?signStatus=5";
              } else {
                paths = `/signInfo/signList?signStatus=2&mySendTo=1`;
              }
              this.$router.push({ path: paths });
            }
            return;
          }
          this.$message.error(res.description || "支付失败");
          this.payDisabled = false;
        });
      } else {
        postCreateApply(param)
          .then(res => {
            if (+res.code === 0) {
              this.$message.success("发起签署成功");
              if (this.isGroup) {
                // this.$router.push({
                //   path:
                //     "/corp/signInfo/applyList?match=-1&snapshotId=" +
                //     this.payInfoData.snapshotId
                // });
                let paths = "";
                if (res.data.selfSign === 1) {
                  paths = "/corp/signInfo/signList?signStatus=4";
                } else if (res.data.selfSign === 2) {
                  paths = "/corp/signInfo/signList?signStatus=5";
                } else {
                  paths = `/corp/signInfo/signList?signStatus=4&mySendTo=1`;
                }
                this.$router.push({ path: paths });
              } else {
                // this.$router.push({
                //   path:
                //     "/signInfo/applyList?match=-1&snapshotId=" +
                //     this.payInfoData.snapshotId
                // });
                let paths = "";
                if (res.data.selfSign === 1) {
                  paths = "/signInfo/signList?signStatus=2";
                } else if (res.data.selfSign === 2) {
                  paths = "/corp/signInfo/signList?signStatus=5";
                } else {
                  paths = `/signInfo/signList?signStatus=2&mySendTo=1`;
                }
                this.$router.push({ path: paths });
              }
              return;
            }
            if (+res.code === 10806) {
              this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
              this.payDisabled = false;
            }
            this.$message.error(res.description || "支付失败");
            this.payDisabled = false;
          })
          .catch(err => {
            if (+err.code === 10806) {
              this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
            }
            this.payDisabled = false;
          });
      }
    },
    // 联系方式改变，或点击修改btn
    handleTargetIdChange (sign) {
      sign.disabled = "";
      sign.isEncrypt = false;
      sign.ischange = 0;
      sign.notRegister = true;
      sign.IDCard = "";
      sign.signatoryIdentityCard = "";
      if (!sign.canSelectArray || sign.canSelectArray.length === 0) {
        sign.signatoryFullName = "";
      }
    },

    // 数字证书切换
    handleChangeCa (ca) {
      if (this.contractInfo.consumMode == 1) return;

      if (ca === "serverCa") {
        if (this.contractInfo.serverCa == 1) {
          this.contractInfo.needCa = 0;
        }
      } else {
        if (this.contractInfo.needCa == 1) {
          this.contractInfo.serverCa = 0;
        }
      }
    },
    // 获取最近联系人
    getTelList () {
      postTelFindByPagedEnterpriseList(this.telPageInfo)
        .then(data => {
          this.telList = data.data;
          this.telPageInfo.itemPage = data.pageNum;
          this.telPageInfo.pageSize = data.pageSize;
          this.telPageInfo.total = data.total;
        })
        .catch(err => { });
    },
    // 获取本公司部门
    getDepartmentList () {
      ApiCorpMethods.CorpCommonController.listGroup().then(res => {
        if (res.success) {
          this.department = res.data;
        }
      });
    },

    handleSizeChange (val) {
      this.telPageInfo.itemPage = 1;
      this.telPageInfo.pageSize = val;
      this.getTelList();
    },
    handleCurrentChange (val) {
      this.telPageInfo.itemPage = val;
      this.getTelList();
    },
    // 输入input合同跳页
    handleContractPageClick () {
      let page = this.goPageNum;
      page = parseFloat(page);
      if (!page) return this.$message.warning("请输入正确的页数");
      if (page < 1 || page > this.contractInfo.items)
        return this.$message.warning("请输入正确的页数");
      this.goPageAndFixed(page);
    },
    //  按页数获取合同，在左侧目录定位当前页，中间合同滚动到顶部从头展示
    goPageAndFixed (page) {
      this.getContractDetailByNum(page);
      this.toCurrentPage(page);
      document.querySelectorAll(".contract-view")[0].scrollTop = 0;
    },
    // 页数跳转，定位到当前展示页,定位左侧图片
    toCurrentPage (val) {
      let dom = document.querySelectorAll(".page-con .list")[val - 1];
      if (dom) {
        document.querySelectorAll(".page-con")[0].scrollTop = dom.offsetTop;
      }
    },
    // 按页数获取合同
    getContractDetailByNum (num) {
      if (this.contractList[num]) {
        return (this.currentInfo = this.contractList[num]);
      }

      this.currentInfo = {
        page: num,
        url: convertDetailToShow({
          sign: this.contractInfo.sign,
          ts: this.contractInfo.ts,
          fileType: this.fileType,
          fix: "png",
          targetId: this.contractInfo.contractId,
          num: num - 1,
          docHash: this.contractInfo.docHash
        })
      };

      if (!this.contractList[num]) {
        this.contractList[num] = this.currentInfo;
      }
    },
    // 显示tool-tip
    handleShow: function (signer, index) {
      this.selectIndex = index;
      this.signatoryJson.forEach(t => {
        if (signer && t.signOwner === signer.signOwner) {
          t.openUserTab = true;
        } else {
          t.openUserTab = false;
        }
      });
    },
    // 隐藏 tool-tip
    handleHide: function (signer, index) {
      this.$set(this.signatoryJson, index, signer);
      this.signatoryJson.forEach(t => {
        if (signer && signer.signOwner && t.signOwner === signer.signOwner) {
          t.authLevel = signer.authLevel;
          t.openUserTab = false;
        }
      });
    },
    // 添加签署方
    addSignerList: function () {
      this.gifClick = true;
      if (this.signatoryJson.length === 10) {
        return this.$message.warning("最多不能超过10个签署方");
      }
      for (let i = 0; i < signerDataList.length; i++) {
        if (signerDataList[i].ischecked === false) {
          this.signatoryJson.push({
            signOwner: signerDataList[i].signOwner,

            emailOrPhone: "",
            childUserName: "",
            signatoryMobile: "",

            signatoryFullName: "",
            signatoryIdentityCard: "",
            signatoryUserType: 0,

            //authLevel: 11,  873 需求修改，此前默认人脸认证 ，此后取消这个逻辑
            authLevel: "",
            handSign: 0,
            corpUser: false,

            chapteJson: null,
            // 新增集团账户 数组
            canSelectArray: [],
            canSelectArrayIndex: 0,

            IDCard: "",
            BusinessLicenseNo: "",
            ischange: 0,
            notRegister: true,
            disabled: "",
            openUserTab: false,
            isEncrypt: false,

            isNoticePhone: false,
            showNoticePhone: false,
            alertMobile: ""
          });
          return (signerDataList[i].ischecked = true);
        }
      }
    },
    // 删除签署方
    delSignList: function (sign) {
      if (sign.signOwner === "批量签署方") {
        this.checkedBatch = false;
      }
      // if (sign.signOwner === '甲方') return;

      for (let i = 0; i < signerDataList.length; i++) {
        if (signerDataList[i].signOwner === sign.signOwner) {
          signerDataList[i].ischecked = false;
        }
      }

      this.signatoryJson = this.signatoryJson.filter(
        t => t.signOwner !== sign.signOwner
      );
      this.delChapterBySignOwner(sign.signOwner);
    },
    // 根据signOwner删除签章列表
    delChapterBySignOwner (signOwner) {
      if (!this.chapteJson.length) return;

      this.chapteJson = this.chapteJson.filter(t => t.signOwner !== signOwner);
      this.listChapteJsonCindex();
    },
    changeSmallMap (val) {
      this.deviationSmallMap = val;
    },
    // 限制签章个数30个
    limitSignCount (signOwner) {
      let v = 0;
      for (let index = 0; index < this.chapteJson.length; index++) {
        const element = this.chapteJson[index];
        if (element.signOwner === signOwner) {
          v++;
        }
      }
      return v;
    },
    dragQZStart (ev) {
      console.log("drag Start");
    },
    /**
     * 20200521新增拖动功能需求
     * 添加签章-拖动
     * @signOwner 签署方一二三
     * @qsInfo 签署方的信息
     * */
    dragQZEnd (ev, signOwner, qsInfo) {
      let {
        top: contBoxTop,
        left: contBoxLeft,
        width: contBoxW,
        height: contBoxH
      } = this.$el.querySelector(".cont-box").getBoundingClientRect();
      let caechetW = this.$refs["contractView"].scaleToVal(110); // 签章宽高-签章更改这里也需要更改
      let caechetH = this.$refs["contractView"].scaleToVal(110); // 签章宽高-签章更改这里也需要更改
      let delBtnHeight = 7; // 删除按钮超出部分高度-签章更改这里也需要更改
      let sx = ev.pageX || ev.screenX;
      // 兼容火狐浏览器无法获取pageY的问题，这里用screenY-浏览器工具栏高度
      let sy =
        ev.pageY || ev.screenY - (window.outerHeight - window.innerHeight);
      let left = sx - contBoxLeft - caechetW / 2; // 鼠标距离合同左侧距离-二分之一签章宽度
      let top = sy - contBoxTop + caechetH / 2; // 鼠标距离合同顶部距离+二分之一签章高度

      let boundaryValue = this.$refs["contractView"].scaleToVal(35); // 合同的最小边界值
      console.error("top" + top, "left" + left, boundaryValue);
      if (top < 120) {
        top = 111 + boundaryValue;
      }
      if (top > contBoxH - caechetH - boundaryValue) {
        top = contBoxH - caechetH - boundaryValue;
      }

      if (left < boundaryValue) {
        left = boundaryValue;
      }
      if (left > contBoxW - caechetW - boundaryValue) {
        left = contBoxW - caechetW - boundaryValue;
      }

      // 获取合同图片的宽高 （用于计算距离的比例）
      // let imgBox = document.querySelector('.cont-box>img');
      // let imgWidth = imgBox.naturalWidth || imgBox.width;
      // let imgHeight = imgBox.naturalHeight || imgBox.height;
      let imgWidth = this.deviationSmallMap.width;
      let imgHeight = this.deviationSmallMap.height;

      for (let i = 0; i < signerDataList.length; i++) {
        if (signerDataList[i].signOwner === signOwner) {
          let url = signerDataList[i].url;
          let len = this.chapteJson.length;
          let v = this.limitSignCount(signOwner);
          if (v >= 30) {
            this.$message({
              message: "温馨提示, 签章最大限制30个!",
              type: "warning"
            });
            return;
          }

          console.log("缩放值:", left, top);
          left = this.$refs["contractView"].scaleToShow(left);
          top = this.$refs["contractView"].scaleToShow(top);
          caechetW = this.$refs["contractView"].scaleToShow(caechetW);
          caechetH = this.$refs["contractView"].scaleToShow(caechetH);

          console.log("真实值", left, top);
          console.log(
            left,
            imgWidth,
            parseFloat((parseInt(left) / imgWidth).toFixed(4))
          );
          this.chapteJson.push({
            offsetX: parseFloat((left / imgWidth).toFixed(4)), // 统一使用真实值计算
            offsetY: parseFloat((top / imgHeight).toFixed(4)),
            cindex: len,
            signOwner: signOwner,
            qsInfo: qsInfo, // 新需求，需要在签章上显示签署方的信息(辅助变量，不需要传到后端)
            url: url,
            page: this.currentInfo.page - 1,
            imageHeight: caechetH
          });
          console.log("添加签章成功：", this.chapteJson, 6666);
          return this.listChapteJsonCindex();
        }
      }
    },

    /** 添加签章
     * @signOwner 签署方一二三
     * @qsInfo 签署方的信息
     * */
    handleAddChapter (signOwner, qsInfo) {
      for (let i = 0; i < signerDataList.length; i++) {
        if (signerDataList[i].signOwner === signOwner) {
          let url = signerDataList[i].url;
          let len = this.chapteJson.length;
          let v = this.limitSignCount(signOwner);
          if (v >= 30) {
            this.$message({
              message: "温馨提示, 签章最大限制30个!",
              type: "warning"
            });
            return;
          }
          this.computeSignImageSize(url, image => {
            let {
              x,
              y,
              imageHeight,
              isNotPy
            } = this.computeClientCenterPosition(image);
            this.chapteJson.push({
              // offsetX: !isNotPy? x + 0.03 * this.chapteJson.length : x, // 合同放大不偏移
              // offsetY: !isNotPy? y + 0.03 * this.chapteJson.length : y, // 合同放大不偏移
              offsetX: x + 0.03 * this.chapteJson.length, // 合同放大不偏移
              offsetY: y + 0.03 * this.chapteJson.length, // 合同放大不偏移
              cindex: len,
              signOwner: signOwner,
              qsInfo: qsInfo, // 新需求，需要在签章上显示签署方的信息(辅助变量，不需要传到后端)
              url: url,
              page: this.currentInfo.page - 1,
              imageHeight: imageHeight
            });
            return this.listChapteJsonCindex();
          });
        }
      }
    },
    // 获取签章图片宽高
    computeSignImageSize (url, callback) {
      let image = new Image();
      image.src = url;
      image.onload = () => {
        callback(image);
      };
    },
    // 计算可视区中心位置
    computeClientCenterPosition (image) {
      let imageWidth = 0,
        imageHeight = 0;
      if (image) {
        // imageWidth = image.width || image.clientWidth || image.naturalWidth; // 之前的章
        // imageHeight = image.height || image.clientHeight || image.naturalHeight; // 之前的章
        imageWidth = 110; // 改版后的章
        imageHeight = 110; // 改版后的章
      }
      // 可视区宽高
      // 加入缩放因子计算
      let fx;
      let fy;
      let isNotPy = false;
      let scaleToShow = this.$refs["contractView"].scaleToShow;
      let scaleToVal = this.$refs["contractView"].scaleToVal;
      let domView = this.$refs["contractView"].$el;
      // console.log(this.deviationSmallMap,[domView])
      if (scaleToVal(this.deviationSmallMap.width) <= domView.clientWidth) {
        // 能显示完全时
        let left = (this.deviationSmallMap.clientWidth - imageWidth) / 2;
        let top = (this.deviationSmallMap.clientHeight - imageHeight) / 2;
        fx = this.deviationSmallMap.left + left;
        fy = this.deviationSmallMap.top + top + imageHeight;
      } else {
        // 不显示完全时
        isNotPy = true; // 放大时不偏移，不然找不到位置
        let marinLeft = 0; // 左侧间隙值
        if (domView.clientWidth > this.deviationSmallMap.width) {
          marinLeft = domView.clientWidth - this.deviationSmallMap.width;
        }
        // 缩放后滚动距离加上可视区域一半的距离（这里的值都是缩放后的值）
        let scrollLeft =
          domView.scrollLeft +
          (domView.clientWidth - scaleToVal(imageWidth)) / 2 -
          scaleToVal(marinLeft / 2);
        // 缩放后滚动距离加上可视区域一半的距离（这里的值都是缩放后的值）
        let scrollTop =
          domView.scrollTop +
          (domView.clientHeight - scaleToVal(imageHeight)) / 2;

        fx = scrollLeft; // 缩放后的值
        fy = scrollTop + scaleToVal(imageHeight); // 缩放后的值
        fx = scaleToShow(fx); // 真实值
        fy = scaleToShow(fy); // 真实值
      }

      return {
        x: parseFloat((fx / this.deviationSmallMap.width).toFixed(2)),
        y: parseFloat((fy / this.deviationSmallMap.height).toFixed(2)),
        imageHeight: imageHeight,
        isNotPy // 新增变量，是否在原有位置偏移（只有合同放大时才不偏移）
      };
    },
    // 根据cindex删除签章
    delChapteByCindex (cindex) {
      if (!this.chapteJson.length) return;
      // 过滤条件加入是否含有批量签章的判断
      const CUR = this.chapteJson.find(chap=>chap.cindex === cindex);
      this.chapteJson = this.chapteJson.filter(t =>{
        //  当前签章是否具有批量签章【batch】属性
        if(CUR.batch >=0){
          return t.batch !== CUR.batch;
        }else{
          return t.cindex !== cindex;
        }
      });
      this.listChapteJsonCindex();
    },
    // 给签章列表添加cindex
    listChapteJsonCindex () {
      if (!this.chapteJson.length) return;
      for (let i = 0; i < this.chapteJson.length; i++) {
        this.chapteJson[i].cindex = i;
      }
    },
    // 另外一边打开通讯录
    handleTelsClickOther: function (item, index) {
      item.openUserTab = true;
      this.selectIndex = index;
      this.getTelList();
      this.showTel = true;
      // 清空集团账户选择人列表
      this.myCorpModel.keyword = "";
      if (this.isGroup) {
        this.clickHandleMyCorpSearch();
      }
      // return openUserTab to true
      if (this.signatoryJson[this.selectIndex]) {
        this.signatoryJson[this.selectIndex].openUserTab = true;
      }
    },
    // 打开通讯薄
    handleTelsClick: function (item, index) {
      item.openUserTab = true;
      this.selectIndex = index;
      this.getTelList();
      this.showTel = true;
      // 清空集团账户选择人列表
      this.myCorpModel.keyword = "";
      if (this.isGroup) {
        this.clickHandleMyCorpSearch();
      }
      // return openUserTab to true
      if (this.signatoryJson[this.selectIndex]) {
        this.signatoryJson[this.selectIndex].openUserTab = true;
      }
    },
    // 处理用户类型选择
    handleSignUserType (signator, index) {
      this.getUserInfoBySelectTargetId(signator.emailOrPhone, index);
    },
    // 通讯录点击选中一行
    handleTelRowClickSelectRow (row, event, column) {
      if (row) {
        this.tableSignorSelectRow = row;
        this.tableSignorSelectRowTargetID = row.mobileOrChild;
      } else {
        this.tableSignorSelectRow = undefined;
        this.tableSignorSelectRowTargetID = "";
      }
    },
    // 上传附件
    handleAttatchFileUpload (el) {
      if (this.attatchFileNamesJson.length >= 3) {
        this.$message.error("附件最多只能上传3个");
        return (el.target.value = "");
      }
      el = el.target;
      let file = el.files[0] || null;
      if (!file) return false;
      if (file.size > 30 * 1024 * 1024) {
        this.$message.warning("附件大小不能超过30M!");
        return;
      }
      this.loadingStart("正在上传附件");
      postFileTempUpload({ file: file, fileType: 1 })
        .then(data => {
          this.loadingClose();
          el.value = "";
          let nameArr = file.name.split(".");

          this.attatchFileNamesJson.push({
            targetId: data.targetId,
            targetFix: "." + nameArr[nameArr.length - 1],
            origiName: nameArr.join(".")
          });
        })
        .catch(err => {
          this.loadingClose();
          el.value = "";
          this.$message.warning(err.description || "附件上传失败请重试");
        });
    },
    // 上传附件1 (设置页面的附件)
    handleAttatchFileUploadNew (file) {
      if (this.attatchFileNamesJson.length >= 3) {
        return this.$message.error("当前可上传的文件不能超过30个！");
      }
      if (file.size > 30 * 1024 * 1024) {
        this.$message.warning("附件大小不能超过30M!");
        return;
      }
      this.loadingStart("正在上传附件");
      postFileTempUpload({ file: file, fileType: 1 })
        .then(data => {
          this.loadingClose();
          let nameArr = file.name.split(".");

          this.attatchFileNamesJson.push({
            targetId: data.targetId,
            targetFix: "." + nameArr[nameArr.length - 1],
            origiName: nameArr.join(".")
          });
        })
        .catch(err => {
          this.loadingClose();
          this.$message.warning(err.description || "附件上传失败请重试");
        });
    },
    // 删除附件
    delAttatchFileNamesJson (attatch) {
      this.attatchFileNamesJson.forEach((t, i) => {
        if (t.targetId === attatch.targetId) {
          this.attatchFileNamesJson.splice(i, 1);
        }
      });
    },
    loadingStart (info = null) {
      this.loading = this.$loading({
        lock: true,
        text: info || "正在拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, .5)"
      });
    },
    //设置状态
    loadingClose () {
      if (this.loading) {
        this.loading.close();
        this.loading = null;
      }
    },
    showSignSet () {
      var _this = this;
    },
    // 是否需要人脸
    authLevelChange (e) {
      // console.log(this.signatoryJson[e]);
      // console.log(e,111111111)
      // if(!e) {
      //     this.authLevelShow = true
      // }
    }
  },
  components: {
    ContractView,
    ToolTip,
    SingerForm,
    draggable,
    Flow,
    SignInfoTipsDialog,
    approvalProcess,
    waterMark,
  },
  head: { title: "文件发起签署" },
  name: "toCreate",
  layout: "fullpage"
};

const signerDataList = [
  {
    signOwner: "签署方一",
    ischecked: true,
    url: "/images/signature/add-sign_a.png"
  },
  {
    signOwner: "签署方二",
    ischecked: false,
    url: "/images/signature/add-sign_b.png"
  },
  {
    signOwner: "签署方三",
    ischecked: false,
    url: "/images/signature/add-sign_c.png"
  },
  {
    signOwner: "签署方四",
    ischecked: false,
    url: "/images/signature/add-sign_d.png"
  },
  {
    signOwner: "签署方五",
    ischecked: false,
    url: "/images/signature/add-sign_e.png"
  },
  {
    signOwner: "签署方六",
    ischecked: false,
    url: "/images/signature/add-sign_f.png"
  },
  {
    signOwner: "签署方七",
    ischecked: false,
    url: "/images/signature/add-sign_g.png"
  },
  {
    signOwner: "签署方八",
    ischecked: false,
    url: "/images/signature/add-sign_h.png"
  },
  {
    signOwner: "签署方九",
    ischecked: false,
    url: "/images/signature/add-sign_i.png"
  },
  {
    signOwner: "签署方十",
    ischecked: false,
    url: "/images/signature/add-sign_j.png"
  },
  {
    signOwner: "批量签署方",
    ischecked: false,
    url: "/images/signature/add-sign_batch.png"
  }
];
</script>
<style>
.el-dialog {
  margin-top: 50px !important;
}

/*.el-tooltip__popper.is-dark{*/
/*background-color: #ddd!important;*/
/*}*/
/*.el-tooltip__popper .popper__arrow::after{*/
/*border-bottom-color:  #ddd!important;*/
/*}*/
/*.el-tooltip__popper .popper__arrow {*/
/*border-bottom-color:  #ddd!important;*/
/*}*/
.el-dialog__body {
  padding-top: 0;
}
</style>

<style scoped>
.el-button:hover {
  color: #ffffff !important;
}
.to-create >>> .el-tabs__header {
  margin-bottom: 0;
}

.prise-dialog >>> .el-dialog {
  margin-top: 10% !important;
}

/***
    自定义select样式
  **/
.pay-type {
  padding: 0 15px;
  border: 0px;
  text-align: left;
}

.pay-type:hover {
  background: transparent;
}

.pay-type .custom-transform-rotateZ-180 {
  webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  -webkit-transform: rotateZ(180deg);
  transform: rotateZ(180deg);
}

.pay-type .custom-transform-rotateZ-0 {
  webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  -webkit-transform: rotateZ(0deg);
  transform: rotateZ(0deg);
}

/* .pay-type >>> .el-icon-arrow-up .is-reverse{
    -webkit-transform: rotateZ(0);
    transform: rotateZ(0);
  } */
</style>

<style lang="less" scoped>
@import (less) '../../assets/style/cssVariable.less';
.temone-box{
  display: flex;
  justify-content: flex-start;
  padding: 10px;
  .temone-chap  {
    margin-right: 20px;
    margin-top: 15px;
    width: 175px;
    text-align: center;
    align-items: center;
    border: 1px solid @ebq-grey-white3;
    border-radius: 4px;
      overflow: hidden;
      position: relative;
      cursor: pointer;
      .select_img {
        display: none;
      }
      &.select-border{
        border: 1px solid @ebq-red !important;
        .select_img {
          display: block;
          position: absolute;
          right: -15px;
          bottom: -8px;
          max-width: 60px;
        }
      }
    // height: 140px;
    .info_box {
      width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      .approve_info {
      cursor: pointer;
      font-weight: bold;
      }
    }
    p {
      font-size: 14px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding: 0 10px;
      width: 100%;
      font-family: Source Han Sans SC;
      box-sizing: border-box;
      height: 35px;
      line-height: 35px;
      background: @ebq-grey-white6;
      color: rgba(41, 2, 2, 0.65);
    }
    .t-box {
      position: relative;
      width: 100%;
      height: 105px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      overflow: hidden;
      &:hover {
        .msk {
          width: 100%;
          height: 100%;
          opacity: 1;
        }
      }
      .y-img {
        width: 96px;
        height: auto;
        display: block;
        margin: 8px auto 7px auto;
      }
    }
    .el-icon-plus {
      cursor: pointer;
      color: @ebq-grey-white;
      font-size: 80px;
    }
  }
}
.more-set {
  cursor: pointer;
  font-size: 14px;
  color: #999;
}

.apply-guide {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 450;
  background: rgba(0, 0, 0, 0.7);

  .tooltiop-btns {
    text-align: right;

    a {
      display: inline-block;
      line-height: 1.7;
      padding: 0 10px;
      color: #ffffff;
      border-radius: 3px;

      &:nth-child(2) {
        color: #333333;
        background: #f5f5f5;
      }
    }
  }

  .tooltip-text {
    margin-bottom: 10px;

    span {
      display: inline-block;
      line-height: 20px;
      width: 20px;
      text-align: center;
      background: #ffffff;
      color: #000000;
      border-radius: 50%;
      margin-right: 7px;
    }
  }

  .tooltip-arrow {
    border: 5px solid transparent;
    content: "";
    position: absolute;
    left: 50%;
    margin-left: -5px;
  }

  .tooltip-top {
    bottom: 55px;

    .tooltip-arrow {
      bottom: -10px;
      border-top-color: #009999;
    }
  }

  .tooltip-bottom {
    top: 50px;
    right: 10px;

    .tooltip-arrow {
      top: -10px;
      border-bottom-color: #009999;
    }
  }

  .tooltip {
    position: absolute;
    min-width: 200px;
    max-width: 300px;
    background: #009899;
    color: #ffffff;
    border-radius: 3px;
    padding: 20px;
  }

  .box {
    position: absolute;
    background: #ffffff;
    border-radius: 3px;
  }
}

/******* 消费弹窗 ********/
.prise-dialog {
  .footer-btn {
    width: 180px;
    margin-top: 10px;
  }

  .box-dashed {
    border-radius: 4px;
    border: 1px dashed #fce2e2;

    img {
      height: 108px;
    }

    h4 {
      font-size: 18px;
      font-weight: 500;
      margin: 10px 0;
    }
  }
}

@keyframes keyRotateToToDown {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(45deg);
  }
  50% {
    transform: rotate(90deg);
  }
  75% {
    transform: rotate(135deg);
  }
  100% {
    transform: rotate(180deg);
  }
}

@keyframes keyRotateToUp {
  0% {
    transform: rotate(180deg);
  }
  25% {
    transform: rotate(225deg);
  }
  50% {
    transform: rotate(270deg);
  }
  75% {
    transform: rotate(315deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.cont-info-form {
  max-width: 1300px;
  margin: 0 auto;
  padding: 40px 0;

  .tab {
    /*border: 1px dashed #dbdbdb;*/

    .list-box {
      /*padding: 15px 14px;*/
      padding: 10px 0;

      /*.sign-item {*/
      /*  &:hover {*/
      /*    background-color: #eee;*/
      /*    !*border: 1px solid #eee !important;*!*/
      /*  }*/
      /*}*/

      .i-drag:hover {
        background-color: #f8f8f8;
      }

      .i-drag:active {
        background-color: #fff2e6 !important;
      }

      .draging {
        background-color: #fff2e6;
      }

      .user-type {
        text-align: center;
        /*cursor: pointer;*/
        padding: 0 10px;

        p {
          text-align: center;
          line-height: 50px;
          white-space: nowrap;
          text-overflow: ellipsis;
          box-sizing: border-box;
        }

        i {
          display: inline-block;
          width: 34px;
          height: 32px;
          vertical-align: super;
        }
      }

      .item {
        /*border: 1px solid #fce7e7;*/
        /*margin: 15px;*/
        display: table;
        width: 100%;
        /*width: calc(100% - 30px);*/

        .col {
          /*overflow-x: hidden;*/
          white-space: nowrap;
          text-overflow: ellipsis;
          box-sizing: border-box;
          display: table-cell;
          /*padding-top:8px;*/
          margin-right: 18px;
          /*padding: 8px 20px 0 0;*/

          &:last-child {
            margin-right: 0;
            padding-right: 15px;
          }
        }
      }

      .icon-move_box {
        position: absolute;
        left: -5px;
        width: 15px;
        height: 15px;
        top: 50%;
        margin-top: -8px;
      }

      .icon-move_box i {
        background: url("../../assets/images/move-icon-default.png") no-repeat
          center center;
        background-size: 100% 100%;
        width: 100%;
        height: 100%;
        /*border-right: 1px solid #fce7e7;*/
        display: block;
        /*width: 30px;*/
        /*height: 50px;*/
        /*line-height: 50px;*/
        color: #ec1c1c;
        text-align: center;
        font-size: 20px;
      }

      .icon-move_box i:hover {
        cursor: move;
        background: url("../../assets/images/move-icon.png") no-repeat center
          center;
        background-size: 100% 100%;
      }

      li {
        margin: 10px 0 10px 10px;
        border-radius: 2px;
      }

      .col {
        display: inline-block !important;
      }
    }

    .radio {
      padding: 5px 14px;
      border-bottom: 1px dashed #dbdbdb;

      small {
        color: #999999;
        margin-left: 14px;
      }
    }
  }

  .cont-form {
    width: 100%;

    .amend-tab__form {
      display: inline-block;
      position: absolute;
      width: 30px;
      right: 0;
    }

    .el-radio.is-bordered.is-checked {
      border-color: #ec1c1c;
      color: #333333;
    }

    .checkbox {
      width: 100%;
      height: 80px;
      padding-top: 22px;

      &.end-time {
        box-sizing: border-box;
        width: 100%;
        height: 80px;
        padding: 10px;
        border: 1px solid #dcdfe6;
      }

      p.small {
        padding-left: 0px;
      }

      p.title {
        font-size: 12px;
        color: #666666 !important;
        font-weight: 600;

        i {
          box-sizing: border-box;
          color: #ec1c1c;
        }
      }

      p {
        color: #333333 !important;
        display: inline-block;
      }
    }

    div.h4,
    h4 {
      padding-top: 10px;
      line-height: 36px;
      font-size: 16px;
      margin: 0;
      font-weight: bold;
      border-bottom: 1px solid #f2f2f2;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      /*padding-left:15px;*/

      > i {
        display: inline-block;
        width: 5px;
        height: 15px;
        background: rgba(38, 38, 38, 1);
        opacity: 1;
        border-radius: 100px;
        margin-right: 10px;
        vertical-align: middle;
      }

      .more-set {
        line-height: 32px;
        font-size: 14px;
        margin-right: 20px;
        cursor: pointer;

        i {
          font-size: 26px;
          vertical-align: middle;
        }

        &.down i {
          animation: keyRotateToToDown 0.3s;
          transform: rotate(180deg);
        }

        &.up i {
          animation: keyRotateToUp 0.3s;
          transform: rotate(0deg);
        }

        &.down-noani i {
          transform: rotate(180deg);
        }

        &.up-noani i {
          transform: rotate(0deg);
        }
      }
    }

    /*20200526重置样式*/

    /deep/ .el-input__inner {
      height: 35px;
      line-height: 35px;
      padding-left: 10px;
    }

    .f-top {
      background-color: #ffffff;
      margin-bottom: 20px;

      .el-form-item {
        margin-bottom: 0;
      }

      .el-row {
        padding: 20px 30px 20px 20px;
      }
    }

    .f-center {
      .f-top();

      div.h4 {
        justify-content: space-between;
        flex-wrap: nowrap;

        .el-checkbox__label {
          /*color: #000000;*/
          font-weight: normal;

          b {
            font-weight: normal;
            /*color: #000000;*/
          }
        }

        small {
          color: rgba(0, 0, 0, 0.45);
          margin-left: 5px;
        }

        .more-set {
          color: rgba(0, 0, 0, 0.45);
        }
      }

      .wp {
        flex: auto;
        margin-left: 40px;
      }

      .radio {
        padding: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: nowrap;
      }

      li .el-row {
        padding: 0;
      }
    }

    .f-center2 {
      .f-top();
    }

    .f-bottom {
      .f-top();
      margin-bottom: 100px;
    }

    .bow {
      padding: 20px;
    }

    .sign-item {
      display: flex !important;
      justify-content: space-between;
      align-items: center;
      position: relative;

      > div {
        /*flex: none;*/

        &:last-child {
          flex: auto;
          text-align: right;
        }
      }
    }

    .c-btn {
      min-width: 82px;
      line-height: 25px;
      padding: 0;
      font-size: 12px;
      text-align: center;
      border: 1px solid rgba(236, 28, 28, 1);
      border-radius: 2px;
      color: #ec1c1c;

      &:hover {
        background-color: gba(236, 28, 28, 1);
        color: #ffffff;
      }
    }

    .y-btn {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: bold;
      border: none;
      padding: 0;
      color: #ec1c1c;
      background: transparent !important;

      &:hover {
        opacity: 0.5;
      }
    }
  }
}

.main-content {
  position: relative;
  display: table-cell;
  box-sizing: border-box;
  vertical-align: top;
  padding: 0;
  /*background: #ffffff;*/
  overflow: hidden;

  .accessory-box {
    position: absolute;
    bottom: -106px;
    width: 100%;
    pointer-events: none;

    .accessory-list {
      pointer-events: initial;
      position: relative;
      width: 100%;
      /*display: flex;*/
      /*justify-content: flex-start;*/
      /*flex-wrap: wrap;*/
      /*align-items: center;*/
      box-sizing: border-box;
      // border-top: 1px solid rgba(0,0,0,0.16);
      padding: 56px 15px 20px 15px;
      background: #ffffff;
      box-shadow: 0px -2px 12px rgba(0, 0, 0, 0.16);

      li {
        /*flex: none;*/
        /*display: table-cell;*/
        /*width: 100%;*/
      }

      .accessory-group {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        align-items: center;

        p.list-item {
          display: inline-block;
          position: relative;
          margin: 4px 25px 4px 0;
          padding: 6px 19px 6px 5px;
          // border: 4px;
          font-size: 12px;
          color: #000000;
          background: rgba(248, 248, 248, 1);

          > span {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            max-width: 200px;
          }
        }

        i.del {
          color: #a1a1a1;
          position: absolute;
          right: -6px;
          top: -6px;
          font-size: 16px;
          cursor: pointer;
        }
      }

      .upload-accessory {
        /*width: 75px;*/
        overflow: hidden;
        position: relative;
        cursor: pointer;
        display: inline-block;

        &:hover {
          opacity: 0.5;
        }

        a {
          // font-size:16px;
          display: inline-block;
          width: 120px;
          line-height: 35px;
          color: #ec1c1c;
          font-weight: bold;
        }

        &:hover a {
          font-weight: 800;
        }

        /*input {*/
        /*  position: absolute;*/
        /*  width: 300px;*/
        /*  height: 300px;*/
        /*  top: -18px;*/
        /*  left: -73px;*/
        /*  cursor: pointer;*/
        /*  opacity: 0;*/
        /*}*/

        .up-icon {
          width: 16px;
          height: 16px;
          vertical-align: middle;
          margin-right: 5px;
        }

        .div-upload {
          /*cursor: pointer;*/
          border: 1px dashed #ec1c1c;
          width: 80px;
          height: 30px;
          line-height: 30px;
          display: inline-block;
          text-align: center;
          color: #ec1c1c;
          font-size: 18px;
          font-weight: normal;
          position: relative;
          z-index: 2;
        }

        .input-upload {
          cursor: pointer;
          position: absolute;
          z-index: 3;
          left: 0;
          top: 0;
          bottom: 0;
          right: 0;
          opacity: 0;
        }
      }
    }

    div.btn {
      pointer-events: initial;
      display: inline-block;
      // width: 120px;
      // height: 35px;
      // line-height: 35px;
      padding: 0 10px;
      font-size: 14px;
      // color: #ffffff;
      // background: #a2a5ac;
      // border-radius: 3px 3px 0 0;
      cursor: pointer;
      width: 150px;
      height: 45px;
      line-height: 45px;
      background: rgba(255, 255, 255, 0.65);
      box-shadow: 0px -2px 12px rgba(0, 0, 0, 0.16);
      border-radius: 6px 6px 0px 0px;
      color: #ec1c1c;
      font-size: 15px;
      font-weight: bold;

      .arrow {
        margin-left: 15px;
        font-size: 12px;
        font-weight: bold;
        vertical-align: middle;
        display: inline-block;
        margin-top: -2px;
      }
    }
  }
}

@mg: 0.2rem; // 左右side给中间合同流的间距
.aside-right {
  box-sizing: border-box;
  // padding: 20px 20px 0 20px;
  background-color: #fafafa;
  overflow: hidden;
  position: relative;
  box-shadow: -0.02rem 0px 0.16rem rgba(0, 0, 0, 0.12);
  /*z-index:3;*/
  margin-left: @mg;

  .right-bottom {
    background-color: #ffffff;
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    /*z-index: 2000;*/
    padding: 0.4rem 0.27rem;
    box-shadow: 0px -0.03rem 0.12rem rgba(0, 0, 0, 0.16);

    button {
      width: 100%;
      height: 0.4rem;
      line-height: 0.4rem;
      padding-top: 0;
      padding-bottom: 0;
    }
  }

  .list-signers {
    position: absolute;
    bottom: 1.2rem;
    top: 1.8rem;
    overflow-x: hidden;
    overflow-y: auto;
    // position: absolute;
    // width: 160px;
    width: 100%;
    // right: 0;
    padding-bottom: 1.2rem;
    background-color: #ffffff;
    padding-top: 0.25rem;
    box-shadow: 0.03rem 0px 0.12rem rgba(0, 0, 0, 0.16);

    .btn-right {
      // width: 108px;
    }

    .del-signer {
      margin-right: 0.05rem;
      font-size: 0.18rem;
      cursor: pointer;
      color: #a1a1a1;
    }

    .del-signer:hover {
      color: #ec1c1c;
    }

    .btn-left {
      width: 0.32rem;
      height: 0.32rem;
      line-height: 0.32rem;
      padding: 0;
      margin-right: -1px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    .qy-wrap {
      box-sizing: border-box;
      padding-left: 0.2rem;
      padding-right: 0.25rem;
    }

    .row-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .dragbox {
        flex: auto;

        button {
          width: 100%;
        }
      }

      button {
        flex: auto;
      }
    }

    .btn-group {
      box-sizing: border-box;
      margin-top: 0.18rem;
      // width: 140px;
      width: 100%;
      padding-top: 28px;
      // padding: 20px 0;
      position: relative;
      display: inline-block;

      .user-show {
        position: absolute;
        top: 0;
        line-height: 1;
        color: rgba(0, 0, 0, 0.45);
        font-size: 14px;

        span {
          display: inline-block;
          // width: 120px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 2rem;
        }
      }
    }
  }

  .btn {
    width: 100%;
    margin: 0 0 0.14rem 0;
  }

  .qs-wrap {
    padding-top: 0.25rem;
    background: rgba(255, 255, 255, 1);
    /*box-shadow:0px 3px 12px rgba(0,0,0,0.06);*/
    position: relative;
    /*z-index: 5;*/

    /deep/ .el-checkbox__label {
      padding-left: 0.1rem;
      line-height: 0.19rem;
      font-size: 14px;
    }

    /deep/ .el-checkbox {
      margin-right: 0.3rem;
    }
  }

  .qs-box {
    // padding:30px 25px 34px 25px;
    padding: 0.2rem 0 0.24rem 0;

    > img {
      height: 0.48rem;
      cursor: pointer;
      /*width: max-content;*/
      margin-left: 0.25rem;
      /*min-width:280px;*/
      width: 2.35rem;

      &:hover {
        cursor: pointer;
        /*cursor: url(/images/icon/cursor.ico),pointer;*/
        opacity: 0.7;
      }
    }
  }

  .t2 {
    color: #000000;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
  }

  .t3 {
    color: rgba(0, 0, 0, 0.85);
    font-weight: normal;
    padding-left: 0.3rem;
    border-bottom: 1px solid #f2f2f2;
    padding-bottom: 0.17rem;
    font-size: 12px;
  }

  .m-title {
    .t2();
    border-bottom: 1px solid #f2f2f2;
    padding-bottom: 0.17rem;
  }

  .icon-1 {
    vertical-align: middle;
    display: inline-block;
    text-align: center;
    width: 0.22rem;
    height: 0.22rem;
    line-height: 0.22rem;
    margin-right: 0.1rem;
    margin-left: 0.05rem;
    margin-top: -0.04rem;
    background: rgba(236, 28, 28, 1);
    border-radius: 50%;
    font-size: 0.16rem;
    color: #ffffff;
    font-weight: normal;
    /*background: url(../../assets/images/icon-n1.png) no-repeat center center;*/
    /*background-size: 100% 100%;*/
  }

  .icon-2 {
    .icon-1();
    /*background: url(../../assets/images/icon-n2.png) no-repeat center center;*/
    /*background-size: 100% 100%;*/
  }

  button {
    height: 0.4rem;
    line-height: 0.4rem;
    font-size: 0.14rem;
  }
  .mybtn {
    position: relative;
    i {
      font-size: 0.18rem;
      vertical-align: middle;
      color: #ffffff;
      margin-right: 10px;
      margin-top: -0.02rem;
    }
  }
}

.aside-left {
  padding-top: 0.2rem;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #ffffff;
  box-shadow: 0.02rem 0.03rem 0.16rem rgba(0, 0, 0, 0.12);
  position: relative;
  z-index: 1;
  margin-right: @mg;

  .cred {
    color: #ec1c1c;
  }

  .list.active img {
    border-color: #ec1c1c;
  }

  .list.active span {
    background-color: #ec1c1c;
  }

  .list {
    position: relative;
    margin: 0 0.3rem 0.2rem 0.3rem;
    cursor: pointer;

    span {
      position: absolute;
      bottom: 0.1rem;
      right: 0;
      display: block;
      /*width: 20px;*/
      /*height: 20px;*/
      width: 0.4rem;
      height: 0.3rem;
      line-height: 0.3rem;
      border-radius: 0.06rem 0px 0px 0px;
      color: #fff;
      background-color: #e3e3e3;
      text-align: center;
    }

    img {
      width: 100%;
      /*max-height: 230px !important;*/
      max-height: 3rem !important;
      box-sizing: border-box;
      margin-bottom: 0.1rem;
      border: 0.02rem solid #e3e3e3;
    }
  }

  .page-total {
    color: #646464;
    font-size: 85%;
    padding: 0 0.3rem 0.2rem 0.3rem;
  }

  .page-con {
    overflow-y: auto;
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0.9rem;
    top: 0.6rem;
  }
}

.tel-box {
  height: 410px;
  overflow: auto;
}

.dialog-footer {
  overflow: hidden;
  padding: 0 0 10px 0;
  margin-bottom: -9px;
}

.to-create {
  margin: -20px;

  .tel-search {
    margin-top: 10px;
    margin-bottom: 10px;
  }
}

/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #ec1c1c;
}

// 签章位置 编辑按钮样式
.edit-Btn-wrap {
  border: none !important;
  background-color: transparent !important;
  height: auto !important;
  width: auto !important;
  margin-right: 10px !important;
  line-height: initial !important;
  margin-top: 5px;
}

.edit-icon {
  cursor: pointer;
  display: inline-block;
  width: 20px;
  height: 20px;
  background: url(../../assets/images/edit-icon.png) no-repeat center center;
  background-size: 100%;

  &:hover {
    background: url(../../assets/images/edit-active-icon.png) no-repeat center
      center;
    background-size: 100%;
  }
}

.edit-active-icon {
  .edit-icon();
  background: url(../../assets/images/edit-active-icon.png) no-repeat center
    center;
  background-size: 100%;
}

// 跳转页面
.go-Page {
  // height:60px;
  // line-height:60px;
  padding: 0.3rem 0;
  width: 100%;
  text-align: center;
  color: rgba(0, 0, 0, 0.85);
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 5;
  background-color: #ffffff;

  > div {
    display: inline-block;

    > div {
      display: flex;
      text-align: center;
      justify-content: space-between;
      align-items: center;
      height: 32px;
      line-height: 28px;
    }
  }

  .bd {
    height: 100%;
    box-sizing: border-box;
    border: 1px solid rgba(183, 183, 183, 1);
    border-style: solid none solid solid;
    display: flex;
    text-align: center;
    justify-content: space-between;
    align-items: center;
    padding-right: 0.05rem;
    border-radius: 0.04rem 0 0 0.04rem;
  }

  a {
    text-decoration: none;
    cursor: pointer;
    box-sizing: border-box;
    width: 0.6rem;
    border-radius: 0px 0.04rem 0.04rem 0.04rem;
    display: block;
    background: #999999;
    border: 1px solid #999999;
    color: rgba(255, 255, 255, 1);
    font-family: PingFang SC;
  }

  /deep/ .el-input {
    /*width: 75px;*/
    width: 1.2rem;
    height: 100%;
  }

  /deep/ .el-input__inner {
    font-size: 0.14rem;
    border: none;
    padding: 0 0 0 0.05rem;
    height: 100%;
    line-height: inherit;
  }
}

// select样式
.el-select-dropdown__item.selected {
  color: #ec1c1c;
  font-weight: normal;
}

.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: rgba(255, 242, 230, 1);
}

// 动画
.an-gif {
  position: absolute;
  right: -0.08rem;
  bottom: -0.08rem;
}
@keyframes mymove {
  0% {
    transform: scale(1);
  }
  80% {
    transform: scale(1.04);
  }
  100% {
    transform: scale(1.2);
  }
}
.mygif {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 0.3rem;
  height: auto;
  transition: all ease-in 0.2s;
  z-index: 5;
  animation: mymove 1s infinite;
}
@keyframes ripple {
  0% {
    left: 0;
    top: 0;
    opacity: 0.75;
    width: 0;
    height: 0;
  }
  100% {
    left: -0.23rem;
    top: -0.23rem;
    opacity: 0;
    width: 0.6rem;
    height: 0.6rem;
  }
}
.dot {
  position: absolute;
  left: -0.32rem;
  top: -0.25rem;
  z-index: 2;
}
.dot:before {
  content: " ";
  position: absolute;
  z-index: 1;
  width: 0;
  height: 0;
  background-color: #ffffff;
  border-radius: 50%;
  box-shadow: 0 0 0.1rem rgba(225, 225, 225, 0.3) inset;
  animation: ripple 1s infinite 0.1s;
}
.dot:after {
  content: " ";
  position: absolute;
  z-index: 1;
  width: 0;
  height: 0;
  background-color: #ffffff;
  border-radius: 50%;
  box-shadow: 0 0 0.1rem rgba(225, 225, 225, 0.3) inset;
  animation: ripple 1s infinite;
}

.jumpFirst {
  top: -80px;
  bottom: initial;
  pointer-events: initial;
}
.jumpLast {
  top: -25px;
  bottom: initial;
  pointer-events: initial;
}

/deep/.cont-info-form .cont-form .datep .el-input__inner {
  padding-left: 30px;
}
</style>
<style lang="less">
.ghost {
  /*opacity: 0.5;*/
  background: #fff2e6;
}

.tel-box {
  .el-table__row.current-row {
    color: #ec1c1c;
  }
}

.no-padding {
  .el-input__inner {
    padding: 0 0 0 10px !important;
  }
}

body {
  .danger-btn {
    height: 40px;
    line-height: 40px;
    padding-top: 0;
    padding-bottom: 0;
    width: 100%;
    background-color: #ff0000;
    font-size: 14px;
  }

  // 自定义图标cursor
  .csCursor {
    cursor: pointer;
    /*cursor: url(/images/icon/cursor.ico),pointer;*/
  }

  .normal-btn {
    border: none;
    background-color: rgba(204, 204, 204, 1);
    height: 40px;
    padding-top: 0;
    padding-bottom: 0;
    font-size: 14px;
    font-weight: bold;
    color: #ffffff !important;
    position: relative;
    .csCursor();
    &:focus {
      background-color: rgba(204, 204, 204, 1);
    }
    &:hover {
      background-color: #ec1c1c;
      .rt {
        background: url(../../assets/images/title-icon-active.png) no-repeat
          center center;
        background-size: 100% 100%;
      }
    }

    .rt {
      font-weight: normal;
      position: absolute;
      display: block;
      background: url(../../assets/images/title-icon.png) no-repeat center
        center;
      background-size: 100% 100%;
      height: 30px;
      line-height: 26px;
      width: 70px;
      top: -8px;
      right: -4px;
      z-index: 2;
      color: rgba(255, 255, 255, 1);
      font-size: 12px;
      text-align: center;
    }
  }
}
.g-icon-close {
  position: absolute;
  width: 22px;
  height: 22px;
  top: -9px;
  right: -8px;
  display: block;
  .icon {
    width: 100%;
    height: 100%;
    display: block;
  }
  .icon1 {
    display: block;
  }
  .icon2 {
    display: none;
  }
  &:hover {
    .icon1 {
      display: none;
    }
    .icon2 {
      display: block;
    }
  }
}
.g-save-disable {
  &,
  &:hover {
    box-sizing: border-box;
    background: #f5f7fa !important;
    border: 1px solid #e4e7ed !important;
    color: rgba(0, 0, 0, 0.25) !important;
    cursor: not-allowed;
  }
  &:hover {
    span {
      color: rgba(0, 0, 0, 0.25) !important;
    }
  }
}
// .el-tooltip__popper.is-light {
//     background: #FFF;
//     /* border: 1px solid #303133; */
//     box-shadow: 2px 2px 12px rgba(0,0,0,0.1);
// }
.enclosure_files {
  width: 100%;
  padding-left: 20px;
  display: flex;
  align-items: center;
  height: auto;
  flex-wrap: wrap;


  .enclosureFiles-item {
    width: 170px;
    height: 30px;
    border-radius: 4px;
    background-color: #efefef;
    margin: 15px;
    position: relative;

    .desc {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding: 0 10px;
      text-align: center;
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #290202;
      width: 170px;
      height: 30px;
      line-height: 30px;
      box-sizing: border-box;
    }

    .del-btn {
      font-size: 20px;
      position: absolute;
      right: -11px;
      top: -11px;
      width: 22px;
      height: 22px;
      color: #888888;
      cursor: pointer;
    }
  }
}
.prtf-sty{
  margin-left: 20px;
  font-size: 13px;
  cursor: pointer;
  &:hover{
    color: #ec1c1c;
  }
}
</style>



// WEBPACK FOOTER //
// pages/applySign/toCreate.vue